(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireab88"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireab88"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aSMts", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7ec48c7d8ea17758$export$fdf2a89c76341bbf; });

var $jG3FW = parcelRequire("jG3FW");

var $hpdLM = parcelRequire("hpdLM");

var $8V4Ru = parcelRequire("8V4Ru");

var $fXGmO = parcelRequire("fXGmO");
function $7ec48c7d8ea17758$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jG3FW._array_with_holes)(arr) || (0, $hpdLM._iterable_to_array_limit)(arr, i) || (0, $fXGmO._unsupported_iterable_to_array)(arr, i) || (0, $8V4Ru._non_iterable_rest)();
}

});
parcelRegister("jG3FW", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $e534ca721748b0c3$export$e6256bf45c68d561; });
function $e534ca721748b0c3$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("hpdLM", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $cabf73d5763ce5a2$export$2fd15edff6687200; });
function $cabf73d5763ce5a2$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("8V4Ru", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $67e76b0988166e1e$export$60dbc22abd7da546; });
function $67e76b0988166e1e$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("fXGmO", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $b9ed3ae1694dd153$export$a5be06335b3a083c; });

var $5B3Hz = parcelRequire("5B3Hz");
function $b9ed3ae1694dd153$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $5B3Hz._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $5B3Hz._array_like_to_array)(o, minLen);
}

});
parcelRegister("5B3Hz", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $4133478a60806ab4$export$79e617b1955a2616; });
function $4133478a60806ab4$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("esXub", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iPFGn"));

});
parcelRegister("iPFGn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $db5d52b52065cc9b$export$ffb0004e005737fa; }, function (v) { return $db5d52b52065cc9b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $db5d52b52065cc9b$export$34b9dba7ce09269b; }, function (v) { return $db5d52b52065cc9b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $db5d52b52065cc9b$export$25062201e9e25d76; }, function (v) { return $db5d52b52065cc9b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db5d52b52065cc9b$export$ffb0004e005737fa;
var $db5d52b52065cc9b$export$34b9dba7ce09269b;
var $db5d52b52065cc9b$export$25062201e9e25d76;
"use strict";

var $3aC2T = parcelRequire("3aC2T");
var $db5d52b52065cc9b$var$k = Symbol["for"]("react.element"), $db5d52b52065cc9b$var$l = Symbol["for"]("react.fragment"), $db5d52b52065cc9b$var$m = Object.prototype.hasOwnProperty, $db5d52b52065cc9b$var$n = $3aC2T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $db5d52b52065cc9b$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $db5d52b52065cc9b$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$db5d52b52065cc9b$var$m.call(a, b) && !$db5d52b52065cc9b$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $db5d52b52065cc9b$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $db5d52b52065cc9b$var$n.current
    };
}
$db5d52b52065cc9b$export$ffb0004e005737fa = $db5d52b52065cc9b$var$l;
$db5d52b52065cc9b$export$34b9dba7ce09269b = $db5d52b52065cc9b$var$q;
$db5d52b52065cc9b$export$25062201e9e25d76 = $db5d52b52065cc9b$var$q;

});
parcelRegister("3aC2T", function(module, exports) {
"use strict";

module.exports = (parcelRequire("d91kw"));

});
parcelRegister("d91kw", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $991d25b6c67751d2$export$dca3b0875bd9a954; }, function (v) { return $991d25b6c67751d2$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $991d25b6c67751d2$export$16fa2f45be04daa8; }, function (v) { return $991d25b6c67751d2$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $991d25b6c67751d2$export$ffb0004e005737fa; }, function (v) { return $991d25b6c67751d2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $991d25b6c67751d2$export$e2c29f18771995cb; }, function (v) { return $991d25b6c67751d2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $991d25b6c67751d2$export$221d75b3f55bb0bd; }, function (v) { return $991d25b6c67751d2$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $991d25b6c67751d2$export$5f8d39834fd61797; }, function (v) { return $991d25b6c67751d2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $991d25b6c67751d2$export$74bf444e3cd11ea5; }, function (v) { return $991d25b6c67751d2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $991d25b6c67751d2$export$ae55be85d98224ed; }, function (v) { return $991d25b6c67751d2$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $991d25b6c67751d2$export$e530037191fcd5d7; }, function (v) { return $991d25b6c67751d2$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $991d25b6c67751d2$export$fd42f52fd3ae1109; }, function (v) { return $991d25b6c67751d2$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $991d25b6c67751d2$export$c8a8987d4410bf2d; }, function (v) { return $991d25b6c67751d2$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $991d25b6c67751d2$export$d38cd72104c1f0e9; }, function (v) { return $991d25b6c67751d2$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $991d25b6c67751d2$export$7d1e3a5e95ceca43; }, function (v) { return $991d25b6c67751d2$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $991d25b6c67751d2$export$257a8862b851cb5b; }, function (v) { return $991d25b6c67751d2$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $991d25b6c67751d2$export$a8257692ac88316c; }, function (v) { return $991d25b6c67751d2$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $991d25b6c67751d2$export$488013bae63b21da; }, function (v) { return $991d25b6c67751d2$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $991d25b6c67751d2$export$7c73462e0d25e514; }, function (v) { return $991d25b6c67751d2$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $991d25b6c67751d2$export$7568632d0d33d16d; }, function (v) { return $991d25b6c67751d2$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $991d25b6c67751d2$export$88948ce120ea2619; }, function (v) { return $991d25b6c67751d2$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $991d25b6c67751d2$export$35808ee640e87ca7; }, function (v) { return $991d25b6c67751d2$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $991d25b6c67751d2$export$fae74005e78b1a27; }, function (v) { return $991d25b6c67751d2$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $991d25b6c67751d2$export$dc8fbce3eb94dc1e; }, function (v) { return $991d25b6c67751d2$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $991d25b6c67751d2$export$6a7bc4e911dc01cf; }, function (v) { return $991d25b6c67751d2$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $991d25b6c67751d2$export$6d9c69b0de29b591; }, function (v) { return $991d25b6c67751d2$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $991d25b6c67751d2$export$f680877a34711e37; }, function (v) { return $991d25b6c67751d2$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $991d25b6c67751d2$export$d5a552a76deda3c2; }, function (v) { return $991d25b6c67751d2$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $991d25b6c67751d2$export$aaabe4eda9ed9969; }, function (v) { return $991d25b6c67751d2$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $991d25b6c67751d2$export$e5c5a5f917a5871c; }, function (v) { return $991d25b6c67751d2$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $991d25b6c67751d2$export$1538c33de8887b59; }, function (v) { return $991d25b6c67751d2$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $991d25b6c67751d2$export$13e3392192263954; }, function (v) { return $991d25b6c67751d2$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $991d25b6c67751d2$export$b8f5890fc79d6aca; }, function (v) { return $991d25b6c67751d2$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $991d25b6c67751d2$export$60241385465d0a34; }, function (v) { return $991d25b6c67751d2$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $991d25b6c67751d2$export$306c0aa65ff9ec16; }, function (v) { return $991d25b6c67751d2$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $991d25b6c67751d2$export$7b286972b8d8ccbf; }, function (v) { return $991d25b6c67751d2$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $991d25b6c67751d2$export$83d89fbfd8236492; }, function (v) { return $991d25b6c67751d2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $qb7pP = parcelRequire("qb7pP");
var $991d25b6c67751d2$export$dca3b0875bd9a954;
var $991d25b6c67751d2$export$16fa2f45be04daa8;
var $991d25b6c67751d2$export$ffb0004e005737fa;
var $991d25b6c67751d2$export$e2c29f18771995cb;
var $991d25b6c67751d2$export$221d75b3f55bb0bd;
var $991d25b6c67751d2$export$5f8d39834fd61797;
var $991d25b6c67751d2$export$74bf444e3cd11ea5;
var $991d25b6c67751d2$export$ae55be85d98224ed;
var $991d25b6c67751d2$export$e530037191fcd5d7;
var $991d25b6c67751d2$export$fd42f52fd3ae1109;
var $991d25b6c67751d2$export$c8a8987d4410bf2d;
var $991d25b6c67751d2$export$d38cd72104c1f0e9;
var $991d25b6c67751d2$export$7d1e3a5e95ceca43;
var $991d25b6c67751d2$export$257a8862b851cb5b;
var $991d25b6c67751d2$export$a8257692ac88316c;
var $991d25b6c67751d2$export$488013bae63b21da;
var $991d25b6c67751d2$export$7c73462e0d25e514;
var $991d25b6c67751d2$export$7568632d0d33d16d;
var $991d25b6c67751d2$export$88948ce120ea2619;
var $991d25b6c67751d2$export$35808ee640e87ca7;
var $991d25b6c67751d2$export$fae74005e78b1a27;
var $991d25b6c67751d2$export$dc8fbce3eb94dc1e;
var $991d25b6c67751d2$export$6a7bc4e911dc01cf;
var $991d25b6c67751d2$export$6d9c69b0de29b591;
var $991d25b6c67751d2$export$f680877a34711e37;
var $991d25b6c67751d2$export$d5a552a76deda3c2;
var $991d25b6c67751d2$export$aaabe4eda9ed9969;
var $991d25b6c67751d2$export$e5c5a5f917a5871c;
var $991d25b6c67751d2$export$1538c33de8887b59;
var $991d25b6c67751d2$export$13e3392192263954;
var $991d25b6c67751d2$export$b8f5890fc79d6aca;
var $991d25b6c67751d2$export$60241385465d0a34;
var $991d25b6c67751d2$export$306c0aa65ff9ec16;
var $991d25b6c67751d2$export$7b286972b8d8ccbf;
var $991d25b6c67751d2$export$83d89fbfd8236492;
"use strict";
var $991d25b6c67751d2$var$l = Symbol["for"]("react.element"), $991d25b6c67751d2$var$n = Symbol["for"]("react.portal"), $991d25b6c67751d2$var$p = Symbol["for"]("react.fragment"), $991d25b6c67751d2$var$q = Symbol["for"]("react.strict_mode"), $991d25b6c67751d2$var$r = Symbol["for"]("react.profiler"), $991d25b6c67751d2$var$t = Symbol["for"]("react.provider"), $991d25b6c67751d2$var$u = Symbol["for"]("react.context"), $991d25b6c67751d2$var$v = Symbol["for"]("react.forward_ref"), $991d25b6c67751d2$var$w = Symbol["for"]("react.suspense"), $991d25b6c67751d2$var$x = Symbol["for"]("react.memo"), $991d25b6c67751d2$var$y = Symbol["for"]("react.lazy"), $991d25b6c67751d2$var$z = Symbol.iterator;
function $991d25b6c67751d2$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $991d25b6c67751d2$var$z && a[$991d25b6c67751d2$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $991d25b6c67751d2$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $991d25b6c67751d2$var$C = Object.assign, $991d25b6c67751d2$var$D = {};
function $991d25b6c67751d2$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $991d25b6c67751d2$var$D;
    this.updater = e || $991d25b6c67751d2$var$B;
}
$991d25b6c67751d2$var$E.prototype.isReactComponent = {};
$991d25b6c67751d2$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$991d25b6c67751d2$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $991d25b6c67751d2$var$F() {}
$991d25b6c67751d2$var$F.prototype = $991d25b6c67751d2$var$E.prototype;
function $991d25b6c67751d2$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $991d25b6c67751d2$var$D;
    this.updater = e || $991d25b6c67751d2$var$B;
}
var $991d25b6c67751d2$var$H = $991d25b6c67751d2$var$G.prototype = new $991d25b6c67751d2$var$F;
$991d25b6c67751d2$var$H.constructor = $991d25b6c67751d2$var$G;
$991d25b6c67751d2$var$C($991d25b6c67751d2$var$H, $991d25b6c67751d2$var$E.prototype);
$991d25b6c67751d2$var$H.isPureReactComponent = !0;
var $991d25b6c67751d2$var$I = Array.isArray, $991d25b6c67751d2$var$J = Object.prototype.hasOwnProperty, $991d25b6c67751d2$var$K = {
    current: null
}, $991d25b6c67751d2$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $991d25b6c67751d2$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$991d25b6c67751d2$var$J.call(b, d) && !$991d25b6c67751d2$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $991d25b6c67751d2$var$K.current
    };
}
function $991d25b6c67751d2$var$N(a, b) {
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $991d25b6c67751d2$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $991d25b6c67751d2$var$l;
}
function $991d25b6c67751d2$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $991d25b6c67751d2$var$P = /\/+/g;
function $991d25b6c67751d2$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $991d25b6c67751d2$var$escape("" + a.key) : b.toString(36);
}
function $991d25b6c67751d2$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $991d25b6c67751d2$var$l:
                case $991d25b6c67751d2$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $991d25b6c67751d2$var$Q(h, 0) : d, $991d25b6c67751d2$var$I(c) ? (e = "", null != a && (e = a.replace($991d25b6c67751d2$var$P, "$&/") + "/"), $991d25b6c67751d2$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($991d25b6c67751d2$var$O(c) && (c = $991d25b6c67751d2$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($991d25b6c67751d2$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($991d25b6c67751d2$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $991d25b6c67751d2$var$Q(k, g);
        h += $991d25b6c67751d2$var$R(k, b, e, f, c);
    }
    else if (f = $991d25b6c67751d2$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $991d25b6c67751d2$var$Q(k, g++), h += $991d25b6c67751d2$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $991d25b6c67751d2$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $991d25b6c67751d2$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $991d25b6c67751d2$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result["default"];
    throw a._result;
}
var $991d25b6c67751d2$var$U = {
    current: null
}, $991d25b6c67751d2$var$V = {
    transition: null
}, $991d25b6c67751d2$var$W = {
    ReactCurrentDispatcher: $991d25b6c67751d2$var$U,
    ReactCurrentBatchConfig: $991d25b6c67751d2$var$V,
    ReactCurrentOwner: $991d25b6c67751d2$var$K
};
$991d25b6c67751d2$export$dca3b0875bd9a954 = {
    map: $991d25b6c67751d2$var$S,
    forEach: function forEach(a, b, e) {
        $991d25b6c67751d2$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $991d25b6c67751d2$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $991d25b6c67751d2$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$991d25b6c67751d2$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$991d25b6c67751d2$export$16fa2f45be04daa8 = $991d25b6c67751d2$var$E;
$991d25b6c67751d2$export$ffb0004e005737fa = $991d25b6c67751d2$var$p;
$991d25b6c67751d2$export$e2c29f18771995cb = $991d25b6c67751d2$var$r;
$991d25b6c67751d2$export$221d75b3f55bb0bd = $991d25b6c67751d2$var$G;
$991d25b6c67751d2$export$5f8d39834fd61797 = $991d25b6c67751d2$var$q;
$991d25b6c67751d2$export$74bf444e3cd11ea5 = $991d25b6c67751d2$var$w;
$991d25b6c67751d2$export$ae55be85d98224ed = $991d25b6c67751d2$var$W;
$991d25b6c67751d2$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $991d25b6c67751d2$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $991d25b6c67751d2$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$991d25b6c67751d2$var$J.call(b, f) && !$991d25b6c67751d2$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $991d25b6c67751d2$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$991d25b6c67751d2$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $991d25b6c67751d2$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $991d25b6c67751d2$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$991d25b6c67751d2$export$c8a8987d4410bf2d = $991d25b6c67751d2$var$M;
$991d25b6c67751d2$export$d38cd72104c1f0e9 = function(a) {
    var b = $991d25b6c67751d2$var$M.bind(null, a);
    b.type = a;
    return b;
};
$991d25b6c67751d2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$991d25b6c67751d2$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $991d25b6c67751d2$var$v,
        render: a
    };
};
$991d25b6c67751d2$export$a8257692ac88316c = $991d25b6c67751d2$var$O;
$991d25b6c67751d2$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $991d25b6c67751d2$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $991d25b6c67751d2$var$T
    };
};
$991d25b6c67751d2$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $991d25b6c67751d2$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$991d25b6c67751d2$export$7568632d0d33d16d = function(a) {
    var b = $991d25b6c67751d2$var$V.transition;
    $991d25b6c67751d2$var$V.transition = {};
    try {
        a();
    } finally{
        $991d25b6c67751d2$var$V.transition = b;
    }
};
$991d25b6c67751d2$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$991d25b6c67751d2$export$35808ee640e87ca7 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useCallback(a, b);
};
$991d25b6c67751d2$export$fae74005e78b1a27 = function(a) {
    return $991d25b6c67751d2$var$U.current.useContext(a);
};
$991d25b6c67751d2$export$dc8fbce3eb94dc1e = function() {};
$991d25b6c67751d2$export$6a7bc4e911dc01cf = function(a) {
    return $991d25b6c67751d2$var$U.current.useDeferredValue(a);
};
$991d25b6c67751d2$export$6d9c69b0de29b591 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useEffect(a, b);
};
$991d25b6c67751d2$export$f680877a34711e37 = function() {
    return $991d25b6c67751d2$var$U.current.useId();
};
$991d25b6c67751d2$export$d5a552a76deda3c2 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useImperativeHandle(a, b, e);
};
$991d25b6c67751d2$export$aaabe4eda9ed9969 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useInsertionEffect(a, b);
};
$991d25b6c67751d2$export$e5c5a5f917a5871c = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useLayoutEffect(a, b);
};
$991d25b6c67751d2$export$1538c33de8887b59 = function(a, b) {
    return $991d25b6c67751d2$var$U.current.useMemo(a, b);
};
$991d25b6c67751d2$export$13e3392192263954 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useReducer(a, b, e);
};
$991d25b6c67751d2$export$b8f5890fc79d6aca = function(a) {
    return $991d25b6c67751d2$var$U.current.useRef(a);
};
$991d25b6c67751d2$export$60241385465d0a34 = function(a) {
    return $991d25b6c67751d2$var$U.current.useState(a);
};
$991d25b6c67751d2$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $991d25b6c67751d2$var$U.current.useSyncExternalStore(a, b, e);
};
$991d25b6c67751d2$export$7b286972b8d8ccbf = function() {
    return $991d25b6c67751d2$var$U.current.useTransition();
};
$991d25b6c67751d2$export$83d89fbfd8236492 = "18.2.0";

});
parcelRegister("qb7pP", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $04eb0dbf26262756$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $04eb0dbf26262756$export$5f0017c582d45a2d; });
function $04eb0dbf26262756$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("diKvV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9af1097fda9f2b31$export$ae55be85d98224ed; }, function (v) { return $9af1097fda9f2b31$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9af1097fda9f2b31$export$d39a5bbd09211389; }, function (v) { return $9af1097fda9f2b31$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9af1097fda9f2b31$export$882461b6382ed46c; }, function (v) { return $9af1097fda9f2b31$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9af1097fda9f2b31$export$466bfc07425424d5; }, function (v) { return $9af1097fda9f2b31$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9af1097fda9f2b31$export$cd75ccfd720a3cd4; }, function (v) { return $9af1097fda9f2b31$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9af1097fda9f2b31$export$fa8d919ba61d84db; }, function (v) { return $9af1097fda9f2b31$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9af1097fda9f2b31$export$757ceba2d55c277e; }, function (v) { return $9af1097fda9f2b31$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9af1097fda9f2b31$export$b3890eb0ae9dca99; }, function (v) { return $9af1097fda9f2b31$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9af1097fda9f2b31$export$502457920280e6be; }, function (v) { return $9af1097fda9f2b31$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9af1097fda9f2b31$export$c78a37762a8d58e1; }, function (v) { return $9af1097fda9f2b31$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9af1097fda9f2b31$export$dc54d992c10e8a18; }, function (v) { return $9af1097fda9f2b31$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9af1097fda9f2b31$export$83d89fbfd8236492; }, function (v) { return $9af1097fda9f2b31$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $qb7pP = parcelRequire("qb7pP");
var $9af1097fda9f2b31$export$ae55be85d98224ed;
var $9af1097fda9f2b31$export$d39a5bbd09211389;
var $9af1097fda9f2b31$export$882461b6382ed46c;
var $9af1097fda9f2b31$export$466bfc07425424d5;
var $9af1097fda9f2b31$export$cd75ccfd720a3cd4;
var $9af1097fda9f2b31$export$fa8d919ba61d84db;
var $9af1097fda9f2b31$export$757ceba2d55c277e;
var $9af1097fda9f2b31$export$b3890eb0ae9dca99;
var $9af1097fda9f2b31$export$502457920280e6be;
var $9af1097fda9f2b31$export$c78a37762a8d58e1;
var $9af1097fda9f2b31$export$dc54d992c10e8a18;
var $9af1097fda9f2b31$export$83d89fbfd8236492;
"use strict";

var $3aC2T = parcelRequire("3aC2T");

var $uOv5F = parcelRequire("uOv5F");
function $9af1097fda9f2b31$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9af1097fda9f2b31$var$da = new Set, $9af1097fda9f2b31$var$ea = {};
function $9af1097fda9f2b31$var$fa(a, b) {
    $9af1097fda9f2b31$var$ha(a, b);
    $9af1097fda9f2b31$var$ha(a + "Capture", b);
}
function $9af1097fda9f2b31$var$ha(a, b) {
    $9af1097fda9f2b31$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9af1097fda9f2b31$var$da.add(b[a]);
}
var $9af1097fda9f2b31$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9af1097fda9f2b31$var$ja = Object.prototype.hasOwnProperty, $9af1097fda9f2b31$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9af1097fda9f2b31$var$la = {}, $9af1097fda9f2b31$var$ma = {};
function $9af1097fda9f2b31$var$oa(a) {
    if ($9af1097fda9f2b31$var$ja.call($9af1097fda9f2b31$var$ma, a)) return !0;
    if ($9af1097fda9f2b31$var$ja.call($9af1097fda9f2b31$var$la, a)) return !1;
    if ($9af1097fda9f2b31$var$ka.test(a)) return $9af1097fda9f2b31$var$ma[a] = !0;
    $9af1097fda9f2b31$var$la[a] = !0;
    return !1;
}
function $9af1097fda9f2b31$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $qb7pP._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9af1097fda9f2b31$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9af1097fda9f2b31$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9af1097fda9f2b31$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9af1097fda9f2b31$var$ra = /[\-:]([a-z])/g;
function $9af1097fda9f2b31$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9af1097fda9f2b31$var$ra, $9af1097fda9f2b31$var$sa);
    $9af1097fda9f2b31$var$z[b] = new $9af1097fda9f2b31$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9af1097fda9f2b31$var$z.xlinkHref = new $9af1097fda9f2b31$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9af1097fda9f2b31$var$z[a] = new $9af1097fda9f2b31$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9af1097fda9f2b31$var$ta(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$z.hasOwnProperty(b) ? $9af1097fda9f2b31$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9af1097fda9f2b31$var$qa(b, c, e, d) && (c = null), d || null === e ? $9af1097fda9f2b31$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9af1097fda9f2b31$var$ua = $3aC2T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9af1097fda9f2b31$var$va = Symbol["for"]("react.element"), $9af1097fda9f2b31$var$wa = Symbol["for"]("react.portal"), $9af1097fda9f2b31$var$ya = Symbol["for"]("react.fragment"), $9af1097fda9f2b31$var$za = Symbol["for"]("react.strict_mode"), $9af1097fda9f2b31$var$Aa = Symbol["for"]("react.profiler"), $9af1097fda9f2b31$var$Ba = Symbol["for"]("react.provider"), $9af1097fda9f2b31$var$Ca = Symbol["for"]("react.context"), $9af1097fda9f2b31$var$Da = Symbol["for"]("react.forward_ref"), $9af1097fda9f2b31$var$Ea = Symbol["for"]("react.suspense"), $9af1097fda9f2b31$var$Fa = Symbol["for"]("react.suspense_list"), $9af1097fda9f2b31$var$Ga = Symbol["for"]("react.memo"), $9af1097fda9f2b31$var$Ha = Symbol["for"]("react.lazy");
Symbol["for"]("react.scope");
Symbol["for"]("react.debug_trace_mode");
var $9af1097fda9f2b31$var$Ia = Symbol["for"]("react.offscreen");
Symbol["for"]("react.legacy_hidden");
Symbol["for"]("react.cache");
Symbol["for"]("react.tracing_marker");
var $9af1097fda9f2b31$var$Ja = Symbol.iterator;
function $9af1097fda9f2b31$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9af1097fda9f2b31$var$Ja && a[$9af1097fda9f2b31$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9af1097fda9f2b31$var$A = Object.assign, $9af1097fda9f2b31$var$La;
function $9af1097fda9f2b31$var$Ma(a) {
    if (void 0 === $9af1097fda9f2b31$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9af1097fda9f2b31$var$La = b && b[1] || "";
    }
    return "\n" + $9af1097fda9f2b31$var$La + a;
}
var $9af1097fda9f2b31$var$Na = !1;
function $9af1097fda9f2b31$var$Oa(a, b) {
    if (!a || $9af1097fda9f2b31$var$Na) return "";
    $9af1097fda9f2b31$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9af1097fda9f2b31$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9af1097fda9f2b31$var$Ma(a) : "";
}
function $9af1097fda9f2b31$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9af1097fda9f2b31$var$Ma(a.type);
        case 16:
            return $9af1097fda9f2b31$var$Ma("Lazy");
        case 13:
            return $9af1097fda9f2b31$var$Ma("Suspense");
        case 19:
            return $9af1097fda9f2b31$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9af1097fda9f2b31$var$Oa(a.type, !1), a;
        case 11:
            return a = $9af1097fda9f2b31$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9af1097fda9f2b31$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9af1097fda9f2b31$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9af1097fda9f2b31$var$ya:
            return "Fragment";
        case $9af1097fda9f2b31$var$wa:
            return "Portal";
        case $9af1097fda9f2b31$var$Aa:
            return "Profiler";
        case $9af1097fda9f2b31$var$za:
            return "StrictMode";
        case $9af1097fda9f2b31$var$Ea:
            return "Suspense";
        case $9af1097fda9f2b31$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9af1097fda9f2b31$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9af1097fda9f2b31$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9af1097fda9f2b31$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9af1097fda9f2b31$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9af1097fda9f2b31$var$Qa(a.type) || "Memo";
        case $9af1097fda9f2b31$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9af1097fda9f2b31$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9af1097fda9f2b31$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9af1097fda9f2b31$var$Qa(b);
        case 8:
            return b === $9af1097fda9f2b31$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9af1097fda9f2b31$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9af1097fda9f2b31$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9af1097fda9f2b31$var$Ua(a) {
    var b = $9af1097fda9f2b31$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9af1097fda9f2b31$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9af1097fda9f2b31$var$Ua(a));
}
function $9af1097fda9f2b31$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9af1097fda9f2b31$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9af1097fda9f2b31$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9af1097fda9f2b31$var$Ya(a, b) {
    var c = b.checked;
    return $9af1097fda9f2b31$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9af1097fda9f2b31$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9af1097fda9f2b31$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9af1097fda9f2b31$var$ab(a, b) {
    b = b.checked;
    null != b && $9af1097fda9f2b31$var$ta(a, "checked", b, !1);
}
function $9af1097fda9f2b31$var$bb(a, b) {
    $9af1097fda9f2b31$var$ab(a, b);
    var c = $9af1097fda9f2b31$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9af1097fda9f2b31$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9af1097fda9f2b31$var$cb(a, b.type, $9af1097fda9f2b31$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9af1097fda9f2b31$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9af1097fda9f2b31$var$cb(a, b, c) {
    if ("number" !== b || $9af1097fda9f2b31$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9af1097fda9f2b31$var$eb = Array.isArray;
function $9af1097fda9f2b31$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9af1097fda9f2b31$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9af1097fda9f2b31$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9af1097fda9f2b31$var$p(91));
    return $9af1097fda9f2b31$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9af1097fda9f2b31$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9af1097fda9f2b31$var$p(92));
            if ($9af1097fda9f2b31$var$eb(c)) {
                if (1 < c.length) throw Error($9af1097fda9f2b31$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9af1097fda9f2b31$var$Sa(c)
    };
}
function $9af1097fda9f2b31$var$ib(a, b) {
    var c = $9af1097fda9f2b31$var$Sa(b.value), d = $9af1097fda9f2b31$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9af1097fda9f2b31$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9af1097fda9f2b31$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9af1097fda9f2b31$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9af1097fda9f2b31$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9af1097fda9f2b31$var$mb, $9af1097fda9f2b31$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9af1097fda9f2b31$var$mb = $9af1097fda9f2b31$var$mb || document.createElement("div");
        $9af1097fda9f2b31$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9af1097fda9f2b31$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9af1097fda9f2b31$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9af1097fda9f2b31$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9af1097fda9f2b31$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9af1097fda9f2b31$var$pb).forEach(function(a) {
    $9af1097fda9f2b31$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9af1097fda9f2b31$var$pb[b] = $9af1097fda9f2b31$var$pb[a];
    });
});
function $9af1097fda9f2b31$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9af1097fda9f2b31$var$pb.hasOwnProperty(a) && $9af1097fda9f2b31$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9af1097fda9f2b31$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9af1097fda9f2b31$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9af1097fda9f2b31$var$tb = $9af1097fda9f2b31$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9af1097fda9f2b31$var$ub(a, b) {
    if (b) {
        if ($9af1097fda9f2b31$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9af1097fda9f2b31$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9af1097fda9f2b31$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9af1097fda9f2b31$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9af1097fda9f2b31$var$p(62));
    }
}
function $9af1097fda9f2b31$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9af1097fda9f2b31$var$wb = null;
function $9af1097fda9f2b31$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9af1097fda9f2b31$var$yb = null, $9af1097fda9f2b31$var$zb = null, $9af1097fda9f2b31$var$Ab = null;
function $9af1097fda9f2b31$var$Bb(a) {
    if (a = $9af1097fda9f2b31$var$Cb(a)) {
        if ("function" !== typeof $9af1097fda9f2b31$var$yb) throw Error($9af1097fda9f2b31$var$p(280));
        var b = a.stateNode;
        b && (b = $9af1097fda9f2b31$var$Db(b), $9af1097fda9f2b31$var$yb(a.stateNode, a.type, b));
    }
}
function $9af1097fda9f2b31$var$Eb(a) {
    $9af1097fda9f2b31$var$zb ? $9af1097fda9f2b31$var$Ab ? $9af1097fda9f2b31$var$Ab.push(a) : $9af1097fda9f2b31$var$Ab = [
        a
    ] : $9af1097fda9f2b31$var$zb = a;
}
function $9af1097fda9f2b31$var$Fb() {
    if ($9af1097fda9f2b31$var$zb) {
        var a = $9af1097fda9f2b31$var$zb, b = $9af1097fda9f2b31$var$Ab;
        $9af1097fda9f2b31$var$Ab = $9af1097fda9f2b31$var$zb = null;
        $9af1097fda9f2b31$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9af1097fda9f2b31$var$Bb(b[a]);
    }
}
function $9af1097fda9f2b31$var$Gb(a, b) {
    return a(b);
}
function $9af1097fda9f2b31$var$Hb() {}
var $9af1097fda9f2b31$var$Ib = !1;
function $9af1097fda9f2b31$var$Jb(a, b, c) {
    if ($9af1097fda9f2b31$var$Ib) return a(b, c);
    $9af1097fda9f2b31$var$Ib = !0;
    try {
        return $9af1097fda9f2b31$var$Gb(a, b, c);
    } finally{
        if ($9af1097fda9f2b31$var$Ib = !1, null !== $9af1097fda9f2b31$var$zb || null !== $9af1097fda9f2b31$var$Ab) $9af1097fda9f2b31$var$Hb(), $9af1097fda9f2b31$var$Fb();
    }
}
function $9af1097fda9f2b31$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9af1097fda9f2b31$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9af1097fda9f2b31$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $qb7pP._)(c)));
    return c;
}
var $9af1097fda9f2b31$var$Lb = !1;
if ($9af1097fda9f2b31$var$ia) try {
    var $9af1097fda9f2b31$var$Mb = {};
    Object.defineProperty($9af1097fda9f2b31$var$Mb, "passive", {
        get: function get() {
            $9af1097fda9f2b31$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9af1097fda9f2b31$var$Mb, $9af1097fda9f2b31$var$Mb);
    window.removeEventListener("test", $9af1097fda9f2b31$var$Mb, $9af1097fda9f2b31$var$Mb);
} catch (a) {
    $9af1097fda9f2b31$var$Lb = !1;
}
function $9af1097fda9f2b31$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9af1097fda9f2b31$var$Ob = !1, $9af1097fda9f2b31$var$Pb = null, $9af1097fda9f2b31$var$Qb = !1, $9af1097fda9f2b31$var$Rb = null, $9af1097fda9f2b31$var$Sb = {
    onError: function onError(a) {
        $9af1097fda9f2b31$var$Ob = !0;
        $9af1097fda9f2b31$var$Pb = a;
    }
};
function $9af1097fda9f2b31$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9af1097fda9f2b31$var$Ob = !1;
    $9af1097fda9f2b31$var$Pb = null;
    $9af1097fda9f2b31$var$Nb.apply($9af1097fda9f2b31$var$Sb, arguments);
}
function $9af1097fda9f2b31$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9af1097fda9f2b31$var$Tb.apply(this, arguments);
    if ($9af1097fda9f2b31$var$Ob) {
        if ($9af1097fda9f2b31$var$Ob) {
            var l = $9af1097fda9f2b31$var$Pb;
            $9af1097fda9f2b31$var$Ob = !1;
            $9af1097fda9f2b31$var$Pb = null;
        } else throw Error($9af1097fda9f2b31$var$p(198));
        $9af1097fda9f2b31$var$Qb || ($9af1097fda9f2b31$var$Qb = !0, $9af1097fda9f2b31$var$Rb = l);
    }
}
function $9af1097fda9f2b31$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9af1097fda9f2b31$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9af1097fda9f2b31$var$Xb(a) {
    if ($9af1097fda9f2b31$var$Vb(a) !== a) throw Error($9af1097fda9f2b31$var$p(188));
}
function $9af1097fda9f2b31$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9af1097fda9f2b31$var$Vb(a);
        if (null === b) throw Error($9af1097fda9f2b31$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9af1097fda9f2b31$var$Xb(e), a;
                if (f === d) return $9af1097fda9f2b31$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9af1097fda9f2b31$var$p(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9af1097fda9f2b31$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9af1097fda9f2b31$var$p(190));
    }
    if (3 !== c.tag) throw Error($9af1097fda9f2b31$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9af1097fda9f2b31$var$Zb(a) {
    a = $9af1097fda9f2b31$var$Yb(a);
    return null !== a ? $9af1097fda9f2b31$var$$b(a) : null;
}
function $9af1097fda9f2b31$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9af1097fda9f2b31$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$ac = $uOv5F.unstable_scheduleCallback, $9af1097fda9f2b31$var$bc = $uOv5F.unstable_cancelCallback, $9af1097fda9f2b31$var$cc = $uOv5F.unstable_shouldYield, $9af1097fda9f2b31$var$dc = $uOv5F.unstable_requestPaint, $9af1097fda9f2b31$var$B = $uOv5F.unstable_now, $9af1097fda9f2b31$var$ec = $uOv5F.unstable_getCurrentPriorityLevel, $9af1097fda9f2b31$var$fc = $uOv5F.unstable_ImmediatePriority, $9af1097fda9f2b31$var$gc = $uOv5F.unstable_UserBlockingPriority, $9af1097fda9f2b31$var$hc = $uOv5F.unstable_NormalPriority, $9af1097fda9f2b31$var$ic = $uOv5F.unstable_LowPriority, $9af1097fda9f2b31$var$jc = $uOv5F.unstable_IdlePriority, $9af1097fda9f2b31$var$kc = null, $9af1097fda9f2b31$var$lc = null;
function $9af1097fda9f2b31$var$mc(a) {
    if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onCommitFiberRoot) try {
        $9af1097fda9f2b31$var$lc.onCommitFiberRoot($9af1097fda9f2b31$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9af1097fda9f2b31$var$oc = Math.clz32 ? Math.clz32 : $9af1097fda9f2b31$var$nc, $9af1097fda9f2b31$var$pc = Math.log, $9af1097fda9f2b31$var$qc = Math.LN2;
function $9af1097fda9f2b31$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9af1097fda9f2b31$var$pc(a) / $9af1097fda9f2b31$var$qc | 0) | 0;
}
var $9af1097fda9f2b31$var$rc = 64, $9af1097fda9f2b31$var$sc = 4194304;
function $9af1097fda9f2b31$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9af1097fda9f2b31$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9af1097fda9f2b31$var$tc(h) : (f &= g, 0 !== f && (d = $9af1097fda9f2b31$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9af1097fda9f2b31$var$tc(g) : 0 !== f && (d = $9af1097fda9f2b31$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9af1097fda9f2b31$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9af1097fda9f2b31$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9af1097fda9f2b31$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9af1097fda9f2b31$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9af1097fda9f2b31$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9af1097fda9f2b31$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9af1097fda9f2b31$var$yc() {
    var a = $9af1097fda9f2b31$var$rc;
    $9af1097fda9f2b31$var$rc <<= 1;
    0 === ($9af1097fda9f2b31$var$rc & 4194240) && ($9af1097fda9f2b31$var$rc = 64);
    return a;
}
function $9af1097fda9f2b31$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9af1097fda9f2b31$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9af1097fda9f2b31$var$oc(b);
    a[b] = c;
}
function $9af1097fda9f2b31$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9af1097fda9f2b31$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9af1097fda9f2b31$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9af1097fda9f2b31$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9af1097fda9f2b31$var$C = 0;
function $9af1097fda9f2b31$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9af1097fda9f2b31$var$Ec, $9af1097fda9f2b31$var$Fc, $9af1097fda9f2b31$var$Gc, $9af1097fda9f2b31$var$Hc, $9af1097fda9f2b31$var$Ic, $9af1097fda9f2b31$var$Jc = !1, $9af1097fda9f2b31$var$Kc = [], $9af1097fda9f2b31$var$Lc = null, $9af1097fda9f2b31$var$Mc = null, $9af1097fda9f2b31$var$Nc = null, $9af1097fda9f2b31$var$Oc = new Map, $9af1097fda9f2b31$var$Pc = new Map, $9af1097fda9f2b31$var$Qc = [], $9af1097fda9f2b31$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9af1097fda9f2b31$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9af1097fda9f2b31$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9af1097fda9f2b31$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9af1097fda9f2b31$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9af1097fda9f2b31$var$Oc["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9af1097fda9f2b31$var$Pc["delete"](b.pointerId);
    }
}
function $9af1097fda9f2b31$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9af1097fda9f2b31$var$Cb(b), null !== b && $9af1097fda9f2b31$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9af1097fda9f2b31$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9af1097fda9f2b31$var$Lc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9af1097fda9f2b31$var$Mc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9af1097fda9f2b31$var$Nc = $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9af1097fda9f2b31$var$Oc.set(f, $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9af1097fda9f2b31$var$Pc.set(f, $9af1097fda9f2b31$var$Tc($9af1097fda9f2b31$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9af1097fda9f2b31$var$Vc(a) {
    var b = $9af1097fda9f2b31$var$Wc(a.target);
    if (null !== b) {
        var c = $9af1097fda9f2b31$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9af1097fda9f2b31$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9af1097fda9f2b31$var$Ic(a.priority, function() {
                        $9af1097fda9f2b31$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9af1097fda9f2b31$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9af1097fda9f2b31$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9af1097fda9f2b31$var$wb = d;
            c.target.dispatchEvent(d);
            $9af1097fda9f2b31$var$wb = null;
        } else return b = $9af1097fda9f2b31$var$Cb(c), null !== b && $9af1097fda9f2b31$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9af1097fda9f2b31$var$Zc(a, b, c) {
    $9af1097fda9f2b31$var$Xc(a) && c["delete"](b);
}
function $9af1097fda9f2b31$var$$c() {
    $9af1097fda9f2b31$var$Jc = !1;
    null !== $9af1097fda9f2b31$var$Lc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Lc) && ($9af1097fda9f2b31$var$Lc = null);
    null !== $9af1097fda9f2b31$var$Mc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Mc) && ($9af1097fda9f2b31$var$Mc = null);
    null !== $9af1097fda9f2b31$var$Nc && $9af1097fda9f2b31$var$Xc($9af1097fda9f2b31$var$Nc) && ($9af1097fda9f2b31$var$Nc = null);
    $9af1097fda9f2b31$var$Oc.forEach($9af1097fda9f2b31$var$Zc);
    $9af1097fda9f2b31$var$Pc.forEach($9af1097fda9f2b31$var$Zc);
}
function $9af1097fda9f2b31$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9af1097fda9f2b31$var$Jc || ($9af1097fda9f2b31$var$Jc = !0, $uOv5F.unstable_scheduleCallback($uOv5F.unstable_NormalPriority, $9af1097fda9f2b31$var$$c)));
}
function $9af1097fda9f2b31$var$bd(a) {
    function b(b) {
        return $9af1097fda9f2b31$var$ad(b, a);
    }
    if (0 < $9af1097fda9f2b31$var$Kc.length) {
        $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Kc[0], a);
        for(var c = 1; c < $9af1097fda9f2b31$var$Kc.length; c++){
            var d = $9af1097fda9f2b31$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9af1097fda9f2b31$var$Lc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Lc, a);
    null !== $9af1097fda9f2b31$var$Mc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Mc, a);
    null !== $9af1097fda9f2b31$var$Nc && $9af1097fda9f2b31$var$ad($9af1097fda9f2b31$var$Nc, a);
    $9af1097fda9f2b31$var$Oc.forEach(b);
    $9af1097fda9f2b31$var$Pc.forEach(b);
    for(c = 0; c < $9af1097fda9f2b31$var$Qc.length; c++)d = $9af1097fda9f2b31$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9af1097fda9f2b31$var$Qc.length && (c = $9af1097fda9f2b31$var$Qc[0], null === c.blockedOn);)$9af1097fda9f2b31$var$Vc(c), null === c.blockedOn && $9af1097fda9f2b31$var$Qc.shift();
}
var $9af1097fda9f2b31$var$cd = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$dd = !0;
function $9af1097fda9f2b31$var$ed(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$C, f = $9af1097fda9f2b31$var$cd.transition;
    $9af1097fda9f2b31$var$cd.transition = null;
    try {
        $9af1097fda9f2b31$var$C = 1, $9af1097fda9f2b31$var$fd(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$C = e, $9af1097fda9f2b31$var$cd.transition = f;
    }
}
function $9af1097fda9f2b31$var$gd(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$C, f = $9af1097fda9f2b31$var$cd.transition;
    $9af1097fda9f2b31$var$cd.transition = null;
    try {
        $9af1097fda9f2b31$var$C = 4, $9af1097fda9f2b31$var$fd(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$C = e, $9af1097fda9f2b31$var$cd.transition = f;
    }
}
function $9af1097fda9f2b31$var$fd(a, b, c, d) {
    if ($9af1097fda9f2b31$var$dd) {
        var e = $9af1097fda9f2b31$var$Yc(a, b, c, d);
        if (null === e) $9af1097fda9f2b31$var$hd(a, b, d, $9af1097fda9f2b31$var$id, c), $9af1097fda9f2b31$var$Sc(a, d);
        else if ($9af1097fda9f2b31$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9af1097fda9f2b31$var$Sc(a, d), b & 4 && -1 < $9af1097fda9f2b31$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9af1097fda9f2b31$var$Cb(e);
                null !== f && $9af1097fda9f2b31$var$Ec(f);
                f = $9af1097fda9f2b31$var$Yc(a, b, c, d);
                null === f && $9af1097fda9f2b31$var$hd(a, b, d, $9af1097fda9f2b31$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9af1097fda9f2b31$var$hd(a, b, d, null, c);
    }
}
var $9af1097fda9f2b31$var$id = null;
function $9af1097fda9f2b31$var$Yc(a, b, c, d) {
    $9af1097fda9f2b31$var$id = null;
    a = $9af1097fda9f2b31$var$xb(d);
    a = $9af1097fda9f2b31$var$Wc(a);
    if (null !== a) {
        if (b = $9af1097fda9f2b31$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9af1097fda9f2b31$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9af1097fda9f2b31$var$id = a;
    return null;
}
function $9af1097fda9f2b31$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9af1097fda9f2b31$var$ec()){
                case $9af1097fda9f2b31$var$fc:
                    return 1;
                case $9af1097fda9f2b31$var$gc:
                    return 4;
                case $9af1097fda9f2b31$var$hc:
                case $9af1097fda9f2b31$var$ic:
                    return 16;
                case $9af1097fda9f2b31$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9af1097fda9f2b31$var$kd = null, $9af1097fda9f2b31$var$ld = null, $9af1097fda9f2b31$var$md = null;
function $9af1097fda9f2b31$var$nd() {
    if ($9af1097fda9f2b31$var$md) return $9af1097fda9f2b31$var$md;
    var a, b = $9af1097fda9f2b31$var$ld, c = b.length, d, e = "value" in $9af1097fda9f2b31$var$kd ? $9af1097fda9f2b31$var$kd.value : $9af1097fda9f2b31$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9af1097fda9f2b31$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9af1097fda9f2b31$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9af1097fda9f2b31$var$pd() {
    return !0;
}
function $9af1097fda9f2b31$var$qd() {
    return !1;
}
function $9af1097fda9f2b31$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9af1097fda9f2b31$var$pd : $9af1097fda9f2b31$var$qd;
        this.isPropagationStopped = $9af1097fda9f2b31$var$qd;
        return this;
    }
    $9af1097fda9f2b31$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $qb7pP._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $9af1097fda9f2b31$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $qb7pP._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $9af1097fda9f2b31$var$pd);
        },
        persist: function persist() {},
        isPersistent: $9af1097fda9f2b31$var$pd
    });
    return b;
}
var $9af1097fda9f2b31$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9af1097fda9f2b31$var$td = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$sd), $9af1097fda9f2b31$var$ud = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    view: 0,
    detail: 0
}), $9af1097fda9f2b31$var$vd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$ud), $9af1097fda9f2b31$var$wd, $9af1097fda9f2b31$var$xd, $9af1097fda9f2b31$var$yd, $9af1097fda9f2b31$var$Ad = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9af1097fda9f2b31$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9af1097fda9f2b31$var$yd && ($9af1097fda9f2b31$var$yd && "mousemove" === a.type ? ($9af1097fda9f2b31$var$wd = a.screenX - $9af1097fda9f2b31$var$yd.screenX, $9af1097fda9f2b31$var$xd = a.screenY - $9af1097fda9f2b31$var$yd.screenY) : $9af1097fda9f2b31$var$xd = $9af1097fda9f2b31$var$wd = 0, $9af1097fda9f2b31$var$yd = a);
        return $9af1097fda9f2b31$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $9af1097fda9f2b31$var$xd;
    }
}), $9af1097fda9f2b31$var$Bd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ad), $9af1097fda9f2b31$var$Cd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    dataTransfer: 0
}), $9af1097fda9f2b31$var$Dd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Cd), $9af1097fda9f2b31$var$Ed = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    relatedTarget: 0
}), $9af1097fda9f2b31$var$Fd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ed), $9af1097fda9f2b31$var$Gd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9af1097fda9f2b31$var$Hd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Gd), $9af1097fda9f2b31$var$Id = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9af1097fda9f2b31$var$Jd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Id), $9af1097fda9f2b31$var$Kd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    data: 0
}), $9af1097fda9f2b31$var$Ld = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Kd), $9af1097fda9f2b31$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9af1097fda9f2b31$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9af1097fda9f2b31$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9af1097fda9f2b31$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9af1097fda9f2b31$var$Od[a]) ? !!b[a] : !1;
}
function $9af1097fda9f2b31$var$zd() {
    return $9af1097fda9f2b31$var$Pd;
}
var $9af1097fda9f2b31$var$Qd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $9af1097fda9f2b31$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9af1097fda9f2b31$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9af1097fda9f2b31$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9af1097fda9f2b31$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $9af1097fda9f2b31$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $9af1097fda9f2b31$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9af1097fda9f2b31$var$Rd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Qd), $9af1097fda9f2b31$var$Sd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9af1097fda9f2b31$var$Td = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Sd), $9af1097fda9f2b31$var$Ud = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9af1097fda9f2b31$var$zd
}), $9af1097fda9f2b31$var$Vd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Ud), $9af1097fda9f2b31$var$Wd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9af1097fda9f2b31$var$Xd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Wd), $9af1097fda9f2b31$var$Yd = $9af1097fda9f2b31$var$A({}, $9af1097fda9f2b31$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9af1097fda9f2b31$var$Zd = $9af1097fda9f2b31$var$rd($9af1097fda9f2b31$var$Yd), $9af1097fda9f2b31$var$$d = [
    9,
    13,
    27,
    32
], $9af1097fda9f2b31$var$ae = $9af1097fda9f2b31$var$ia && "CompositionEvent" in window, $9af1097fda9f2b31$var$be = null;
$9af1097fda9f2b31$var$ia && "documentMode" in document && ($9af1097fda9f2b31$var$be = document.documentMode);
var $9af1097fda9f2b31$var$ce = $9af1097fda9f2b31$var$ia && "TextEvent" in window && !$9af1097fda9f2b31$var$be, $9af1097fda9f2b31$var$de = $9af1097fda9f2b31$var$ia && (!$9af1097fda9f2b31$var$ae || $9af1097fda9f2b31$var$be && 8 < $9af1097fda9f2b31$var$be && 11 >= $9af1097fda9f2b31$var$be), $9af1097fda9f2b31$var$ee = String.fromCharCode(32), $9af1097fda9f2b31$var$fe = !1;
function $9af1097fda9f2b31$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9af1097fda9f2b31$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9af1097fda9f2b31$var$ie = !1;
function $9af1097fda9f2b31$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9af1097fda9f2b31$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9af1097fda9f2b31$var$fe = !0;
            return $9af1097fda9f2b31$var$ee;
        case "textInput":
            return a = b.data, a === $9af1097fda9f2b31$var$ee && $9af1097fda9f2b31$var$fe ? null : a;
        default:
            return null;
    }
}
function $9af1097fda9f2b31$var$ke(a, b) {
    if ($9af1097fda9f2b31$var$ie) return "compositionend" === a || !$9af1097fda9f2b31$var$ae && $9af1097fda9f2b31$var$ge(a, b) ? (a = $9af1097fda9f2b31$var$nd(), $9af1097fda9f2b31$var$md = $9af1097fda9f2b31$var$ld = $9af1097fda9f2b31$var$kd = null, $9af1097fda9f2b31$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9af1097fda9f2b31$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9af1097fda9f2b31$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9af1097fda9f2b31$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9af1097fda9f2b31$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9af1097fda9f2b31$var$ne(a, b, c, d) {
    $9af1097fda9f2b31$var$Eb(d);
    b = $9af1097fda9f2b31$var$oe(b, "onChange");
    0 < b.length && (c = new $9af1097fda9f2b31$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9af1097fda9f2b31$var$pe = null, $9af1097fda9f2b31$var$qe = null;
function $9af1097fda9f2b31$var$re(a) {
    $9af1097fda9f2b31$var$se(a, 0);
}
function $9af1097fda9f2b31$var$te(a) {
    var b = $9af1097fda9f2b31$var$ue(a);
    if ($9af1097fda9f2b31$var$Wa(b)) return a;
}
function $9af1097fda9f2b31$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9af1097fda9f2b31$var$we = !1;
if ($9af1097fda9f2b31$var$ia) {
    var $9af1097fda9f2b31$var$xe;
    if ($9af1097fda9f2b31$var$ia) {
        var $9af1097fda9f2b31$var$ye = "oninput" in document;
        if (!$9af1097fda9f2b31$var$ye) {
            var $9af1097fda9f2b31$var$ze = document.createElement("div");
            $9af1097fda9f2b31$var$ze.setAttribute("oninput", "return;");
            $9af1097fda9f2b31$var$ye = "function" === typeof $9af1097fda9f2b31$var$ze.oninput;
        }
        $9af1097fda9f2b31$var$xe = $9af1097fda9f2b31$var$ye;
    } else $9af1097fda9f2b31$var$xe = !1;
    $9af1097fda9f2b31$var$we = $9af1097fda9f2b31$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9af1097fda9f2b31$var$Ae() {
    $9af1097fda9f2b31$var$pe && ($9af1097fda9f2b31$var$pe.detachEvent("onpropertychange", $9af1097fda9f2b31$var$Be), $9af1097fda9f2b31$var$qe = $9af1097fda9f2b31$var$pe = null);
}
function $9af1097fda9f2b31$var$Be(a) {
    if ("value" === a.propertyName && $9af1097fda9f2b31$var$te($9af1097fda9f2b31$var$qe)) {
        var b = [];
        $9af1097fda9f2b31$var$ne(b, $9af1097fda9f2b31$var$qe, a, $9af1097fda9f2b31$var$xb(a));
        $9af1097fda9f2b31$var$Jb($9af1097fda9f2b31$var$re, b);
    }
}
function $9af1097fda9f2b31$var$Ce(a, b, c) {
    "focusin" === a ? ($9af1097fda9f2b31$var$Ae(), $9af1097fda9f2b31$var$pe = b, $9af1097fda9f2b31$var$qe = c, $9af1097fda9f2b31$var$pe.attachEvent("onpropertychange", $9af1097fda9f2b31$var$Be)) : "focusout" === a && $9af1097fda9f2b31$var$Ae();
}
function $9af1097fda9f2b31$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9af1097fda9f2b31$var$te($9af1097fda9f2b31$var$qe);
}
function $9af1097fda9f2b31$var$Ee(a, b) {
    if ("click" === a) return $9af1097fda9f2b31$var$te(b);
}
function $9af1097fda9f2b31$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9af1097fda9f2b31$var$te(b);
}
function $9af1097fda9f2b31$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9af1097fda9f2b31$var$He = "function" === typeof Object.is ? Object.is : $9af1097fda9f2b31$var$Ge;
function $9af1097fda9f2b31$var$Ie(a, b) {
    if ($9af1097fda9f2b31$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9af1097fda9f2b31$var$ja.call(b, e) || !$9af1097fda9f2b31$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9af1097fda9f2b31$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9af1097fda9f2b31$var$Ke(a, b) {
    var c = $9af1097fda9f2b31$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9af1097fda9f2b31$var$Je(c);
    }
}
function $9af1097fda9f2b31$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9af1097fda9f2b31$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9af1097fda9f2b31$var$Me() {
    for(var a = window, b = $9af1097fda9f2b31$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9af1097fda9f2b31$var$Xa(a.document);
    }
    return b;
}
function $9af1097fda9f2b31$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9af1097fda9f2b31$var$Oe(a) {
    var b = $9af1097fda9f2b31$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9af1097fda9f2b31$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9af1097fda9f2b31$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9af1097fda9f2b31$var$Ke(c, f);
                var g = $9af1097fda9f2b31$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9af1097fda9f2b31$var$Pe = $9af1097fda9f2b31$var$ia && "documentMode" in document && 11 >= document.documentMode, $9af1097fda9f2b31$var$Qe = null, $9af1097fda9f2b31$var$Re = null, $9af1097fda9f2b31$var$Se = null, $9af1097fda9f2b31$var$Te = !1;
function $9af1097fda9f2b31$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9af1097fda9f2b31$var$Te || null == $9af1097fda9f2b31$var$Qe || $9af1097fda9f2b31$var$Qe !== $9af1097fda9f2b31$var$Xa(d) || (d = $9af1097fda9f2b31$var$Qe, "selectionStart" in d && $9af1097fda9f2b31$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9af1097fda9f2b31$var$Se && $9af1097fda9f2b31$var$Ie($9af1097fda9f2b31$var$Se, d) || ($9af1097fda9f2b31$var$Se = d, d = $9af1097fda9f2b31$var$oe($9af1097fda9f2b31$var$Re, "onSelect"), 0 < d.length && (b = new $9af1097fda9f2b31$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9af1097fda9f2b31$var$Qe)));
}
function $9af1097fda9f2b31$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9af1097fda9f2b31$var$We = {
    animationend: $9af1097fda9f2b31$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9af1097fda9f2b31$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9af1097fda9f2b31$var$Ve("Animation", "AnimationStart"),
    transitionend: $9af1097fda9f2b31$var$Ve("Transition", "TransitionEnd")
}, $9af1097fda9f2b31$var$Xe = {}, $9af1097fda9f2b31$var$Ye = {};
$9af1097fda9f2b31$var$ia && ($9af1097fda9f2b31$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9af1097fda9f2b31$var$We.animationend.animation, delete $9af1097fda9f2b31$var$We.animationiteration.animation, delete $9af1097fda9f2b31$var$We.animationstart.animation), "TransitionEvent" in window || delete $9af1097fda9f2b31$var$We.transitionend.transition);
function $9af1097fda9f2b31$var$Ze(a) {
    if ($9af1097fda9f2b31$var$Xe[a]) return $9af1097fda9f2b31$var$Xe[a];
    if (!$9af1097fda9f2b31$var$We[a]) return a;
    var b = $9af1097fda9f2b31$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9af1097fda9f2b31$var$Ye) return $9af1097fda9f2b31$var$Xe[a] = b[c];
    return a;
}
var $9af1097fda9f2b31$var$$e = $9af1097fda9f2b31$var$Ze("animationend"), $9af1097fda9f2b31$var$af = $9af1097fda9f2b31$var$Ze("animationiteration"), $9af1097fda9f2b31$var$bf = $9af1097fda9f2b31$var$Ze("animationstart"), $9af1097fda9f2b31$var$cf = $9af1097fda9f2b31$var$Ze("transitionend"), $9af1097fda9f2b31$var$df = new Map, $9af1097fda9f2b31$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9af1097fda9f2b31$var$ff(a, b) {
    $9af1097fda9f2b31$var$df.set(a, b);
    $9af1097fda9f2b31$var$fa(b, [
        a
    ]);
}
for(var $9af1097fda9f2b31$var$gf = 0; $9af1097fda9f2b31$var$gf < $9af1097fda9f2b31$var$ef.length; $9af1097fda9f2b31$var$gf++){
    var $9af1097fda9f2b31$var$hf = $9af1097fda9f2b31$var$ef[$9af1097fda9f2b31$var$gf], $9af1097fda9f2b31$var$jf = $9af1097fda9f2b31$var$hf.toLowerCase(), $9af1097fda9f2b31$var$kf = $9af1097fda9f2b31$var$hf[0].toUpperCase() + $9af1097fda9f2b31$var$hf.slice(1);
    $9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$jf, "on" + $9af1097fda9f2b31$var$kf);
}
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$$e, "onAnimationEnd");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$af, "onAnimationIteration");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$bf, "onAnimationStart");
$9af1097fda9f2b31$var$ff("dblclick", "onDoubleClick");
$9af1097fda9f2b31$var$ff("focusin", "onFocus");
$9af1097fda9f2b31$var$ff("focusout", "onBlur");
$9af1097fda9f2b31$var$ff($9af1097fda9f2b31$var$cf, "onTransitionEnd");
$9af1097fda9f2b31$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9af1097fda9f2b31$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9af1097fda9f2b31$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9af1097fda9f2b31$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9af1097fda9f2b31$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9af1097fda9f2b31$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9af1097fda9f2b31$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9af1097fda9f2b31$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9af1097fda9f2b31$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9af1097fda9f2b31$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9af1097fda9f2b31$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9af1097fda9f2b31$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9af1097fda9f2b31$var$lf));
function $9af1097fda9f2b31$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9af1097fda9f2b31$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9af1097fda9f2b31$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9af1097fda9f2b31$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9af1097fda9f2b31$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9af1097fda9f2b31$var$Qb) throw a = $9af1097fda9f2b31$var$Rb, $9af1097fda9f2b31$var$Qb = !1, $9af1097fda9f2b31$var$Rb = null, a;
}
function $9af1097fda9f2b31$var$D(a, b) {
    var c = b[$9af1097fda9f2b31$var$of];
    void 0 === c && (c = b[$9af1097fda9f2b31$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9af1097fda9f2b31$var$pf(b, a, 2, !1), c.add(d));
}
function $9af1097fda9f2b31$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9af1097fda9f2b31$var$pf(c, a, d, b);
}
var $9af1097fda9f2b31$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9af1097fda9f2b31$var$sf(a) {
    if (!a[$9af1097fda9f2b31$var$rf]) {
        a[$9af1097fda9f2b31$var$rf] = !0;
        $9af1097fda9f2b31$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9af1097fda9f2b31$var$mf.has(b) || $9af1097fda9f2b31$var$qf(b, !1, a), $9af1097fda9f2b31$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9af1097fda9f2b31$var$rf] || (b[$9af1097fda9f2b31$var$rf] = !0, $9af1097fda9f2b31$var$qf("selectionchange", !1, b));
    }
}
function $9af1097fda9f2b31$var$pf(a, b, c, d) {
    switch($9af1097fda9f2b31$var$jd(b)){
        case 1:
            var e = $9af1097fda9f2b31$var$ed;
            break;
        case 4:
            e = $9af1097fda9f2b31$var$gd;
            break;
        default:
            e = $9af1097fda9f2b31$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9af1097fda9f2b31$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9af1097fda9f2b31$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d["return"]; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g["return"];
            }
            for(; null !== h;){
                g = $9af1097fda9f2b31$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d["return"];
    }
    $9af1097fda9f2b31$var$Jb(function() {
        var _$d = f, _$e = $9af1097fda9f2b31$var$xb(c), g = [];
        a: {
            var h = $9af1097fda9f2b31$var$df.get(a);
            if (void 0 !== h) {
                var k = $9af1097fda9f2b31$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9af1097fda9f2b31$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9af1097fda9f2b31$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9af1097fda9f2b31$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9af1097fda9f2b31$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9af1097fda9f2b31$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9af1097fda9f2b31$var$Vd;
                        break;
                    case $9af1097fda9f2b31$var$$e:
                    case $9af1097fda9f2b31$var$af:
                    case $9af1097fda9f2b31$var$bf:
                        k = $9af1097fda9f2b31$var$Hd;
                        break;
                    case $9af1097fda9f2b31$var$cf:
                        k = $9af1097fda9f2b31$var$Xd;
                        break;
                    case "scroll":
                        k = $9af1097fda9f2b31$var$vd;
                        break;
                    case "wheel":
                        k = $9af1097fda9f2b31$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9af1097fda9f2b31$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9af1097fda9f2b31$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9af1097fda9f2b31$var$Kb(w, x), null != F && t.push($9af1097fda9f2b31$var$tf(w, F, u))));
                    if (J) break;
                    w = w["return"];
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9af1097fda9f2b31$var$wb && (n = c.relatedTarget || c.fromElement) && ($9af1097fda9f2b31$var$Wc(n) || n[$9af1097fda9f2b31$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $9af1097fda9f2b31$var$Wc(n) : null, null !== n && (J = $9af1097fda9f2b31$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $9af1097fda9f2b31$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9af1097fda9f2b31$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9af1097fda9f2b31$var$ue(k);
                        u = null == n ? h : $9af1097fda9f2b31$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9af1097fda9f2b31$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9af1097fda9f2b31$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9af1097fda9f2b31$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9af1097fda9f2b31$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9af1097fda9f2b31$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9af1097fda9f2b31$var$vf(t);
                                x = $9af1097fda9f2b31$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9af1097fda9f2b31$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9af1097fda9f2b31$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $9af1097fda9f2b31$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9af1097fda9f2b31$var$ve;
                else if ($9af1097fda9f2b31$var$me(h)) {
                    if ($9af1097fda9f2b31$var$we) na = $9af1097fda9f2b31$var$Fe;
                    else {
                        na = $9af1097fda9f2b31$var$De;
                        var xa = $9af1097fda9f2b31$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9af1097fda9f2b31$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $9af1097fda9f2b31$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9af1097fda9f2b31$var$cb(h, "number", h.value);
            }
            xa = _$d ? $9af1097fda9f2b31$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($9af1097fda9f2b31$var$me(xa) || "true" === xa.contentEditable) $9af1097fda9f2b31$var$Qe = xa, $9af1097fda9f2b31$var$Re = _$d, $9af1097fda9f2b31$var$Se = null;
                    break;
                case "focusout":
                    $9af1097fda9f2b31$var$Se = $9af1097fda9f2b31$var$Re = $9af1097fda9f2b31$var$Qe = null;
                    break;
                case "mousedown":
                    $9af1097fda9f2b31$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9af1097fda9f2b31$var$Te = !1;
                    $9af1097fda9f2b31$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($9af1097fda9f2b31$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9af1097fda9f2b31$var$Ue(g, c, _$e);
            }
            var $a;
            if ($9af1097fda9f2b31$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9af1097fda9f2b31$var$ie ? $9af1097fda9f2b31$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9af1097fda9f2b31$var$de && "ko" !== c.locale && ($9af1097fda9f2b31$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9af1097fda9f2b31$var$ie && ($a = $9af1097fda9f2b31$var$nd()) : ($9af1097fda9f2b31$var$kd = _$e, $9af1097fda9f2b31$var$ld = "value" in $9af1097fda9f2b31$var$kd ? $9af1097fda9f2b31$var$kd.value : $9af1097fda9f2b31$var$kd.textContent, $9af1097fda9f2b31$var$ie = !0)), xa = $9af1097fda9f2b31$var$oe(_$d, ba), 0 < xa.length && (ba = new $9af1097fda9f2b31$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9af1097fda9f2b31$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9af1097fda9f2b31$var$ce ? $9af1097fda9f2b31$var$je(a, c) : $9af1097fda9f2b31$var$ke(a, c)) _$d = $9af1097fda9f2b31$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $9af1097fda9f2b31$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $9af1097fda9f2b31$var$se(g, b);
    });
}
function $9af1097fda9f2b31$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9af1097fda9f2b31$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9af1097fda9f2b31$var$Kb(a, c), null != f && d.unshift($9af1097fda9f2b31$var$tf(a, f, e)), f = $9af1097fda9f2b31$var$Kb(a, b), null != f && d.push($9af1097fda9f2b31$var$tf(a, f, e)));
        a = a["return"];
    }
    return d;
}
function $9af1097fda9f2b31$var$vf(a) {
    if (null === a) return null;
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9af1097fda9f2b31$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9af1097fda9f2b31$var$Kb(c, f), null != k && g.unshift($9af1097fda9f2b31$var$tf(c, k, h))) : e || (k = $9af1097fda9f2b31$var$Kb(c, f), null != k && g.push($9af1097fda9f2b31$var$tf(c, k, h))));
        c = c["return"];
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9af1097fda9f2b31$var$xf = /\r\n?/g, $9af1097fda9f2b31$var$yf = /\u0000|\uFFFD/g;
function $9af1097fda9f2b31$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9af1097fda9f2b31$var$xf, "\n").replace($9af1097fda9f2b31$var$yf, "");
}
function $9af1097fda9f2b31$var$Af(a, b, c) {
    b = $9af1097fda9f2b31$var$zf(b);
    if ($9af1097fda9f2b31$var$zf(a) !== b && c) throw Error($9af1097fda9f2b31$var$p(425));
}
function $9af1097fda9f2b31$var$Bf() {}
var $9af1097fda9f2b31$var$Cf = null, $9af1097fda9f2b31$var$Df = null;
function $9af1097fda9f2b31$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9af1097fda9f2b31$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9af1097fda9f2b31$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9af1097fda9f2b31$var$Hf = "function" === typeof Promise ? Promise : void 0, $9af1097fda9f2b31$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9af1097fda9f2b31$var$Hf ? function Jf(a) {
    return $9af1097fda9f2b31$var$Hf.resolve(null).then(a)["catch"]($9af1097fda9f2b31$var$If);
} : $9af1097fda9f2b31$var$Ff;
function $9af1097fda9f2b31$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9af1097fda9f2b31$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9af1097fda9f2b31$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9af1097fda9f2b31$var$bd(b);
}
function $9af1097fda9f2b31$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9af1097fda9f2b31$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$Nf = Math.random().toString(36).slice(2), $9af1097fda9f2b31$var$Of = "__reactFiber$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Pf = "__reactProps$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$uf = "__reactContainer$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$of = "__reactEvents$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Qf = "__reactListeners$" + $9af1097fda9f2b31$var$Nf, $9af1097fda9f2b31$var$Rf = "__reactHandles$" + $9af1097fda9f2b31$var$Nf;
function $9af1097fda9f2b31$var$Wc(a) {
    var b = a[$9af1097fda9f2b31$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9af1097fda9f2b31$var$uf] || c[$9af1097fda9f2b31$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9af1097fda9f2b31$var$Mf(a); null !== a;){
                if (c = a[$9af1097fda9f2b31$var$Of]) return c;
                a = $9af1097fda9f2b31$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9af1097fda9f2b31$var$Cb(a) {
    a = a[$9af1097fda9f2b31$var$Of] || a[$9af1097fda9f2b31$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9af1097fda9f2b31$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9af1097fda9f2b31$var$p(33));
}
function $9af1097fda9f2b31$var$Db(a) {
    return a[$9af1097fda9f2b31$var$Pf] || null;
}
var $9af1097fda9f2b31$var$Sf = [], $9af1097fda9f2b31$var$Tf = -1;
function $9af1097fda9f2b31$var$Uf(a) {
    return {
        current: a
    };
}
function $9af1097fda9f2b31$var$E(a) {
    0 > $9af1097fda9f2b31$var$Tf || (a.current = $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf], $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf] = null, $9af1097fda9f2b31$var$Tf--);
}
function $9af1097fda9f2b31$var$G(a, b) {
    $9af1097fda9f2b31$var$Tf++;
    $9af1097fda9f2b31$var$Sf[$9af1097fda9f2b31$var$Tf] = a.current;
    a.current = b;
}
var $9af1097fda9f2b31$var$Vf = {}, $9af1097fda9f2b31$var$H = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Vf), $9af1097fda9f2b31$var$Wf = $9af1097fda9f2b31$var$Uf(!1), $9af1097fda9f2b31$var$Xf = $9af1097fda9f2b31$var$Vf;
function $9af1097fda9f2b31$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9af1097fda9f2b31$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9af1097fda9f2b31$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9af1097fda9f2b31$var$$f() {
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
}
function $9af1097fda9f2b31$var$ag(a, b, c) {
    if ($9af1097fda9f2b31$var$H.current !== $9af1097fda9f2b31$var$Vf) throw Error($9af1097fda9f2b31$var$p(168));
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, b);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, c);
}
function $9af1097fda9f2b31$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9af1097fda9f2b31$var$p(108, $9af1097fda9f2b31$var$Ra(a) || "Unknown", e));
    return $9af1097fda9f2b31$var$A({}, c, d);
}
function $9af1097fda9f2b31$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9af1097fda9f2b31$var$Vf;
    $9af1097fda9f2b31$var$Xf = $9af1097fda9f2b31$var$H.current;
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, a);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, $9af1097fda9f2b31$var$Wf.current);
    return !0;
}
function $9af1097fda9f2b31$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9af1097fda9f2b31$var$p(169));
    c ? (a = $9af1097fda9f2b31$var$bg(a, b, $9af1097fda9f2b31$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H), $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$H, a)) : $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Wf, c);
}
var $9af1097fda9f2b31$var$eg = null, $9af1097fda9f2b31$var$fg = !1, $9af1097fda9f2b31$var$gg = !1;
function $9af1097fda9f2b31$var$hg(a) {
    null === $9af1097fda9f2b31$var$eg ? $9af1097fda9f2b31$var$eg = [
        a
    ] : $9af1097fda9f2b31$var$eg.push(a);
}
function $9af1097fda9f2b31$var$ig(a) {
    $9af1097fda9f2b31$var$fg = !0;
    $9af1097fda9f2b31$var$hg(a);
}
function $9af1097fda9f2b31$var$jg() {
    if (!$9af1097fda9f2b31$var$gg && null !== $9af1097fda9f2b31$var$eg) {
        $9af1097fda9f2b31$var$gg = !0;
        var a = 0, b = $9af1097fda9f2b31$var$C;
        try {
            var c = $9af1097fda9f2b31$var$eg;
            for($9af1097fda9f2b31$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9af1097fda9f2b31$var$eg = null;
            $9af1097fda9f2b31$var$fg = !1;
        } catch (e) {
            throw null !== $9af1097fda9f2b31$var$eg && ($9af1097fda9f2b31$var$eg = $9af1097fda9f2b31$var$eg.slice(a + 1)), $9af1097fda9f2b31$var$ac($9af1097fda9f2b31$var$fc, $9af1097fda9f2b31$var$jg), e;
        } finally{
            $9af1097fda9f2b31$var$C = b, $9af1097fda9f2b31$var$gg = !1;
        }
    }
    return null;
}
var $9af1097fda9f2b31$var$kg = [], $9af1097fda9f2b31$var$lg = 0, $9af1097fda9f2b31$var$mg = null, $9af1097fda9f2b31$var$ng = 0, $9af1097fda9f2b31$var$og = [], $9af1097fda9f2b31$var$pg = 0, $9af1097fda9f2b31$var$qg = null, $9af1097fda9f2b31$var$rg = 1, $9af1097fda9f2b31$var$sg = "";
function $9af1097fda9f2b31$var$tg(a, b) {
    $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg++] = $9af1097fda9f2b31$var$ng;
    $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg++] = $9af1097fda9f2b31$var$mg;
    $9af1097fda9f2b31$var$mg = a;
    $9af1097fda9f2b31$var$ng = b;
}
function $9af1097fda9f2b31$var$ug(a, b, c) {
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$rg;
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$sg;
    $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$qg;
    $9af1097fda9f2b31$var$qg = a;
    var d = $9af1097fda9f2b31$var$rg;
    a = $9af1097fda9f2b31$var$sg;
    var e = 32 - $9af1097fda9f2b31$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9af1097fda9f2b31$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9af1097fda9f2b31$var$rg = 1 << 32 - $9af1097fda9f2b31$var$oc(b) + e | c << e | d;
        $9af1097fda9f2b31$var$sg = f + a;
    } else $9af1097fda9f2b31$var$rg = 1 << f | c << e | d, $9af1097fda9f2b31$var$sg = a;
}
function $9af1097fda9f2b31$var$vg(a) {
    null !== a["return"] && ($9af1097fda9f2b31$var$tg(a, 1), $9af1097fda9f2b31$var$ug(a, 1, 0));
}
function $9af1097fda9f2b31$var$wg(a) {
    for(; a === $9af1097fda9f2b31$var$mg;)$9af1097fda9f2b31$var$mg = $9af1097fda9f2b31$var$kg[--$9af1097fda9f2b31$var$lg], $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg] = null, $9af1097fda9f2b31$var$ng = $9af1097fda9f2b31$var$kg[--$9af1097fda9f2b31$var$lg], $9af1097fda9f2b31$var$kg[$9af1097fda9f2b31$var$lg] = null;
    for(; a === $9af1097fda9f2b31$var$qg;)$9af1097fda9f2b31$var$qg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null, $9af1097fda9f2b31$var$sg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null, $9af1097fda9f2b31$var$rg = $9af1097fda9f2b31$var$og[--$9af1097fda9f2b31$var$pg], $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg] = null;
}
var $9af1097fda9f2b31$var$xg = null, $9af1097fda9f2b31$var$yg = null, $9af1097fda9f2b31$var$I = !1, $9af1097fda9f2b31$var$zg = null;
function $9af1097fda9f2b31$var$Ag(a, b) {
    var c = $9af1097fda9f2b31$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9af1097fda9f2b31$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9af1097fda9f2b31$var$qg ? {
                id: $9af1097fda9f2b31$var$rg,
                overflow: $9af1097fda9f2b31$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9af1097fda9f2b31$var$Bg(18, null, null, 0), c.stateNode = b, c["return"] = a, a.child = c, $9af1097fda9f2b31$var$xg = a, $9af1097fda9f2b31$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9af1097fda9f2b31$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9af1097fda9f2b31$var$Eg(a) {
    if ($9af1097fda9f2b31$var$I) {
        var b = $9af1097fda9f2b31$var$yg;
        if (b) {
            var c = b;
            if (!$9af1097fda9f2b31$var$Cg(a, b)) {
                if ($9af1097fda9f2b31$var$Dg(a)) throw Error($9af1097fda9f2b31$var$p(418));
                b = $9af1097fda9f2b31$var$Lf(c.nextSibling);
                var d = $9af1097fda9f2b31$var$xg;
                b && $9af1097fda9f2b31$var$Cg(a, b) ? $9af1097fda9f2b31$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9af1097fda9f2b31$var$I = !1, $9af1097fda9f2b31$var$xg = a);
            }
        } else {
            if ($9af1097fda9f2b31$var$Dg(a)) throw Error($9af1097fda9f2b31$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9af1097fda9f2b31$var$I = !1;
            $9af1097fda9f2b31$var$xg = a;
        }
    }
}
function $9af1097fda9f2b31$var$Fg(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    $9af1097fda9f2b31$var$xg = a;
}
function $9af1097fda9f2b31$var$Gg(a) {
    if (a !== $9af1097fda9f2b31$var$xg) return !1;
    if (!$9af1097fda9f2b31$var$I) return $9af1097fda9f2b31$var$Fg(a), $9af1097fda9f2b31$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9af1097fda9f2b31$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9af1097fda9f2b31$var$yg)) {
        if ($9af1097fda9f2b31$var$Dg(a)) throw $9af1097fda9f2b31$var$Hg(), Error($9af1097fda9f2b31$var$p(418));
        for(; b;)$9af1097fda9f2b31$var$Ag(a, b), b = $9af1097fda9f2b31$var$Lf(b.nextSibling);
    }
    $9af1097fda9f2b31$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9af1097fda9f2b31$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9af1097fda9f2b31$var$yg = null;
        }
    } else $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$xg ? $9af1097fda9f2b31$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9af1097fda9f2b31$var$Hg() {
    for(var a = $9af1097fda9f2b31$var$yg; a;)a = $9af1097fda9f2b31$var$Lf(a.nextSibling);
}
function $9af1097fda9f2b31$var$Ig() {
    $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$xg = null;
    $9af1097fda9f2b31$var$I = !1;
}
function $9af1097fda9f2b31$var$Jg(a) {
    null === $9af1097fda9f2b31$var$zg ? $9af1097fda9f2b31$var$zg = [
        a
    ] : $9af1097fda9f2b31$var$zg.push(a);
}
var $9af1097fda9f2b31$var$Kg = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig;
function $9af1097fda9f2b31$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9af1097fda9f2b31$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9af1097fda9f2b31$var$Mg = $9af1097fda9f2b31$var$Uf(null), $9af1097fda9f2b31$var$Ng = null, $9af1097fda9f2b31$var$Og = null, $9af1097fda9f2b31$var$Pg = null;
function $9af1097fda9f2b31$var$Qg() {
    $9af1097fda9f2b31$var$Pg = $9af1097fda9f2b31$var$Og = $9af1097fda9f2b31$var$Ng = null;
}
function $9af1097fda9f2b31$var$Rg(a) {
    var b = $9af1097fda9f2b31$var$Mg.current;
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Mg);
    a._currentValue = b;
}
function $9af1097fda9f2b31$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a["return"];
    }
}
function $9af1097fda9f2b31$var$Tg(a, b) {
    $9af1097fda9f2b31$var$Ng = a;
    $9af1097fda9f2b31$var$Pg = $9af1097fda9f2b31$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9af1097fda9f2b31$var$Ug = !0), a.firstContext = null);
}
function $9af1097fda9f2b31$var$Vg(a) {
    var b = a._currentValue;
    if ($9af1097fda9f2b31$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9af1097fda9f2b31$var$Og) {
            if (null === $9af1097fda9f2b31$var$Ng) throw Error($9af1097fda9f2b31$var$p(308));
            $9af1097fda9f2b31$var$Og = a;
            $9af1097fda9f2b31$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9af1097fda9f2b31$var$Og = $9af1097fda9f2b31$var$Og.next = a;
    }
    return b;
}
var $9af1097fda9f2b31$var$Wg = null;
function $9af1097fda9f2b31$var$Xg(a) {
    null === $9af1097fda9f2b31$var$Wg ? $9af1097fda9f2b31$var$Wg = [
        a
    ] : $9af1097fda9f2b31$var$Wg.push(a);
}
function $9af1097fda9f2b31$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9af1097fda9f2b31$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9af1097fda9f2b31$var$Zg(a, d);
}
function $9af1097fda9f2b31$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a["return"]; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a["return"];
    return 3 === c.tag ? c.stateNode : null;
}
var $9af1097fda9f2b31$var$$g = !1;
function $9af1097fda9f2b31$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9af1097fda9f2b31$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9af1097fda9f2b31$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9af1097fda9f2b31$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9af1097fda9f2b31$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9af1097fda9f2b31$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9af1097fda9f2b31$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9af1097fda9f2b31$var$Zg(a, c);
}
function $9af1097fda9f2b31$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9af1097fda9f2b31$var$Cc(a, c);
    }
}
function $9af1097fda9f2b31$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9af1097fda9f2b31$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9af1097fda9f2b31$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9af1097fda9f2b31$var$A({}, q, r);
                            break a;
                        case 2:
                            $9af1097fda9f2b31$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9af1097fda9f2b31$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9af1097fda9f2b31$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9af1097fda9f2b31$var$p(191, e));
            e.call(d);
        }
    }
}
var $9af1097fda9f2b31$var$jh = (new $3aC2T.Component).refs;
function $9af1097fda9f2b31$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9af1097fda9f2b31$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9af1097fda9f2b31$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $9af1097fda9f2b31$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $9af1097fda9f2b31$var$L(), e = $9af1097fda9f2b31$var$lh(a), f = $9af1097fda9f2b31$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9af1097fda9f2b31$var$dh(a, f, e);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, e, d), $9af1097fda9f2b31$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $9af1097fda9f2b31$var$L(), e = $9af1097fda9f2b31$var$lh(a), f = $9af1097fda9f2b31$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9af1097fda9f2b31$var$dh(a, f, e);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, e, d), $9af1097fda9f2b31$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $9af1097fda9f2b31$var$L(), d = $9af1097fda9f2b31$var$lh(a), e = $9af1097fda9f2b31$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9af1097fda9f2b31$var$dh(a, e, d);
        null !== b && ($9af1097fda9f2b31$var$mh(b, a, d, c), $9af1097fda9f2b31$var$eh(b, a, d));
    }
};
function $9af1097fda9f2b31$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9af1097fda9f2b31$var$Ie(c, d) || !$9af1097fda9f2b31$var$Ie(e, f) : !0;
}
function $9af1097fda9f2b31$var$ph(a, b, c) {
    var d = !1, e = $9af1097fda9f2b31$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9af1097fda9f2b31$var$Vg(f) : (e = $9af1097fda9f2b31$var$Zf(b) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9af1097fda9f2b31$var$Yf(a, e) : $9af1097fda9f2b31$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9af1097fda9f2b31$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9af1097fda9f2b31$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9af1097fda9f2b31$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9af1097fda9f2b31$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9af1097fda9f2b31$var$jh;
    $9af1097fda9f2b31$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9af1097fda9f2b31$var$Vg(f) : (f = $9af1097fda9f2b31$var$Zf(b) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, e.context = $9af1097fda9f2b31$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9af1097fda9f2b31$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9af1097fda9f2b31$var$nh.enqueueReplaceState(e, e.state, null), $9af1097fda9f2b31$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9af1097fda9f2b31$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9af1097fda9f2b31$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9af1097fda9f2b31$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $9af1097fda9f2b31$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9af1097fda9f2b31$var$p(284));
        if (!c._owner) throw Error($9af1097fda9f2b31$var$p(290, a));
    }
    return a;
}
function $9af1097fda9f2b31$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9af1097fda9f2b31$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9af1097fda9f2b31$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9af1097fda9f2b31$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9af1097fda9f2b31$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9af1097fda9f2b31$var$xh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9af1097fda9f2b31$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9af1097fda9f2b31$var$Ha && $9af1097fda9f2b31$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9af1097fda9f2b31$var$sh(a, b, c), d["return"] = a, d;
        d = $9af1097fda9f2b31$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9af1097fda9f2b31$var$sh(a, b, c);
        d["return"] = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9af1097fda9f2b31$var$zh(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9af1097fda9f2b31$var$Ah(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9af1097fda9f2b31$var$xh("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return c = $9af1097fda9f2b31$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9af1097fda9f2b31$var$sh(a, null, b), c["return"] = a, c;
                case $9af1097fda9f2b31$var$wa:
                    return b = $9af1097fda9f2b31$var$zh(b, a.mode, c), b["return"] = a, b;
                case $9af1097fda9f2b31$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9af1097fda9f2b31$var$eb(b) || $9af1097fda9f2b31$var$Ka(b)) return b = $9af1097fda9f2b31$var$Ah(b, a.mode, c, null), b["return"] = a, b;
            $9af1097fda9f2b31$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9af1097fda9f2b31$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9af1097fda9f2b31$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9af1097fda9f2b31$var$eb(c) || $9af1097fda9f2b31$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9af1097fda9f2b31$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9af1097fda9f2b31$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9af1097fda9f2b31$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9af1097fda9f2b31$var$eb(d) || $9af1097fda9f2b31$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9af1097fda9f2b31$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u["delete"](null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9af1097fda9f2b31$var$Ka(h);
        if ("function" !== typeof l) throw Error($9af1097fda9f2b31$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9af1097fda9f2b31$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m["delete"](null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9af1097fda9f2b31$var$I && $9af1097fda9f2b31$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9af1097fda9f2b31$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9af1097fda9f2b31$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9af1097fda9f2b31$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9af1097fda9f2b31$var$Ha && $9af1097fda9f2b31$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9af1097fda9f2b31$var$sh(a, l, f);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9af1097fda9f2b31$var$ya ? (d = $9af1097fda9f2b31$var$Ah(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = $9af1097fda9f2b31$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9af1097fda9f2b31$var$sh(a, d, f), h["return"] = a, a = h);
                    }
                    return g(a);
                case $9af1097fda9f2b31$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d["return"] = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9af1097fda9f2b31$var$zh(f, a.mode, h);
                        d["return"] = a;
                        a = d;
                    }
                    return g(a);
                case $9af1097fda9f2b31$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9af1097fda9f2b31$var$eb(f)) return n(a, d, f, h);
            if ($9af1097fda9f2b31$var$Ka(f)) return t(a, d, f, h);
            $9af1097fda9f2b31$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = $9af1097fda9f2b31$var$xh(f, a.mode, h), d["return"] = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9af1097fda9f2b31$var$Bh = $9af1097fda9f2b31$var$vh(!0), $9af1097fda9f2b31$var$Ch = $9af1097fda9f2b31$var$vh(!1), $9af1097fda9f2b31$var$Dh = {}, $9af1097fda9f2b31$var$Eh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh), $9af1097fda9f2b31$var$Fh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh), $9af1097fda9f2b31$var$Gh = $9af1097fda9f2b31$var$Uf($9af1097fda9f2b31$var$Dh);
function $9af1097fda9f2b31$var$Hh(a) {
    if (a === $9af1097fda9f2b31$var$Dh) throw Error($9af1097fda9f2b31$var$p(174));
    return a;
}
function $9af1097fda9f2b31$var$Ih(a, b) {
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Gh, b);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Fh, a);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, $9af1097fda9f2b31$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9af1097fda9f2b31$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9af1097fda9f2b31$var$lb(b, a);
    }
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh);
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, b);
}
function $9af1097fda9f2b31$var$Jh() {
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Fh);
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Gh);
}
function $9af1097fda9f2b31$var$Kh(a) {
    $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
    var b = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
    var c = $9af1097fda9f2b31$var$lb(b, a.type);
    b !== c && ($9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Fh, a), $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Eh, c));
}
function $9af1097fda9f2b31$var$Lh(a) {
    $9af1097fda9f2b31$var$Fh.current === a && ($9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Eh), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Fh));
}
var $9af1097fda9f2b31$var$M = $9af1097fda9f2b31$var$Uf(0);
function $9af1097fda9f2b31$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
var $9af1097fda9f2b31$var$Nh = [];
function $9af1097fda9f2b31$var$Oh() {
    for(var a = 0; a < $9af1097fda9f2b31$var$Nh.length; a++)$9af1097fda9f2b31$var$Nh[a]._workInProgressVersionPrimary = null;
    $9af1097fda9f2b31$var$Nh.length = 0;
}
var $9af1097fda9f2b31$var$Ph = $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher, $9af1097fda9f2b31$var$Qh = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$Rh = 0, $9af1097fda9f2b31$var$N = null, $9af1097fda9f2b31$var$O = null, $9af1097fda9f2b31$var$P = null, $9af1097fda9f2b31$var$Sh = !1, $9af1097fda9f2b31$var$Th = !1, $9af1097fda9f2b31$var$Uh = 0, $9af1097fda9f2b31$var$Vh = 0;
function $9af1097fda9f2b31$var$Q() {
    throw Error($9af1097fda9f2b31$var$p(321));
}
function $9af1097fda9f2b31$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9af1097fda9f2b31$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9af1097fda9f2b31$var$Xh(a, b, c, d, e, f) {
    $9af1097fda9f2b31$var$Rh = f;
    $9af1097fda9f2b31$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9af1097fda9f2b31$var$Ph.current = null === a || null === a.memoizedState ? $9af1097fda9f2b31$var$Yh : $9af1097fda9f2b31$var$Zh;
    a = c(d, e);
    if ($9af1097fda9f2b31$var$Th) {
        f = 0;
        do {
            $9af1097fda9f2b31$var$Th = !1;
            $9af1097fda9f2b31$var$Uh = 0;
            if (25 <= f) throw Error($9af1097fda9f2b31$var$p(301));
            f += 1;
            $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = null;
            b.updateQueue = null;
            $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$$h;
            a = c(d, e);
        }while ($9af1097fda9f2b31$var$Th);
    }
    $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$ai;
    b = null !== $9af1097fda9f2b31$var$O && null !== $9af1097fda9f2b31$var$O.next;
    $9af1097fda9f2b31$var$Rh = 0;
    $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = $9af1097fda9f2b31$var$N = null;
    $9af1097fda9f2b31$var$Sh = !1;
    if (b) throw Error($9af1097fda9f2b31$var$p(300));
    return a;
}
function $9af1097fda9f2b31$var$bi() {
    var a = 0 !== $9af1097fda9f2b31$var$Uh;
    $9af1097fda9f2b31$var$Uh = 0;
    return a;
}
function $9af1097fda9f2b31$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState = $9af1097fda9f2b31$var$P = a : $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$P.next = a;
    return $9af1097fda9f2b31$var$P;
}
function $9af1097fda9f2b31$var$di() {
    if (null === $9af1097fda9f2b31$var$O) {
        var a = $9af1097fda9f2b31$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9af1097fda9f2b31$var$O.next;
    var b = null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState : $9af1097fda9f2b31$var$P.next;
    if (null !== b) $9af1097fda9f2b31$var$P = b, $9af1097fda9f2b31$var$O = a;
    else {
        if (null === a) throw Error($9af1097fda9f2b31$var$p(310));
        $9af1097fda9f2b31$var$O = a;
        a = {
            memoizedState: $9af1097fda9f2b31$var$O.memoizedState,
            baseState: $9af1097fda9f2b31$var$O.baseState,
            baseQueue: $9af1097fda9f2b31$var$O.baseQueue,
            queue: $9af1097fda9f2b31$var$O.queue,
            next: null
        };
        null === $9af1097fda9f2b31$var$P ? $9af1097fda9f2b31$var$N.memoizedState = $9af1097fda9f2b31$var$P = a : $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$P.next = a;
    }
    return $9af1097fda9f2b31$var$P;
}
function $9af1097fda9f2b31$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9af1097fda9f2b31$var$fi(a) {
    var b = $9af1097fda9f2b31$var$di(), c = b.queue;
    if (null === c) throw Error($9af1097fda9f2b31$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9af1097fda9f2b31$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9af1097fda9f2b31$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9af1097fda9f2b31$var$N.lanes |= m;
                $9af1097fda9f2b31$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9af1097fda9f2b31$var$He(d, b.memoizedState) || ($9af1097fda9f2b31$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9af1097fda9f2b31$var$N.lanes |= f, $9af1097fda9f2b31$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9af1097fda9f2b31$var$gi(a) {
    var b = $9af1097fda9f2b31$var$di(), c = b.queue;
    if (null === c) throw Error($9af1097fda9f2b31$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9af1097fda9f2b31$var$He(f, b.memoizedState) || ($9af1097fda9f2b31$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9af1097fda9f2b31$var$hi() {}
function $9af1097fda9f2b31$var$ii(a, b) {
    var c = $9af1097fda9f2b31$var$N, d = $9af1097fda9f2b31$var$di(), e = b(), f = !$9af1097fda9f2b31$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9af1097fda9f2b31$var$Ug = !0);
    d = d.queue;
    $9af1097fda9f2b31$var$ji($9af1097fda9f2b31$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9af1097fda9f2b31$var$P && $9af1097fda9f2b31$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9af1097fda9f2b31$var$li(9, $9af1097fda9f2b31$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9af1097fda9f2b31$var$R) throw Error($9af1097fda9f2b31$var$p(349));
        0 !== ($9af1097fda9f2b31$var$Rh & 30) || $9af1097fda9f2b31$var$ni(c, b, e);
    }
    return e;
}
function $9af1097fda9f2b31$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9af1097fda9f2b31$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9af1097fda9f2b31$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9af1097fda9f2b31$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9af1097fda9f2b31$var$oi(b) && $9af1097fda9f2b31$var$pi(a);
}
function $9af1097fda9f2b31$var$ki(a, b, c) {
    return c(function() {
        $9af1097fda9f2b31$var$oi(b) && $9af1097fda9f2b31$var$pi(a);
    });
}
function $9af1097fda9f2b31$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9af1097fda9f2b31$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9af1097fda9f2b31$var$pi(a) {
    var b = $9af1097fda9f2b31$var$Zg(a, 1);
    null !== b && $9af1097fda9f2b31$var$mh(b, a, 1, -1);
}
function $9af1097fda9f2b31$var$qi(a) {
    var b = $9af1097fda9f2b31$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9af1097fda9f2b31$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9af1097fda9f2b31$var$ri.bind(null, $9af1097fda9f2b31$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9af1097fda9f2b31$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9af1097fda9f2b31$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9af1097fda9f2b31$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9af1097fda9f2b31$var$si() {
    return $9af1097fda9f2b31$var$di().memoizedState;
}
function $9af1097fda9f2b31$var$ti(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$ci();
    $9af1097fda9f2b31$var$N.flags |= a;
    e.memoizedState = $9af1097fda9f2b31$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9af1097fda9f2b31$var$ui(a, b, c, d) {
    var e = $9af1097fda9f2b31$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9af1097fda9f2b31$var$O) {
        var g = $9af1097fda9f2b31$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9af1097fda9f2b31$var$Wh(d, g.deps)) {
            e.memoizedState = $9af1097fda9f2b31$var$li(b, c, f, d);
            return;
        }
    }
    $9af1097fda9f2b31$var$N.flags |= a;
    e.memoizedState = $9af1097fda9f2b31$var$li(1 | b, c, f, d);
}
function $9af1097fda9f2b31$var$vi(a, b) {
    return $9af1097fda9f2b31$var$ti(8390656, 8, a, b);
}
function $9af1097fda9f2b31$var$ji(a, b) {
    return $9af1097fda9f2b31$var$ui(2048, 8, a, b);
}
function $9af1097fda9f2b31$var$wi(a, b) {
    return $9af1097fda9f2b31$var$ui(4, 2, a, b);
}
function $9af1097fda9f2b31$var$xi(a, b) {
    return $9af1097fda9f2b31$var$ui(4, 4, a, b);
}
function $9af1097fda9f2b31$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9af1097fda9f2b31$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9af1097fda9f2b31$var$ui(4, 4, $9af1097fda9f2b31$var$yi.bind(null, b, a), c);
}
function $9af1097fda9f2b31$var$Ai() {}
function $9af1097fda9f2b31$var$Bi(a, b) {
    var c = $9af1097fda9f2b31$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9af1097fda9f2b31$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9af1097fda9f2b31$var$Ci(a, b) {
    var c = $9af1097fda9f2b31$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9af1097fda9f2b31$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9af1097fda9f2b31$var$Di(a, b, c) {
    if (0 === ($9af1097fda9f2b31$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9af1097fda9f2b31$var$Ug = !0), a.memoizedState = c;
    $9af1097fda9f2b31$var$He(c, b) || (c = $9af1097fda9f2b31$var$yc(), $9af1097fda9f2b31$var$N.lanes |= c, $9af1097fda9f2b31$var$hh |= c, a.baseState = !0);
    return b;
}
function $9af1097fda9f2b31$var$Ei(a, b) {
    var c = $9af1097fda9f2b31$var$C;
    $9af1097fda9f2b31$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9af1097fda9f2b31$var$Qh.transition;
    $9af1097fda9f2b31$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9af1097fda9f2b31$var$C = c, $9af1097fda9f2b31$var$Qh.transition = d;
    }
}
function $9af1097fda9f2b31$var$Fi() {
    return $9af1097fda9f2b31$var$di().memoizedState;
}
function $9af1097fda9f2b31$var$Gi(a, b, c) {
    var d = $9af1097fda9f2b31$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9af1097fda9f2b31$var$Hi(a)) $9af1097fda9f2b31$var$Ii(b, c);
    else if (c = $9af1097fda9f2b31$var$Yg(a, b, c, d), null !== c) {
        var e = $9af1097fda9f2b31$var$L();
        $9af1097fda9f2b31$var$mh(c, a, d, e);
        $9af1097fda9f2b31$var$Ji(c, b, d);
    }
}
function $9af1097fda9f2b31$var$ri(a, b, c) {
    var d = $9af1097fda9f2b31$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9af1097fda9f2b31$var$Hi(a)) $9af1097fda9f2b31$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9af1097fda9f2b31$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9af1097fda9f2b31$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9af1097fda9f2b31$var$Yg(a, b, e, d);
        null !== c && (e = $9af1097fda9f2b31$var$L(), $9af1097fda9f2b31$var$mh(c, a, d, e), $9af1097fda9f2b31$var$Ji(c, b, d));
    }
}
function $9af1097fda9f2b31$var$Hi(a) {
    var b = a.alternate;
    return a === $9af1097fda9f2b31$var$N || null !== b && b === $9af1097fda9f2b31$var$N;
}
function $9af1097fda9f2b31$var$Ii(a, b) {
    $9af1097fda9f2b31$var$Th = $9af1097fda9f2b31$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9af1097fda9f2b31$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9af1097fda9f2b31$var$Cc(a, c);
    }
}
var $9af1097fda9f2b31$var$ai = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Q,
    useContext: $9af1097fda9f2b31$var$Q,
    useEffect: $9af1097fda9f2b31$var$Q,
    useImperativeHandle: $9af1097fda9f2b31$var$Q,
    useInsertionEffect: $9af1097fda9f2b31$var$Q,
    useLayoutEffect: $9af1097fda9f2b31$var$Q,
    useMemo: $9af1097fda9f2b31$var$Q,
    useReducer: $9af1097fda9f2b31$var$Q,
    useRef: $9af1097fda9f2b31$var$Q,
    useState: $9af1097fda9f2b31$var$Q,
    useDebugValue: $9af1097fda9f2b31$var$Q,
    useDeferredValue: $9af1097fda9f2b31$var$Q,
    useTransition: $9af1097fda9f2b31$var$Q,
    useMutableSource: $9af1097fda9f2b31$var$Q,
    useSyncExternalStore: $9af1097fda9f2b31$var$Q,
    useId: $9af1097fda9f2b31$var$Q,
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$Yh = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: function useCallback(a, b) {
        $9af1097fda9f2b31$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9af1097fda9f2b31$var$ti(4194308, 4, $9af1097fda9f2b31$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $9af1097fda9f2b31$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $9af1097fda9f2b31$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $9af1097fda9f2b31$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $9af1097fda9f2b31$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9af1097fda9f2b31$var$Gi.bind(null, $9af1097fda9f2b31$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $9af1097fda9f2b31$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9af1097fda9f2b31$var$qi,
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $9af1097fda9f2b31$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$qi(!1), b = a[0];
        a = $9af1097fda9f2b31$var$Ei.bind(null, a[1]);
        $9af1097fda9f2b31$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $9af1097fda9f2b31$var$N, e = $9af1097fda9f2b31$var$ci();
        if ($9af1097fda9f2b31$var$I) {
            if (void 0 === c) throw Error($9af1097fda9f2b31$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9af1097fda9f2b31$var$R) throw Error($9af1097fda9f2b31$var$p(349));
            0 !== ($9af1097fda9f2b31$var$Rh & 30) || $9af1097fda9f2b31$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9af1097fda9f2b31$var$vi($9af1097fda9f2b31$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9af1097fda9f2b31$var$li(9, $9af1097fda9f2b31$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $9af1097fda9f2b31$var$ci(), b = $9af1097fda9f2b31$var$R.identifierPrefix;
        if ($9af1097fda9f2b31$var$I) {
            var c = $9af1097fda9f2b31$var$sg;
            var d = $9af1097fda9f2b31$var$rg;
            c = (d & ~(1 << 32 - $9af1097fda9f2b31$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9af1097fda9f2b31$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9af1097fda9f2b31$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$Zh = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Bi,
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$ji,
    useImperativeHandle: $9af1097fda9f2b31$var$zi,
    useInsertionEffect: $9af1097fda9f2b31$var$wi,
    useLayoutEffect: $9af1097fda9f2b31$var$xi,
    useMemo: $9af1097fda9f2b31$var$Ci,
    useReducer: $9af1097fda9f2b31$var$fi,
    useRef: $9af1097fda9f2b31$var$si,
    useState: function useState() {
        return $9af1097fda9f2b31$var$fi($9af1097fda9f2b31$var$ei);
    },
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $9af1097fda9f2b31$var$di();
        return $9af1097fda9f2b31$var$Di(b, $9af1097fda9f2b31$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$fi($9af1097fda9f2b31$var$ei)[0], b = $9af1097fda9f2b31$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9af1097fda9f2b31$var$hi,
    useSyncExternalStore: $9af1097fda9f2b31$var$ii,
    useId: $9af1097fda9f2b31$var$Fi,
    unstable_isNewReconciler: !1
}, $9af1097fda9f2b31$var$$h = {
    readContext: $9af1097fda9f2b31$var$Vg,
    useCallback: $9af1097fda9f2b31$var$Bi,
    useContext: $9af1097fda9f2b31$var$Vg,
    useEffect: $9af1097fda9f2b31$var$ji,
    useImperativeHandle: $9af1097fda9f2b31$var$zi,
    useInsertionEffect: $9af1097fda9f2b31$var$wi,
    useLayoutEffect: $9af1097fda9f2b31$var$xi,
    useMemo: $9af1097fda9f2b31$var$Ci,
    useReducer: $9af1097fda9f2b31$var$gi,
    useRef: $9af1097fda9f2b31$var$si,
    useState: function useState() {
        return $9af1097fda9f2b31$var$gi($9af1097fda9f2b31$var$ei);
    },
    useDebugValue: $9af1097fda9f2b31$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $9af1097fda9f2b31$var$di();
        return null === $9af1097fda9f2b31$var$O ? b.memoizedState = a : $9af1097fda9f2b31$var$Di(b, $9af1097fda9f2b31$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $9af1097fda9f2b31$var$gi($9af1097fda9f2b31$var$ei)[0], b = $9af1097fda9f2b31$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9af1097fda9f2b31$var$hi,
    useSyncExternalStore: $9af1097fda9f2b31$var$ii,
    useId: $9af1097fda9f2b31$var$Fi,
    unstable_isNewReconciler: !1
};
function $9af1097fda9f2b31$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9af1097fda9f2b31$var$Pa(d), d = d["return"];
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9af1097fda9f2b31$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9af1097fda9f2b31$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9af1097fda9f2b31$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9af1097fda9f2b31$var$Oi(a, b, c) {
    c = $9af1097fda9f2b31$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9af1097fda9f2b31$var$Pi || ($9af1097fda9f2b31$var$Pi = !0, $9af1097fda9f2b31$var$Qi = d);
        $9af1097fda9f2b31$var$Mi(a, b);
    };
    return c;
}
function $9af1097fda9f2b31$var$Ri(a, b, c) {
    c = $9af1097fda9f2b31$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9af1097fda9f2b31$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9af1097fda9f2b31$var$Mi(a, b);
        "function" !== typeof d && (null === $9af1097fda9f2b31$var$Si ? $9af1097fda9f2b31$var$Si = new Set([
            this
        ]) : $9af1097fda9f2b31$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $9af1097fda9f2b31$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9af1097fda9f2b31$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9af1097fda9f2b31$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9af1097fda9f2b31$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a["return"];
    }while (null !== a);
    return null;
}
function $9af1097fda9f2b31$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9af1097fda9f2b31$var$ch(-1, 1), b.tag = 2, $9af1097fda9f2b31$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9af1097fda9f2b31$var$Xi = $9af1097fda9f2b31$var$ua.ReactCurrentOwner, $9af1097fda9f2b31$var$Ug = !1;
function $9af1097fda9f2b31$var$Yi(a, b, c, d) {
    b.child = null === a ? $9af1097fda9f2b31$var$Ch(b, null, c, d) : $9af1097fda9f2b31$var$Bh(b, a.child, c, d);
}
function $9af1097fda9f2b31$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9af1097fda9f2b31$var$Tg(b, e);
    d = $9af1097fda9f2b31$var$Xh(a, b, c, d, f, e);
    c = $9af1097fda9f2b31$var$bi();
    if (null !== a && !$9af1097fda9f2b31$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9af1097fda9f2b31$var$$i(a, b, e);
    $9af1097fda9f2b31$var$I && c && $9af1097fda9f2b31$var$vg(b);
    b.flags |= 1;
    $9af1097fda9f2b31$var$Yi(a, b, d, e);
    return b.child;
}
function $9af1097fda9f2b31$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9af1097fda9f2b31$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9af1097fda9f2b31$var$cj(a, b, f, d, e);
        a = $9af1097fda9f2b31$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9af1097fda9f2b31$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9af1097fda9f2b31$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9af1097fda9f2b31$var$wh(f, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function $9af1097fda9f2b31$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9af1097fda9f2b31$var$Ie(f, d) && a.ref === b.ref) {
            if ($9af1097fda9f2b31$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9af1097fda9f2b31$var$Ug = !0);
            else return b.lanes = a.lanes, $9af1097fda9f2b31$var$$i(a, b, e);
        }
    }
    return $9af1097fda9f2b31$var$dj(a, b, c, d, e);
}
function $9af1097fda9f2b31$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj);
            $9af1097fda9f2b31$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$fj, $9af1097fda9f2b31$var$gj), $9af1097fda9f2b31$var$gj |= d;
    $9af1097fda9f2b31$var$Yi(a, b, e, c);
    return b.child;
}
function $9af1097fda9f2b31$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9af1097fda9f2b31$var$dj(a, b, c, d, e) {
    var f = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current;
    f = $9af1097fda9f2b31$var$Yf(b, f);
    $9af1097fda9f2b31$var$Tg(b, e);
    c = $9af1097fda9f2b31$var$Xh(a, b, c, d, f, e);
    d = $9af1097fda9f2b31$var$bi();
    if (null !== a && !$9af1097fda9f2b31$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9af1097fda9f2b31$var$$i(a, b, e);
    $9af1097fda9f2b31$var$I && d && $9af1097fda9f2b31$var$vg(b);
    b.flags |= 1;
    $9af1097fda9f2b31$var$Yi(a, b, c, e);
    return b.child;
}
function $9af1097fda9f2b31$var$ij(a, b, c, d, e) {
    if ($9af1097fda9f2b31$var$Zf(c)) {
        var f = !0;
        $9af1097fda9f2b31$var$cg(b);
    } else f = !1;
    $9af1097fda9f2b31$var$Tg(b, e);
    if (null === b.stateNode) $9af1097fda9f2b31$var$jj(a, b), $9af1097fda9f2b31$var$ph(b, c, d), $9af1097fda9f2b31$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9af1097fda9f2b31$var$Vg(l) : (l = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, l = $9af1097fda9f2b31$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9af1097fda9f2b31$var$qh(b, g, d, l);
        $9af1097fda9f2b31$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9af1097fda9f2b31$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9af1097fda9f2b31$var$Wf.current || $9af1097fda9f2b31$var$$g ? ("function" === typeof m && ($9af1097fda9f2b31$var$kh(b, c, m, d), k = b.memoizedState), (h = $9af1097fda9f2b31$var$$g || $9af1097fda9f2b31$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9af1097fda9f2b31$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9af1097fda9f2b31$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9af1097fda9f2b31$var$Vg(k) : (k = $9af1097fda9f2b31$var$Zf(c) ? $9af1097fda9f2b31$var$Xf : $9af1097fda9f2b31$var$H.current, k = $9af1097fda9f2b31$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9af1097fda9f2b31$var$qh(b, g, d, k);
        $9af1097fda9f2b31$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9af1097fda9f2b31$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9af1097fda9f2b31$var$Wf.current || $9af1097fda9f2b31$var$$g ? ("function" === typeof y && ($9af1097fda9f2b31$var$kh(b, c, y, d), n = b.memoizedState), (l = $9af1097fda9f2b31$var$$g || $9af1097fda9f2b31$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9af1097fda9f2b31$var$kj(a, b, c, d, f, e);
}
function $9af1097fda9f2b31$var$kj(a, b, c, d, e, f) {
    $9af1097fda9f2b31$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9af1097fda9f2b31$var$dg(b, c, !1), $9af1097fda9f2b31$var$$i(a, b, f);
    d = b.stateNode;
    $9af1097fda9f2b31$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9af1097fda9f2b31$var$Bh(b, a.child, null, f), b.child = $9af1097fda9f2b31$var$Bh(b, null, h, f)) : $9af1097fda9f2b31$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9af1097fda9f2b31$var$dg(b, c, !0);
    return b.child;
}
function $9af1097fda9f2b31$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9af1097fda9f2b31$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9af1097fda9f2b31$var$ag(a, b.context, !1);
    $9af1097fda9f2b31$var$Ih(a, b.containerInfo);
}
function $9af1097fda9f2b31$var$mj(a, b, c, d, e) {
    $9af1097fda9f2b31$var$Ig();
    $9af1097fda9f2b31$var$Jg(e);
    b.flags |= 256;
    $9af1097fda9f2b31$var$Yi(a, b, c, d);
    return b.child;
}
var $9af1097fda9f2b31$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9af1097fda9f2b31$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9af1097fda9f2b31$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9af1097fda9f2b31$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, e & 1);
    if (null === a) {
        $9af1097fda9f2b31$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9af1097fda9f2b31$var$qj(g, d, 0, null), a = $9af1097fda9f2b31$var$Ah(a, d, c, null), f["return"] = b, a["return"] = b, f.sibling = a, b.child = f, b.child.memoizedState = $9af1097fda9f2b31$var$oj(c), b.memoizedState = $9af1097fda9f2b31$var$nj, a) : $9af1097fda9f2b31$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9af1097fda9f2b31$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9af1097fda9f2b31$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9af1097fda9f2b31$var$wh(h, f) : (f = $9af1097fda9f2b31$var$Ah(f, g, c, null), f.flags |= 2);
        f["return"] = b;
        d["return"] = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9af1097fda9f2b31$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9af1097fda9f2b31$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9af1097fda9f2b31$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d["return"] = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9af1097fda9f2b31$var$rj(a, b) {
    b = $9af1097fda9f2b31$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b["return"] = a;
    return a.child = b;
}
function $9af1097fda9f2b31$var$tj(a, b, c, d) {
    null !== d && $9af1097fda9f2b31$var$Jg(d);
    $9af1097fda9f2b31$var$Bh(b, a.child, null, c);
    a = $9af1097fda9f2b31$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9af1097fda9f2b31$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9af1097fda9f2b31$var$Li(Error($9af1097fda9f2b31$var$p(422))), $9af1097fda9f2b31$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9af1097fda9f2b31$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9af1097fda9f2b31$var$Ah(f, e, g, null);
        f.flags |= 2;
        d["return"] = b;
        f["return"] = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9af1097fda9f2b31$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9af1097fda9f2b31$var$oj(g);
        b.memoizedState = $9af1097fda9f2b31$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9af1097fda9f2b31$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9af1097fda9f2b31$var$p(419));
        d = $9af1097fda9f2b31$var$Li(f, d, void 0);
        return $9af1097fda9f2b31$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9af1097fda9f2b31$var$Ug || h) {
        d = $9af1097fda9f2b31$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9af1097fda9f2b31$var$Zg(a, e), $9af1097fda9f2b31$var$mh(d, a, e, -1));
        }
        $9af1097fda9f2b31$var$uj();
        d = $9af1097fda9f2b31$var$Li(Error($9af1097fda9f2b31$var$p(421)));
        return $9af1097fda9f2b31$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9af1097fda9f2b31$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(e.nextSibling);
    $9af1097fda9f2b31$var$xg = b;
    $9af1097fda9f2b31$var$I = !0;
    $9af1097fda9f2b31$var$zg = null;
    null !== a && ($9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$rg, $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$sg, $9af1097fda9f2b31$var$og[$9af1097fda9f2b31$var$pg++] = $9af1097fda9f2b31$var$qg, $9af1097fda9f2b31$var$rg = a.id, $9af1097fda9f2b31$var$sg = a.overflow, $9af1097fda9f2b31$var$qg = b);
    b = $9af1097fda9f2b31$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9af1097fda9f2b31$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9af1097fda9f2b31$var$Sg(a["return"], b, c);
}
function $9af1097fda9f2b31$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9af1097fda9f2b31$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9af1097fda9f2b31$var$Yi(a, b, d.children, c);
    d = $9af1097fda9f2b31$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9af1097fda9f2b31$var$wj(a, c, b);
            else if (19 === a.tag) $9af1097fda9f2b31$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9af1097fda9f2b31$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9af1097fda9f2b31$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9af1097fda9f2b31$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9af1097fda9f2b31$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9af1097fda9f2b31$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9af1097fda9f2b31$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9af1097fda9f2b31$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9af1097fda9f2b31$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9af1097fda9f2b31$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9af1097fda9f2b31$var$wh(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9af1097fda9f2b31$var$wh(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
function $9af1097fda9f2b31$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9af1097fda9f2b31$var$lj(b);
            $9af1097fda9f2b31$var$Ig();
            break;
        case 5:
            $9af1097fda9f2b31$var$Kh(b);
            break;
        case 1:
            $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$cg(b);
            break;
        case 4:
            $9af1097fda9f2b31$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9af1097fda9f2b31$var$pj(a, b, c);
                $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1);
                a = $9af1097fda9f2b31$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9af1097fda9f2b31$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9af1097fda9f2b31$var$ej(a, b, c);
    }
    return $9af1097fda9f2b31$var$$i(a, b, c);
}
var $9af1097fda9f2b31$var$Aj, $9af1097fda9f2b31$var$Bj, $9af1097fda9f2b31$var$Cj, $9af1097fda9f2b31$var$Dj;
$9af1097fda9f2b31$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
$9af1097fda9f2b31$var$Bj = function Bj() {};
$9af1097fda9f2b31$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9af1097fda9f2b31$var$Ya(a, e);
                d = $9af1097fda9f2b31$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9af1097fda9f2b31$var$A({}, e, {
                    value: void 0
                });
                d = $9af1097fda9f2b31$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9af1097fda9f2b31$var$gb(a, e);
                d = $9af1097fda9f2b31$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9af1097fda9f2b31$var$Bf);
        }
        $9af1097fda9f2b31$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9af1097fda9f2b31$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9af1097fda9f2b31$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9af1097fda9f2b31$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9af1097fda9f2b31$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9af1097fda9f2b31$var$Ej(a, b) {
    if (!$9af1097fda9f2b31$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9af1097fda9f2b31$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e["return"] = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e["return"] = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9af1097fda9f2b31$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9af1097fda9f2b31$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9af1097fda9f2b31$var$S(b), null;
        case 1:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), $9af1097fda9f2b31$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9af1097fda9f2b31$var$Jh();
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
            $9af1097fda9f2b31$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9af1097fda9f2b31$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9af1097fda9f2b31$var$zg && ($9af1097fda9f2b31$var$Gj($9af1097fda9f2b31$var$zg), $9af1097fda9f2b31$var$zg = null));
            $9af1097fda9f2b31$var$Bj(a, b);
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 5:
            $9af1097fda9f2b31$var$Lh(b);
            var e = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9af1097fda9f2b31$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9af1097fda9f2b31$var$p(166));
                    $9af1097fda9f2b31$var$S(b);
                    return null;
                }
                a = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
                if ($9af1097fda9f2b31$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9af1097fda9f2b31$var$Of] = b;
                    d[$9af1097fda9f2b31$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9af1097fda9f2b31$var$D("cancel", d);
                            $9af1097fda9f2b31$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9af1097fda9f2b31$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9af1097fda9f2b31$var$lf.length; e++)$9af1097fda9f2b31$var$D($9af1097fda9f2b31$var$lf[e], d);
                            break;
                        case "source":
                            $9af1097fda9f2b31$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9af1097fda9f2b31$var$D("error", d);
                            $9af1097fda9f2b31$var$D("load", d);
                            break;
                        case "details":
                            $9af1097fda9f2b31$var$D("toggle", d);
                            break;
                        case "input":
                            $9af1097fda9f2b31$var$Za(d, f);
                            $9af1097fda9f2b31$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9af1097fda9f2b31$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$hb(d, f), $9af1097fda9f2b31$var$D("invalid", d);
                    }
                    $9af1097fda9f2b31$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9af1097fda9f2b31$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9af1097fda9f2b31$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9af1097fda9f2b31$var$Va(d);
                            $9af1097fda9f2b31$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$Va(d);
                            $9af1097fda9f2b31$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9af1097fda9f2b31$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9af1097fda9f2b31$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9af1097fda9f2b31$var$Of] = b;
                    a[$9af1097fda9f2b31$var$Pf] = d;
                    $9af1097fda9f2b31$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9af1097fda9f2b31$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9af1097fda9f2b31$var$D("cancel", a);
                                $9af1097fda9f2b31$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9af1097fda9f2b31$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9af1097fda9f2b31$var$lf.length; e++)$9af1097fda9f2b31$var$D($9af1097fda9f2b31$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9af1097fda9f2b31$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9af1097fda9f2b31$var$D("error", a);
                                $9af1097fda9f2b31$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9af1097fda9f2b31$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9af1097fda9f2b31$var$Za(a, d);
                                e = $9af1097fda9f2b31$var$Ya(a, d);
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9af1097fda9f2b31$var$A({}, d, {
                                    value: void 0
                                });
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9af1097fda9f2b31$var$hb(a, d);
                                e = $9af1097fda9f2b31$var$gb(a, d);
                                $9af1097fda9f2b31$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9af1097fda9f2b31$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9af1097fda9f2b31$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9af1097fda9f2b31$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9af1097fda9f2b31$var$ob(a, k) : "number" === typeof k && $9af1097fda9f2b31$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9af1097fda9f2b31$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9af1097fda9f2b31$var$D("scroll", a) : null != k && $9af1097fda9f2b31$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9af1097fda9f2b31$var$Va(a);
                                $9af1097fda9f2b31$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9af1097fda9f2b31$var$Va(a);
                                $9af1097fda9f2b31$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9af1097fda9f2b31$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9af1097fda9f2b31$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9af1097fda9f2b31$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9af1097fda9f2b31$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9af1097fda9f2b31$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9af1097fda9f2b31$var$p(166));
                c = $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Gh.current);
                $9af1097fda9f2b31$var$Hh($9af1097fda9f2b31$var$Eh.current);
                if ($9af1097fda9f2b31$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9af1097fda9f2b31$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9af1097fda9f2b31$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9af1097fda9f2b31$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9af1097fda9f2b31$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9af1097fda9f2b31$var$Of] = b, b.stateNode = d;
            }
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 13:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9af1097fda9f2b31$var$I && null !== $9af1097fda9f2b31$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9af1097fda9f2b31$var$Hg(), $9af1097fda9f2b31$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9af1097fda9f2b31$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9af1097fda9f2b31$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9af1097fda9f2b31$var$p(317));
                        f[$9af1097fda9f2b31$var$Of] = b;
                    } else $9af1097fda9f2b31$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9af1097fda9f2b31$var$S(b);
                    f = !1;
                } else null !== $9af1097fda9f2b31$var$zg && ($9af1097fda9f2b31$var$Gj($9af1097fda9f2b31$var$zg), $9af1097fda9f2b31$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9af1097fda9f2b31$var$M.current & 1) ? 0 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 3) : $9af1097fda9f2b31$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 4:
            return $9af1097fda9f2b31$var$Jh(), $9af1097fda9f2b31$var$Bj(a, b), null === a && $9af1097fda9f2b31$var$sf(b.stateNode.containerInfo), $9af1097fda9f2b31$var$S(b), null;
        case 10:
            return $9af1097fda9f2b31$var$Rg(b.type._context), $9af1097fda9f2b31$var$S(b), null;
        case 17:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), $9af1097fda9f2b31$var$S(b), null;
        case 19:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            f = b.memoizedState;
            if (null === f) return $9af1097fda9f2b31$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9af1097fda9f2b31$var$Ej(f, !1);
                else {
                    if (0 !== $9af1097fda9f2b31$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9af1097fda9f2b31$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9af1097fda9f2b31$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, $9af1097fda9f2b31$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9af1097fda9f2b31$var$B() > $9af1097fda9f2b31$var$Hj && (b.flags |= 128, d = !0, $9af1097fda9f2b31$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9af1097fda9f2b31$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9af1097fda9f2b31$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9af1097fda9f2b31$var$I) return $9af1097fda9f2b31$var$S(b), null;
                    } else 2 * $9af1097fda9f2b31$var$B() - f.renderingStartTime > $9af1097fda9f2b31$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9af1097fda9f2b31$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9af1097fda9f2b31$var$B(), b.sibling = null, c = $9af1097fda9f2b31$var$M.current, $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$M, d ? c & 1 | 2 : c & 1), b;
            $9af1097fda9f2b31$var$S(b);
            return null;
        case 22:
        case 23:
            return $9af1097fda9f2b31$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9af1097fda9f2b31$var$gj & 1073741824) && ($9af1097fda9f2b31$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9af1097fda9f2b31$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9af1097fda9f2b31$var$p(156, b.tag));
}
function $9af1097fda9f2b31$var$Jj(a, b) {
    $9af1097fda9f2b31$var$wg(b);
    switch(b.tag){
        case 1:
            return $9af1097fda9f2b31$var$Zf(b.type) && $9af1097fda9f2b31$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9af1097fda9f2b31$var$Jh(), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf), $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H), $9af1097fda9f2b31$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9af1097fda9f2b31$var$Lh(b), null;
        case 13:
            $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9af1097fda9f2b31$var$p(340));
                $9af1097fda9f2b31$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M), null;
        case 4:
            return $9af1097fda9f2b31$var$Jh(), null;
        case 10:
            return $9af1097fda9f2b31$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9af1097fda9f2b31$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9af1097fda9f2b31$var$Kj = !1, $9af1097fda9f2b31$var$U = !1, $9af1097fda9f2b31$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9af1097fda9f2b31$var$V = null;
function $9af1097fda9f2b31$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9af1097fda9f2b31$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9af1097fda9f2b31$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9af1097fda9f2b31$var$W(a, b, d);
    }
}
var $9af1097fda9f2b31$var$Oj = !1;
function $9af1097fda9f2b31$var$Pj(a, b) {
    $9af1097fda9f2b31$var$Cf = $9af1097fda9f2b31$var$dd;
    a = $9af1097fda9f2b31$var$Me();
    if ($9af1097fda9f2b31$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9af1097fda9f2b31$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9af1097fda9f2b31$var$dd = !1;
    for($9af1097fda9f2b31$var$V = b; null !== $9af1097fda9f2b31$var$V;)if (b = $9af1097fda9f2b31$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a["return"] = b, $9af1097fda9f2b31$var$V = a;
    else for(; null !== $9af1097fda9f2b31$var$V;){
        b = $9af1097fda9f2b31$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9af1097fda9f2b31$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(163));
            }
        } catch (F) {
            $9af1097fda9f2b31$var$W(b, b["return"], F);
        }
        a = b.sibling;
        if (null !== a) {
            a["return"] = b["return"];
            $9af1097fda9f2b31$var$V = a;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
    n = $9af1097fda9f2b31$var$Oj;
    $9af1097fda9f2b31$var$Oj = !1;
    return n;
}
function $9af1097fda9f2b31$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9af1097fda9f2b31$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9af1097fda9f2b31$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9af1097fda9f2b31$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9af1097fda9f2b31$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9af1097fda9f2b31$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9af1097fda9f2b31$var$Of], delete b[$9af1097fda9f2b31$var$Pf], delete b[$9af1097fda9f2b31$var$of], delete b[$9af1097fda9f2b31$var$Qf], delete b[$9af1097fda9f2b31$var$Rf]));
    a.stateNode = null;
    a["return"] = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9af1097fda9f2b31$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9af1097fda9f2b31$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a["return"] || $9af1097fda9f2b31$var$Uj(a["return"])) return null;
            a = a["return"];
        }
        a.sibling["return"] = a["return"];
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child["return"] = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9af1097fda9f2b31$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9af1097fda9f2b31$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9af1097fda9f2b31$var$Wj(a, b, c), a = a.sibling; null !== a;)$9af1097fda9f2b31$var$Wj(a, b, c), a = a.sibling;
}
function $9af1097fda9f2b31$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9af1097fda9f2b31$var$Xj(a, b, c), a = a.sibling; null !== a;)$9af1097fda9f2b31$var$Xj(a, b, c), a = a.sibling;
}
var $9af1097fda9f2b31$var$X = null, $9af1097fda9f2b31$var$Yj = !1;
function $9af1097fda9f2b31$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9af1097fda9f2b31$var$ak(a, b, c), c = c.sibling;
}
function $9af1097fda9f2b31$var$ak(a, b, c) {
    if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onCommitFiberUnmount) try {
        $9af1097fda9f2b31$var$lc.onCommitFiberUnmount($9af1097fda9f2b31$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9af1097fda9f2b31$var$U || $9af1097fda9f2b31$var$Mj(c, b);
        case 6:
            var d = $9af1097fda9f2b31$var$X, e = $9af1097fda9f2b31$var$Yj;
            $9af1097fda9f2b31$var$X = null;
            $9af1097fda9f2b31$var$Zj(a, b, c);
            $9af1097fda9f2b31$var$X = d;
            $9af1097fda9f2b31$var$Yj = e;
            null !== $9af1097fda9f2b31$var$X && ($9af1097fda9f2b31$var$Yj ? (a = $9af1097fda9f2b31$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9af1097fda9f2b31$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9af1097fda9f2b31$var$X && ($9af1097fda9f2b31$var$Yj ? (a = $9af1097fda9f2b31$var$X, c = c.stateNode, 8 === a.nodeType ? $9af1097fda9f2b31$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9af1097fda9f2b31$var$Kf(a, c), $9af1097fda9f2b31$var$bd(a)) : $9af1097fda9f2b31$var$Kf($9af1097fda9f2b31$var$X, c.stateNode));
            break;
        case 4:
            d = $9af1097fda9f2b31$var$X;
            e = $9af1097fda9f2b31$var$Yj;
            $9af1097fda9f2b31$var$X = c.stateNode.containerInfo;
            $9af1097fda9f2b31$var$Yj = !0;
            $9af1097fda9f2b31$var$Zj(a, b, c);
            $9af1097fda9f2b31$var$X = d;
            $9af1097fda9f2b31$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9af1097fda9f2b31$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9af1097fda9f2b31$var$Nj(c, b, g) : 0 !== (f & 4) && $9af1097fda9f2b31$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9af1097fda9f2b31$var$U && ($9af1097fda9f2b31$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9af1097fda9f2b31$var$W(c, b, h);
            }
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 21:
            $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9af1097fda9f2b31$var$U = (d = $9af1097fda9f2b31$var$U) || null !== c.memoizedState, $9af1097fda9f2b31$var$Zj(a, b, c), $9af1097fda9f2b31$var$U = d) : $9af1097fda9f2b31$var$Zj(a, b, c);
            break;
        default:
            $9af1097fda9f2b31$var$Zj(a, b, c);
    }
}
function $9af1097fda9f2b31$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9af1097fda9f2b31$var$Lj);
        b.forEach(function(b) {
            var d = $9af1097fda9f2b31$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9af1097fda9f2b31$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9af1097fda9f2b31$var$X = h.stateNode;
                        $9af1097fda9f2b31$var$Yj = !1;
                        break a;
                    case 3:
                        $9af1097fda9f2b31$var$X = h.stateNode.containerInfo;
                        $9af1097fda9f2b31$var$Yj = !0;
                        break a;
                    case 4:
                        $9af1097fda9f2b31$var$X = h.stateNode.containerInfo;
                        $9af1097fda9f2b31$var$Yj = !0;
                        break a;
                }
                h = h["return"];
            }
            if (null === $9af1097fda9f2b31$var$X) throw Error($9af1097fda9f2b31$var$p(160));
            $9af1097fda9f2b31$var$ak(f, g, e);
            $9af1097fda9f2b31$var$X = null;
            $9af1097fda9f2b31$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k["return"] = null);
            e["return"] = null;
        } catch (l) {
            $9af1097fda9f2b31$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9af1097fda9f2b31$var$ek(b, a), b = b.sibling;
}
function $9af1097fda9f2b31$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4) {
                try {
                    $9af1097fda9f2b31$var$Qj(3, a, a["return"]), $9af1097fda9f2b31$var$Rj(3, a);
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
                try {
                    $9af1097fda9f2b31$var$Qj(5, a, a["return"]);
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 1:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 512 && null !== c && $9af1097fda9f2b31$var$Mj(c, c["return"]);
            break;
        case 5:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 512 && null !== c && $9af1097fda9f2b31$var$Mj(c, c["return"]);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9af1097fda9f2b31$var$ob(e, "");
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9af1097fda9f2b31$var$ab(e, f);
                    $9af1097fda9f2b31$var$vb(h, g);
                    var l = $9af1097fda9f2b31$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9af1097fda9f2b31$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9af1097fda9f2b31$var$nb(e, q) : "children" === m ? $9af1097fda9f2b31$var$ob(e, q) : $9af1097fda9f2b31$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9af1097fda9f2b31$var$bb(e, f);
                            break;
                        case "textarea":
                            $9af1097fda9f2b31$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9af1097fda9f2b31$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9af1097fda9f2b31$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9af1097fda9f2b31$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9af1097fda9f2b31$var$Pf] = f;
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 6:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9af1097fda9f2b31$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9af1097fda9f2b31$var$W(a, a["return"], t);
                }
            }
            break;
        case 3:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9af1097fda9f2b31$var$bd(b.containerInfo);
            } catch (t) {
                $9af1097fda9f2b31$var$W(a, a["return"], t);
            }
            break;
        case 4:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            break;
        case 13:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9af1097fda9f2b31$var$gk = $9af1097fda9f2b31$var$B()));
            d & 4 && $9af1097fda9f2b31$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9af1097fda9f2b31$var$U = (l = $9af1097fda9f2b31$var$U) || m, $9af1097fda9f2b31$var$dk(b, a), $9af1097fda9f2b31$var$U = l) : $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9af1097fda9f2b31$var$V = a, m = a.child; null !== m;){
                    for(q = $9af1097fda9f2b31$var$V = m; null !== $9af1097fda9f2b31$var$V;){
                        r = $9af1097fda9f2b31$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9af1097fda9f2b31$var$Qj(4, r, r["return"]);
                                break;
                            case 1:
                                $9af1097fda9f2b31$var$Mj(r, r["return"]);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r["return"];
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9af1097fda9f2b31$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9af1097fda9f2b31$var$Mj(r, r["return"]);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9af1097fda9f2b31$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y["return"] = r, $9af1097fda9f2b31$var$V = y) : $9af1097fda9f2b31$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9af1097fda9f2b31$var$rb("display", g));
                            } catch (t) {
                                $9af1097fda9f2b31$var$W(a, a["return"], t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9af1097fda9f2b31$var$W(a, a["return"], t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child["return"] = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q["return"] || q["return"] === a) break a;
                        m === q && (m = null);
                        q = q["return"];
                    }
                    m === q && (m = null);
                    q.sibling["return"] = q["return"];
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9af1097fda9f2b31$var$dk(b, a);
            $9af1097fda9f2b31$var$fk(a);
            d & 4 && $9af1097fda9f2b31$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9af1097fda9f2b31$var$dk(b, a), $9af1097fda9f2b31$var$fk(a);
    }
}
function $9af1097fda9f2b31$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a["return"]; null !== c;){
                    if ($9af1097fda9f2b31$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c["return"];
                }
                throw Error($9af1097fda9f2b31$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9af1097fda9f2b31$var$ob(e, ""), d.flags &= -33);
                    var f = $9af1097fda9f2b31$var$Vj(a);
                    $9af1097fda9f2b31$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9af1097fda9f2b31$var$Vj(a);
                    $9af1097fda9f2b31$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(161));
            }
        } catch (k) {
            $9af1097fda9f2b31$var$W(a, a["return"], k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9af1097fda9f2b31$var$ik(a, b, c) {
    $9af1097fda9f2b31$var$V = a;
    $9af1097fda9f2b31$var$jk(a, b, c);
}
function $9af1097fda9f2b31$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9af1097fda9f2b31$var$V;){
        var e = $9af1097fda9f2b31$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9af1097fda9f2b31$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9af1097fda9f2b31$var$U;
                h = $9af1097fda9f2b31$var$Kj;
                var l = $9af1097fda9f2b31$var$U;
                $9af1097fda9f2b31$var$Kj = g;
                if (($9af1097fda9f2b31$var$U = k) && !l) for($9af1097fda9f2b31$var$V = e; null !== $9af1097fda9f2b31$var$V;)g = $9af1097fda9f2b31$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9af1097fda9f2b31$var$kk(e) : null !== k ? (k["return"] = g, $9af1097fda9f2b31$var$V = k) : $9af1097fda9f2b31$var$kk(e);
                for(; null !== f;)$9af1097fda9f2b31$var$V = f, $9af1097fda9f2b31$var$jk(f, b, c), f = f.sibling;
                $9af1097fda9f2b31$var$V = e;
                $9af1097fda9f2b31$var$Kj = h;
                $9af1097fda9f2b31$var$U = l;
            }
            $9af1097fda9f2b31$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f["return"] = e, $9af1097fda9f2b31$var$V = f) : $9af1097fda9f2b31$var$lk(a, b, c);
    }
}
function $9af1097fda9f2b31$var$lk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9af1097fda9f2b31$var$U || $9af1097fda9f2b31$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9af1097fda9f2b31$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9af1097fda9f2b31$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9af1097fda9f2b31$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9af1097fda9f2b31$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9af1097fda9f2b31$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9af1097fda9f2b31$var$p(163));
                }
                $9af1097fda9f2b31$var$U || b.flags & 512 && $9af1097fda9f2b31$var$Sj(b);
            } catch (r) {
                $9af1097fda9f2b31$var$W(b, b["return"], r);
            }
        }
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $9af1097fda9f2b31$var$V = c;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
function $9af1097fda9f2b31$var$hk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c["return"] = b["return"];
            $9af1097fda9f2b31$var$V = c;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
function $9af1097fda9f2b31$var$kk(a) {
    for(; null !== $9af1097fda9f2b31$var$V;){
        var b = $9af1097fda9f2b31$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Rj(4, b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b["return"];
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9af1097fda9f2b31$var$W(b, e, k);
                        }
                    }
                    var f = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Sj(b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b["return"];
                    try {
                        $9af1097fda9f2b31$var$Sj(b);
                    } catch (k) {
                        $9af1097fda9f2b31$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9af1097fda9f2b31$var$W(b, b["return"], k);
        }
        if (b === a) {
            $9af1097fda9f2b31$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h["return"] = b["return"];
            $9af1097fda9f2b31$var$V = h;
            break;
        }
        $9af1097fda9f2b31$var$V = b["return"];
    }
}
var $9af1097fda9f2b31$var$mk = Math.ceil, $9af1097fda9f2b31$var$nk = $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher, $9af1097fda9f2b31$var$ok = $9af1097fda9f2b31$var$ua.ReactCurrentOwner, $9af1097fda9f2b31$var$pk = $9af1097fda9f2b31$var$ua.ReactCurrentBatchConfig, $9af1097fda9f2b31$var$K = 0, $9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Y = null, $9af1097fda9f2b31$var$Z = 0, $9af1097fda9f2b31$var$gj = 0, $9af1097fda9f2b31$var$fj = $9af1097fda9f2b31$var$Uf(0), $9af1097fda9f2b31$var$T = 0, $9af1097fda9f2b31$var$qk = null, $9af1097fda9f2b31$var$hh = 0, $9af1097fda9f2b31$var$rk = 0, $9af1097fda9f2b31$var$sk = 0, $9af1097fda9f2b31$var$tk = null, $9af1097fda9f2b31$var$uk = null, $9af1097fda9f2b31$var$gk = 0, $9af1097fda9f2b31$var$Hj = Infinity, $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Pi = !1, $9af1097fda9f2b31$var$Qi = null, $9af1097fda9f2b31$var$Si = null, $9af1097fda9f2b31$var$wk = !1, $9af1097fda9f2b31$var$xk = null, $9af1097fda9f2b31$var$yk = 0, $9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = null, $9af1097fda9f2b31$var$Bk = -1, $9af1097fda9f2b31$var$Ck = 0;
function $9af1097fda9f2b31$var$L() {
    return 0 !== ($9af1097fda9f2b31$var$K & 6) ? $9af1097fda9f2b31$var$B() : -1 !== $9af1097fda9f2b31$var$Bk ? $9af1097fda9f2b31$var$Bk : $9af1097fda9f2b31$var$Bk = $9af1097fda9f2b31$var$B();
}
function $9af1097fda9f2b31$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9af1097fda9f2b31$var$K & 2) && 0 !== $9af1097fda9f2b31$var$Z) return $9af1097fda9f2b31$var$Z & -$9af1097fda9f2b31$var$Z;
    if (null !== $9af1097fda9f2b31$var$Kg.transition) return 0 === $9af1097fda9f2b31$var$Ck && ($9af1097fda9f2b31$var$Ck = $9af1097fda9f2b31$var$yc()), $9af1097fda9f2b31$var$Ck;
    a = $9af1097fda9f2b31$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9af1097fda9f2b31$var$jd(a.type);
    return a;
}
function $9af1097fda9f2b31$var$mh(a, b, c, d) {
    if (50 < $9af1097fda9f2b31$var$zk) throw $9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = null, Error($9af1097fda9f2b31$var$p(185));
    $9af1097fda9f2b31$var$Ac(a, c, d);
    if (0 === ($9af1097fda9f2b31$var$K & 2) || a !== $9af1097fda9f2b31$var$R) a === $9af1097fda9f2b31$var$R && (0 === ($9af1097fda9f2b31$var$K & 2) && ($9af1097fda9f2b31$var$rk |= c), 4 === $9af1097fda9f2b31$var$T && $9af1097fda9f2b31$var$Dk(a, $9af1097fda9f2b31$var$Z)), $9af1097fda9f2b31$var$Ek(a, d), 1 === c && 0 === $9af1097fda9f2b31$var$K && 0 === (b.mode & 1) && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$fg && $9af1097fda9f2b31$var$jg());
}
function $9af1097fda9f2b31$var$Ek(a, b) {
    var c = a.callbackNode;
    $9af1097fda9f2b31$var$wc(a, b);
    var d = $9af1097fda9f2b31$var$uc(a, a === $9af1097fda9f2b31$var$R ? $9af1097fda9f2b31$var$Z : 0);
    if (0 === d) null !== c && $9af1097fda9f2b31$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9af1097fda9f2b31$var$bc(c);
        if (1 === b) 0 === a.tag ? $9af1097fda9f2b31$var$ig($9af1097fda9f2b31$var$Fk.bind(null, a)) : $9af1097fda9f2b31$var$hg($9af1097fda9f2b31$var$Fk.bind(null, a)), $9af1097fda9f2b31$var$Jf(function() {
            0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$jg();
        }), c = null;
        else {
            switch($9af1097fda9f2b31$var$Dc(d)){
                case 1:
                    c = $9af1097fda9f2b31$var$fc;
                    break;
                case 4:
                    c = $9af1097fda9f2b31$var$gc;
                    break;
                case 16:
                    c = $9af1097fda9f2b31$var$hc;
                    break;
                case 536870912:
                    c = $9af1097fda9f2b31$var$jc;
                    break;
                default:
                    c = $9af1097fda9f2b31$var$hc;
            }
            c = $9af1097fda9f2b31$var$Gk(c, $9af1097fda9f2b31$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9af1097fda9f2b31$var$Hk(a, b) {
    $9af1097fda9f2b31$var$Bk = -1;
    $9af1097fda9f2b31$var$Ck = 0;
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    var c = a.callbackNode;
    if ($9af1097fda9f2b31$var$Ik() && a.callbackNode !== c) return null;
    var d = $9af1097fda9f2b31$var$uc(a, a === $9af1097fda9f2b31$var$R ? $9af1097fda9f2b31$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9af1097fda9f2b31$var$Jk(a, d);
    else {
        b = d;
        var e = $9af1097fda9f2b31$var$K;
        $9af1097fda9f2b31$var$K |= 2;
        var f = $9af1097fda9f2b31$var$Kk();
        if ($9af1097fda9f2b31$var$R !== a || $9af1097fda9f2b31$var$Z !== b) $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$Lk(a, b);
        for(;;)try {
            $9af1097fda9f2b31$var$Mk();
            break;
        } catch (h) {
            $9af1097fda9f2b31$var$Nk(a, h);
        }
        $9af1097fda9f2b31$var$Qg();
        $9af1097fda9f2b31$var$nk.current = f;
        $9af1097fda9f2b31$var$K = e;
        null !== $9af1097fda9f2b31$var$Y ? b = 0 : ($9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Z = 0, b = $9af1097fda9f2b31$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9af1097fda9f2b31$var$xc(a), 0 !== e && (d = e, b = $9af1097fda9f2b31$var$Ok(a, e)));
        if (1 === b) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, d), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
        if (6 === b) $9af1097fda9f2b31$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9af1097fda9f2b31$var$Pk(e) && (b = $9af1097fda9f2b31$var$Jk(a, d), 2 === b && (f = $9af1097fda9f2b31$var$xc(a), 0 !== f && (d = f, b = $9af1097fda9f2b31$var$Ok(a, f))), 1 === b)) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, d), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9af1097fda9f2b31$var$p(345));
                case 2:
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 3:
                    $9af1097fda9f2b31$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9af1097fda9f2b31$var$gk + 500 - $9af1097fda9f2b31$var$B(), 10 < b)) {
                        if (0 !== $9af1097fda9f2b31$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9af1097fda9f2b31$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9af1097fda9f2b31$var$Ff($9af1097fda9f2b31$var$Qk.bind(null, a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk), b);
                        break;
                    }
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 4:
                    $9af1097fda9f2b31$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9af1097fda9f2b31$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9af1097fda9f2b31$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9af1097fda9f2b31$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9af1097fda9f2b31$var$Ff($9af1097fda9f2b31$var$Qk.bind(null, a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk), d);
                        break;
                    }
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                case 5:
                    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
                    break;
                default:
                    throw Error($9af1097fda9f2b31$var$p(329));
            }
        }
    }
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    return a.callbackNode === c ? $9af1097fda9f2b31$var$Hk.bind(null, a) : null;
}
function $9af1097fda9f2b31$var$Ok(a, b) {
    var c = $9af1097fda9f2b31$var$tk;
    a.current.memoizedState.isDehydrated && ($9af1097fda9f2b31$var$Lk(a, b).flags |= 256);
    a = $9af1097fda9f2b31$var$Jk(a, b);
    2 !== a && (b = $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$uk = c, null !== b && $9af1097fda9f2b31$var$Gj(b));
    return a;
}
function $9af1097fda9f2b31$var$Gj(a) {
    null === $9af1097fda9f2b31$var$uk ? $9af1097fda9f2b31$var$uk = a : $9af1097fda9f2b31$var$uk.push.apply($9af1097fda9f2b31$var$uk, a);
}
function $9af1097fda9f2b31$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9af1097fda9f2b31$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c["return"] = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b["return"] || b["return"] === a) return !0;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return !0;
}
function $9af1097fda9f2b31$var$Dk(a, b) {
    b &= ~$9af1097fda9f2b31$var$sk;
    b &= ~$9af1097fda9f2b31$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9af1097fda9f2b31$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9af1097fda9f2b31$var$Fk(a) {
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    $9af1097fda9f2b31$var$Ik();
    var b = $9af1097fda9f2b31$var$uc(a, 0);
    if (0 === (b & 1)) return $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), null;
    var c = $9af1097fda9f2b31$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9af1097fda9f2b31$var$xc(a);
        0 !== d && (b = d, c = $9af1097fda9f2b31$var$Ok(a, d));
    }
    if (1 === c) throw c = $9af1097fda9f2b31$var$qk, $9af1097fda9f2b31$var$Lk(a, 0), $9af1097fda9f2b31$var$Dk(a, b), $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B()), c;
    if (6 === c) throw Error($9af1097fda9f2b31$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9af1097fda9f2b31$var$Qk(a, $9af1097fda9f2b31$var$uk, $9af1097fda9f2b31$var$vk);
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    return null;
}
function $9af1097fda9f2b31$var$Rk(a, b) {
    var c = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9af1097fda9f2b31$var$K = c, 0 === $9af1097fda9f2b31$var$K && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$fg && $9af1097fda9f2b31$var$jg());
    }
}
function $9af1097fda9f2b31$var$Sk(a) {
    null !== $9af1097fda9f2b31$var$xk && 0 === $9af1097fda9f2b31$var$xk.tag && 0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$Ik();
    var b = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 1;
    var c = $9af1097fda9f2b31$var$pk.transition, d = $9af1097fda9f2b31$var$C;
    try {
        if ($9af1097fda9f2b31$var$pk.transition = null, $9af1097fda9f2b31$var$C = 1, a) return a();
    } finally{
        $9af1097fda9f2b31$var$C = d, $9af1097fda9f2b31$var$pk.transition = c, $9af1097fda9f2b31$var$K = b, 0 === ($9af1097fda9f2b31$var$K & 6) && $9af1097fda9f2b31$var$jg();
    }
}
function $9af1097fda9f2b31$var$Ij() {
    $9af1097fda9f2b31$var$gj = $9af1097fda9f2b31$var$fj.current;
    $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$fj);
}
function $9af1097fda9f2b31$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9af1097fda9f2b31$var$Gf(c));
    if (null !== $9af1097fda9f2b31$var$Y) for(c = $9af1097fda9f2b31$var$Y["return"]; null !== c;){
        var d = c;
        $9af1097fda9f2b31$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9af1097fda9f2b31$var$$f();
                break;
            case 3:
                $9af1097fda9f2b31$var$Jh();
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$Wf);
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$H);
                $9af1097fda9f2b31$var$Oh();
                break;
            case 5:
                $9af1097fda9f2b31$var$Lh(d);
                break;
            case 4:
                $9af1097fda9f2b31$var$Jh();
                break;
            case 13:
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
                break;
            case 19:
                $9af1097fda9f2b31$var$E($9af1097fda9f2b31$var$M);
                break;
            case 10:
                $9af1097fda9f2b31$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9af1097fda9f2b31$var$Ij();
        }
        c = c["return"];
    }
    $9af1097fda9f2b31$var$R = a;
    $9af1097fda9f2b31$var$Y = a = $9af1097fda9f2b31$var$wh(a.current, null);
    $9af1097fda9f2b31$var$Z = $9af1097fda9f2b31$var$gj = b;
    $9af1097fda9f2b31$var$T = 0;
    $9af1097fda9f2b31$var$qk = null;
    $9af1097fda9f2b31$var$sk = $9af1097fda9f2b31$var$rk = $9af1097fda9f2b31$var$hh = 0;
    $9af1097fda9f2b31$var$uk = $9af1097fda9f2b31$var$tk = null;
    if (null !== $9af1097fda9f2b31$var$Wg) {
        for(b = 0; b < $9af1097fda9f2b31$var$Wg.length; b++)if (c = $9af1097fda9f2b31$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9af1097fda9f2b31$var$Wg = null;
    }
    return a;
}
function $9af1097fda9f2b31$var$Nk(a, b) {
    do {
        var c = $9af1097fda9f2b31$var$Y;
        try {
            $9af1097fda9f2b31$var$Qg();
            $9af1097fda9f2b31$var$Ph.current = $9af1097fda9f2b31$var$ai;
            if ($9af1097fda9f2b31$var$Sh) {
                for(var d = $9af1097fda9f2b31$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9af1097fda9f2b31$var$Sh = !1;
            }
            $9af1097fda9f2b31$var$Rh = 0;
            $9af1097fda9f2b31$var$P = $9af1097fda9f2b31$var$O = $9af1097fda9f2b31$var$N = null;
            $9af1097fda9f2b31$var$Th = !1;
            $9af1097fda9f2b31$var$Uh = 0;
            $9af1097fda9f2b31$var$ok.current = null;
            if (null === c || null === c["return"]) {
                $9af1097fda9f2b31$var$T = 1;
                $9af1097fda9f2b31$var$qk = b;
                $9af1097fda9f2b31$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c["return"], h = c, k = b;
                b = $9af1097fda9f2b31$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9af1097fda9f2b31$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9af1097fda9f2b31$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9af1097fda9f2b31$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9af1097fda9f2b31$var$Ti(f, l, b);
                            $9af1097fda9f2b31$var$uj();
                            break a;
                        }
                        k = Error($9af1097fda9f2b31$var$p(426));
                    }
                } else if ($9af1097fda9f2b31$var$I && h.mode & 1) {
                    var J = $9af1097fda9f2b31$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9af1097fda9f2b31$var$Wi(J, g, h, f, b);
                        $9af1097fda9f2b31$var$Jg($9af1097fda9f2b31$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9af1097fda9f2b31$var$Ki(k, h);
                4 !== $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 2);
                null === $9af1097fda9f2b31$var$tk ? $9af1097fda9f2b31$var$tk = [
                    f
                ] : $9af1097fda9f2b31$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9af1097fda9f2b31$var$Oi(f, k, b);
                            $9af1097fda9f2b31$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9af1097fda9f2b31$var$Si || !$9af1097fda9f2b31$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9af1097fda9f2b31$var$Ri(f, h, b);
                                $9af1097fda9f2b31$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f["return"];
                }while (null !== f);
            }
            $9af1097fda9f2b31$var$Tk(c);
        } catch (na) {
            b = na;
            $9af1097fda9f2b31$var$Y === c && null !== c && ($9af1097fda9f2b31$var$Y = c = c["return"]);
            continue;
        }
        break;
    }while (1);
}
function $9af1097fda9f2b31$var$Kk() {
    var a = $9af1097fda9f2b31$var$nk.current;
    $9af1097fda9f2b31$var$nk.current = $9af1097fda9f2b31$var$ai;
    return null === a ? $9af1097fda9f2b31$var$ai : a;
}
function $9af1097fda9f2b31$var$uj() {
    if (0 === $9af1097fda9f2b31$var$T || 3 === $9af1097fda9f2b31$var$T || 2 === $9af1097fda9f2b31$var$T) $9af1097fda9f2b31$var$T = 4;
    null === $9af1097fda9f2b31$var$R || 0 === ($9af1097fda9f2b31$var$hh & 268435455) && 0 === ($9af1097fda9f2b31$var$rk & 268435455) || $9af1097fda9f2b31$var$Dk($9af1097fda9f2b31$var$R, $9af1097fda9f2b31$var$Z);
}
function $9af1097fda9f2b31$var$Jk(a, b) {
    var c = $9af1097fda9f2b31$var$K;
    $9af1097fda9f2b31$var$K |= 2;
    var d = $9af1097fda9f2b31$var$Kk();
    if ($9af1097fda9f2b31$var$R !== a || $9af1097fda9f2b31$var$Z !== b) $9af1097fda9f2b31$var$vk = null, $9af1097fda9f2b31$var$Lk(a, b);
    for(;;)try {
        $9af1097fda9f2b31$var$Uk();
        break;
    } catch (e) {
        $9af1097fda9f2b31$var$Nk(a, e);
    }
    $9af1097fda9f2b31$var$Qg();
    $9af1097fda9f2b31$var$K = c;
    $9af1097fda9f2b31$var$nk.current = d;
    if (null !== $9af1097fda9f2b31$var$Y) throw Error($9af1097fda9f2b31$var$p(261));
    $9af1097fda9f2b31$var$R = null;
    $9af1097fda9f2b31$var$Z = 0;
    return $9af1097fda9f2b31$var$T;
}
function $9af1097fda9f2b31$var$Uk() {
    for(; null !== $9af1097fda9f2b31$var$Y;)$9af1097fda9f2b31$var$Vk($9af1097fda9f2b31$var$Y);
}
function $9af1097fda9f2b31$var$Mk() {
    for(; null !== $9af1097fda9f2b31$var$Y && !$9af1097fda9f2b31$var$cc();)$9af1097fda9f2b31$var$Vk($9af1097fda9f2b31$var$Y);
}
function $9af1097fda9f2b31$var$Vk(a) {
    var b = $9af1097fda9f2b31$var$Wk(a.alternate, a, $9af1097fda9f2b31$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9af1097fda9f2b31$var$Tk(a) : $9af1097fda9f2b31$var$Y = b;
    $9af1097fda9f2b31$var$ok.current = null;
}
function $9af1097fda9f2b31$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b["return"];
        if (0 === (b.flags & 32768)) {
            if (c = $9af1097fda9f2b31$var$Fj(c, b, $9af1097fda9f2b31$var$gj), null !== c) {
                $9af1097fda9f2b31$var$Y = c;
                return;
            }
        } else {
            c = $9af1097fda9f2b31$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9af1097fda9f2b31$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9af1097fda9f2b31$var$T = 6;
                $9af1097fda9f2b31$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9af1097fda9f2b31$var$Y = b;
            return;
        }
        $9af1097fda9f2b31$var$Y = b = a;
    }while (null !== b);
    0 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$T = 5);
}
function $9af1097fda9f2b31$var$Qk(a, b, c) {
    var d = $9af1097fda9f2b31$var$C, e = $9af1097fda9f2b31$var$pk.transition;
    try {
        $9af1097fda9f2b31$var$pk.transition = null, $9af1097fda9f2b31$var$C = 1, $9af1097fda9f2b31$var$Xk(a, b, c, d);
    } finally{
        $9af1097fda9f2b31$var$pk.transition = e, $9af1097fda9f2b31$var$C = d;
    }
    return null;
}
function $9af1097fda9f2b31$var$Xk(a, b, c, d) {
    do $9af1097fda9f2b31$var$Ik();
    while (null !== $9af1097fda9f2b31$var$xk);
    if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9af1097fda9f2b31$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9af1097fda9f2b31$var$Bc(a, f);
    a === $9af1097fda9f2b31$var$R && ($9af1097fda9f2b31$var$Y = $9af1097fda9f2b31$var$R = null, $9af1097fda9f2b31$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9af1097fda9f2b31$var$wk || ($9af1097fda9f2b31$var$wk = !0, $9af1097fda9f2b31$var$Gk($9af1097fda9f2b31$var$hc, function() {
        $9af1097fda9f2b31$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9af1097fda9f2b31$var$pk.transition;
        $9af1097fda9f2b31$var$pk.transition = null;
        var g = $9af1097fda9f2b31$var$C;
        $9af1097fda9f2b31$var$C = 1;
        var h = $9af1097fda9f2b31$var$K;
        $9af1097fda9f2b31$var$K |= 4;
        $9af1097fda9f2b31$var$ok.current = null;
        $9af1097fda9f2b31$var$Pj(a, c);
        $9af1097fda9f2b31$var$ek(c, a);
        $9af1097fda9f2b31$var$Oe($9af1097fda9f2b31$var$Df);
        $9af1097fda9f2b31$var$dd = !!$9af1097fda9f2b31$var$Cf;
        $9af1097fda9f2b31$var$Df = $9af1097fda9f2b31$var$Cf = null;
        a.current = c;
        $9af1097fda9f2b31$var$ik(c, a, e);
        $9af1097fda9f2b31$var$dc();
        $9af1097fda9f2b31$var$K = h;
        $9af1097fda9f2b31$var$C = g;
        $9af1097fda9f2b31$var$pk.transition = f;
    } else a.current = c;
    $9af1097fda9f2b31$var$wk && ($9af1097fda9f2b31$var$wk = !1, $9af1097fda9f2b31$var$xk = a, $9af1097fda9f2b31$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9af1097fda9f2b31$var$Si = null);
    $9af1097fda9f2b31$var$mc(c.stateNode, d);
    $9af1097fda9f2b31$var$Ek(a, $9af1097fda9f2b31$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9af1097fda9f2b31$var$Pi) throw $9af1097fda9f2b31$var$Pi = !1, a = $9af1097fda9f2b31$var$Qi, $9af1097fda9f2b31$var$Qi = null, a;
    0 !== ($9af1097fda9f2b31$var$yk & 1) && 0 !== a.tag && $9af1097fda9f2b31$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9af1097fda9f2b31$var$Ak ? $9af1097fda9f2b31$var$zk++ : ($9af1097fda9f2b31$var$zk = 0, $9af1097fda9f2b31$var$Ak = a) : $9af1097fda9f2b31$var$zk = 0;
    $9af1097fda9f2b31$var$jg();
    return null;
}
function $9af1097fda9f2b31$var$Ik() {
    if (null !== $9af1097fda9f2b31$var$xk) {
        var a = $9af1097fda9f2b31$var$Dc($9af1097fda9f2b31$var$yk), b = $9af1097fda9f2b31$var$pk.transition, c = $9af1097fda9f2b31$var$C;
        try {
            $9af1097fda9f2b31$var$pk.transition = null;
            $9af1097fda9f2b31$var$C = 16 > a ? 16 : a;
            if (null === $9af1097fda9f2b31$var$xk) var d = !1;
            else {
                a = $9af1097fda9f2b31$var$xk;
                $9af1097fda9f2b31$var$xk = null;
                $9af1097fda9f2b31$var$yk = 0;
                if (0 !== ($9af1097fda9f2b31$var$K & 6)) throw Error($9af1097fda9f2b31$var$p(331));
                var e = $9af1097fda9f2b31$var$K;
                $9af1097fda9f2b31$var$K |= 4;
                for($9af1097fda9f2b31$var$V = a.current; null !== $9af1097fda9f2b31$var$V;){
                    var f = $9af1097fda9f2b31$var$V, g = f.child;
                    if (0 !== ($9af1097fda9f2b31$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9af1097fda9f2b31$var$V = l; null !== $9af1097fda9f2b31$var$V;){
                                    var m = $9af1097fda9f2b31$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9af1097fda9f2b31$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q["return"] = m, $9af1097fda9f2b31$var$V = q;
                                    else for(; null !== $9af1097fda9f2b31$var$V;){
                                        m = $9af1097fda9f2b31$var$V;
                                        var r = m.sibling, y = m["return"];
                                        $9af1097fda9f2b31$var$Tj(m);
                                        if (m === l) {
                                            $9af1097fda9f2b31$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r["return"] = y;
                                            $9af1097fda9f2b31$var$V = r;
                                            break;
                                        }
                                        $9af1097fda9f2b31$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9af1097fda9f2b31$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g["return"] = f, $9af1097fda9f2b31$var$V = g;
                    else b: for(; null !== $9af1097fda9f2b31$var$V;){
                        f = $9af1097fda9f2b31$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9af1097fda9f2b31$var$Qj(9, f, f["return"]);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x["return"] = f["return"];
                            $9af1097fda9f2b31$var$V = x;
                            break b;
                        }
                        $9af1097fda9f2b31$var$V = f["return"];
                    }
                }
                var w = a.current;
                for($9af1097fda9f2b31$var$V = w; null !== $9af1097fda9f2b31$var$V;){
                    g = $9af1097fda9f2b31$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u["return"] = g, $9af1097fda9f2b31$var$V = u;
                    else b: for(g = w; null !== $9af1097fda9f2b31$var$V;){
                        h = $9af1097fda9f2b31$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9af1097fda9f2b31$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9af1097fda9f2b31$var$W(h, h["return"], na);
                        }
                        if (h === g) {
                            $9af1097fda9f2b31$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F["return"] = h["return"];
                            $9af1097fda9f2b31$var$V = F;
                            break b;
                        }
                        $9af1097fda9f2b31$var$V = h["return"];
                    }
                }
                $9af1097fda9f2b31$var$K = e;
                $9af1097fda9f2b31$var$jg();
                if ($9af1097fda9f2b31$var$lc && "function" === typeof $9af1097fda9f2b31$var$lc.onPostCommitFiberRoot) try {
                    $9af1097fda9f2b31$var$lc.onPostCommitFiberRoot($9af1097fda9f2b31$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9af1097fda9f2b31$var$C = c, $9af1097fda9f2b31$var$pk.transition = b;
        }
    }
    return !1;
}
function $9af1097fda9f2b31$var$Yk(a, b, c) {
    b = $9af1097fda9f2b31$var$Ki(c, b);
    b = $9af1097fda9f2b31$var$Oi(a, b, 1);
    a = $9af1097fda9f2b31$var$dh(a, b, 1);
    b = $9af1097fda9f2b31$var$L();
    null !== a && ($9af1097fda9f2b31$var$Ac(a, 1, b), $9af1097fda9f2b31$var$Ek(a, b));
}
function $9af1097fda9f2b31$var$W(a, b, c) {
    if (3 === a.tag) $9af1097fda9f2b31$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9af1097fda9f2b31$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9af1097fda9f2b31$var$Si || !$9af1097fda9f2b31$var$Si.has(d))) {
                a = $9af1097fda9f2b31$var$Ki(c, a);
                a = $9af1097fda9f2b31$var$Ri(b, a, 1);
                b = $9af1097fda9f2b31$var$dh(b, a, 1);
                a = $9af1097fda9f2b31$var$L();
                null !== b && ($9af1097fda9f2b31$var$Ac(b, 1, a), $9af1097fda9f2b31$var$Ek(b, a));
                break;
            }
        }
        b = b["return"];
    }
}
function $9af1097fda9f2b31$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    b = $9af1097fda9f2b31$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9af1097fda9f2b31$var$R === a && ($9af1097fda9f2b31$var$Z & c) === c && (4 === $9af1097fda9f2b31$var$T || 3 === $9af1097fda9f2b31$var$T && ($9af1097fda9f2b31$var$Z & 130023424) === $9af1097fda9f2b31$var$Z && 500 > $9af1097fda9f2b31$var$B() - $9af1097fda9f2b31$var$gk ? $9af1097fda9f2b31$var$Lk(a, 0) : $9af1097fda9f2b31$var$sk |= c);
    $9af1097fda9f2b31$var$Ek(a, b);
}
function $9af1097fda9f2b31$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9af1097fda9f2b31$var$sc, $9af1097fda9f2b31$var$sc <<= 1, 0 === ($9af1097fda9f2b31$var$sc & 130023424) && ($9af1097fda9f2b31$var$sc = 4194304)));
    var c = $9af1097fda9f2b31$var$L();
    a = $9af1097fda9f2b31$var$Zg(a, b);
    null !== a && ($9af1097fda9f2b31$var$Ac(a, b, c), $9af1097fda9f2b31$var$Ek(a, c));
}
function $9af1097fda9f2b31$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9af1097fda9f2b31$var$Zk(a, c);
}
function $9af1097fda9f2b31$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9af1097fda9f2b31$var$p(314));
    }
    null !== d && d["delete"](b);
    $9af1097fda9f2b31$var$Zk(a, c);
}
var $9af1097fda9f2b31$var$Wk;
$9af1097fda9f2b31$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9af1097fda9f2b31$var$Wf.current) $9af1097fda9f2b31$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9af1097fda9f2b31$var$Ug = !1, $9af1097fda9f2b31$var$zj(a, b, c);
            $9af1097fda9f2b31$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9af1097fda9f2b31$var$Ug = !1, $9af1097fda9f2b31$var$I && 0 !== (b.flags & 1048576) && $9af1097fda9f2b31$var$ug(b, $9af1097fda9f2b31$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9af1097fda9f2b31$var$jj(a, b);
            a = b.pendingProps;
            var e = $9af1097fda9f2b31$var$Yf(b, $9af1097fda9f2b31$var$H.current);
            $9af1097fda9f2b31$var$Tg(b, c);
            e = $9af1097fda9f2b31$var$Xh(null, b, d, a, e, c);
            var f = $9af1097fda9f2b31$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9af1097fda9f2b31$var$Zf(d) ? (f = !0, $9af1097fda9f2b31$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9af1097fda9f2b31$var$ah(b), e.updater = $9af1097fda9f2b31$var$nh, b.stateNode = e, e._reactInternals = b, $9af1097fda9f2b31$var$rh(b, d, a, c), b = $9af1097fda9f2b31$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9af1097fda9f2b31$var$I && f && $9af1097fda9f2b31$var$vg(b), $9af1097fda9f2b31$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9af1097fda9f2b31$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9af1097fda9f2b31$var$$k(d);
                a = $9af1097fda9f2b31$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9af1097fda9f2b31$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9af1097fda9f2b31$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9af1097fda9f2b31$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9af1097fda9f2b31$var$aj(null, b, d, $9af1097fda9f2b31$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9af1097fda9f2b31$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9af1097fda9f2b31$var$lj(b);
                if (null === a) throw Error($9af1097fda9f2b31$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9af1097fda9f2b31$var$bh(a, b);
                $9af1097fda9f2b31$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9af1097fda9f2b31$var$Ki(Error($9af1097fda9f2b31$var$p(423)), b);
                        b = $9af1097fda9f2b31$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9af1097fda9f2b31$var$Ki(Error($9af1097fda9f2b31$var$p(424)), b);
                        b = $9af1097fda9f2b31$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9af1097fda9f2b31$var$yg = $9af1097fda9f2b31$var$Lf(b.stateNode.containerInfo.firstChild), $9af1097fda9f2b31$var$xg = b, $9af1097fda9f2b31$var$I = !0, $9af1097fda9f2b31$var$zg = null, c = $9af1097fda9f2b31$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9af1097fda9f2b31$var$Ig();
                    if (d === e) {
                        b = $9af1097fda9f2b31$var$$i(a, b, c);
                        break a;
                    }
                    $9af1097fda9f2b31$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9af1097fda9f2b31$var$Kh(b), null === a && $9af1097fda9f2b31$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9af1097fda9f2b31$var$Ef(d, e) ? g = null : null !== f && $9af1097fda9f2b31$var$Ef(d, f) && (b.flags |= 32), $9af1097fda9f2b31$var$hj(a, b), $9af1097fda9f2b31$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9af1097fda9f2b31$var$Eg(b), null;
        case 13:
            return $9af1097fda9f2b31$var$pj(a, b, c);
        case 4:
            return $9af1097fda9f2b31$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9af1097fda9f2b31$var$Bh(b, null, d, c) : $9af1097fda9f2b31$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$Zi(a, b, d, e, c);
        case 7:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9af1097fda9f2b31$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9af1097fda9f2b31$var$G($9af1097fda9f2b31$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9af1097fda9f2b31$var$He(f.value, g)) {
                        if (f.children === e.children && !$9af1097fda9f2b31$var$Wf.current) {
                            b = $9af1097fda9f2b31$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f["return"] = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9af1097fda9f2b31$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9af1097fda9f2b31$var$Sg(f["return"], c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f["return"];
                            if (null === g) throw Error($9af1097fda9f2b31$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9af1097fda9f2b31$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g["return"] = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f["return"] = g["return"];
                                g = f;
                                break;
                            }
                            g = g["return"];
                        }
                        f = g;
                    }
                }
                $9af1097fda9f2b31$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9af1097fda9f2b31$var$Tg(b, c), e = $9af1097fda9f2b31$var$Vg(e), d = d(e), b.flags |= 1, $9af1097fda9f2b31$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9af1097fda9f2b31$var$Lg(d, b.pendingProps), e = $9af1097fda9f2b31$var$Lg(d.type, e), $9af1097fda9f2b31$var$aj(a, b, d, e, c);
        case 15:
            return $9af1097fda9f2b31$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9af1097fda9f2b31$var$Lg(d, e), $9af1097fda9f2b31$var$jj(a, b), b.tag = 1, $9af1097fda9f2b31$var$Zf(d) ? (a = !0, $9af1097fda9f2b31$var$cg(b)) : a = !1, $9af1097fda9f2b31$var$Tg(b, c), $9af1097fda9f2b31$var$ph(b, d, e), $9af1097fda9f2b31$var$rh(b, d, e, c), $9af1097fda9f2b31$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9af1097fda9f2b31$var$yj(a, b, c);
        case 22:
            return $9af1097fda9f2b31$var$ej(a, b, c);
    }
    throw Error($9af1097fda9f2b31$var$p(156, b.tag));
};
function $9af1097fda9f2b31$var$Gk(a, b) {
    return $9af1097fda9f2b31$var$ac(a, b);
}
function $9af1097fda9f2b31$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9af1097fda9f2b31$var$Bg(a, b, c, d) {
    return new $9af1097fda9f2b31$var$al(a, b, c, d);
}
function $9af1097fda9f2b31$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9af1097fda9f2b31$var$$k(a) {
    if ("function" === typeof a) return $9af1097fda9f2b31$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9af1097fda9f2b31$var$Da) return 11;
        if (a === $9af1097fda9f2b31$var$Ga) return 14;
    }
    return 2;
}
function $9af1097fda9f2b31$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9af1097fda9f2b31$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9af1097fda9f2b31$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9af1097fda9f2b31$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9af1097fda9f2b31$var$ya:
            return $9af1097fda9f2b31$var$Ah(c.children, e, f, b);
        case $9af1097fda9f2b31$var$za:
            g = 8;
            e |= 8;
            break;
        case $9af1097fda9f2b31$var$Aa:
            return a = $9af1097fda9f2b31$var$Bg(12, c, b, e | 2), a.elementType = $9af1097fda9f2b31$var$Aa, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Ea:
            return a = $9af1097fda9f2b31$var$Bg(13, c, b, e), a.elementType = $9af1097fda9f2b31$var$Ea, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Fa:
            return a = $9af1097fda9f2b31$var$Bg(19, c, b, e), a.elementType = $9af1097fda9f2b31$var$Fa, a.lanes = f, a;
        case $9af1097fda9f2b31$var$Ia:
            return $9af1097fda9f2b31$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9af1097fda9f2b31$var$Ba:
                    g = 10;
                    break a;
                case $9af1097fda9f2b31$var$Ca:
                    g = 9;
                    break a;
                case $9af1097fda9f2b31$var$Da:
                    g = 11;
                    break a;
                case $9af1097fda9f2b31$var$Ga:
                    g = 14;
                    break a;
                case $9af1097fda9f2b31$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9af1097fda9f2b31$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $qb7pP._)(a), ""));
    }
    b = $9af1097fda9f2b31$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9af1097fda9f2b31$var$Ah(a, b, c, d) {
    a = $9af1097fda9f2b31$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9af1097fda9f2b31$var$qj(a, b, c, d) {
    a = $9af1097fda9f2b31$var$Bg(22, a, d, b);
    a.elementType = $9af1097fda9f2b31$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9af1097fda9f2b31$var$xh(a, b, c) {
    a = $9af1097fda9f2b31$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9af1097fda9f2b31$var$zh(a, b, c) {
    b = $9af1097fda9f2b31$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9af1097fda9f2b31$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9af1097fda9f2b31$var$zc(0);
    this.expirationTimes = $9af1097fda9f2b31$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9af1097fda9f2b31$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9af1097fda9f2b31$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9af1097fda9f2b31$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9af1097fda9f2b31$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9af1097fda9f2b31$var$ah(f);
    return a;
}
function $9af1097fda9f2b31$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9af1097fda9f2b31$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9af1097fda9f2b31$var$el(a) {
    if (!a) return $9af1097fda9f2b31$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9af1097fda9f2b31$var$Vb(a) !== a || 1 !== a.tag) throw Error($9af1097fda9f2b31$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9af1097fda9f2b31$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b["return"];
        }while (null !== b);
        throw Error($9af1097fda9f2b31$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9af1097fda9f2b31$var$Zf(c)) return $9af1097fda9f2b31$var$bg(a, c, b);
    }
    return b;
}
function $9af1097fda9f2b31$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9af1097fda9f2b31$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9af1097fda9f2b31$var$el(null);
    c = a.current;
    d = $9af1097fda9f2b31$var$L();
    e = $9af1097fda9f2b31$var$lh(c);
    f = $9af1097fda9f2b31$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9af1097fda9f2b31$var$dh(c, f, e);
    a.current.lanes = e;
    $9af1097fda9f2b31$var$Ac(a, e, d);
    $9af1097fda9f2b31$var$Ek(a, d);
    return a;
}
function $9af1097fda9f2b31$var$gl(a, b, c, d) {
    var e = b.current, f = $9af1097fda9f2b31$var$L(), g = $9af1097fda9f2b31$var$lh(e);
    c = $9af1097fda9f2b31$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9af1097fda9f2b31$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9af1097fda9f2b31$var$dh(e, b, g);
    null !== a && ($9af1097fda9f2b31$var$mh(a, e, g, f), $9af1097fda9f2b31$var$eh(a, e, g));
    return g;
}
function $9af1097fda9f2b31$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9af1097fda9f2b31$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9af1097fda9f2b31$var$jl(a, b) {
    $9af1097fda9f2b31$var$il(a, b);
    (a = a.alternate) && $9af1097fda9f2b31$var$il(a, b);
}
function $9af1097fda9f2b31$var$kl() {
    return null;
}
var $9af1097fda9f2b31$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $9af1097fda9f2b31$var$ml(a) {
    this._internalRoot = a;
}
$9af1097fda9f2b31$var$nl.prototype.render = $9af1097fda9f2b31$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9af1097fda9f2b31$var$p(409));
    $9af1097fda9f2b31$var$gl(a, b, null, null);
};
$9af1097fda9f2b31$var$nl.prototype.unmount = $9af1097fda9f2b31$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9af1097fda9f2b31$var$Sk(function() {
            $9af1097fda9f2b31$var$gl(null, a, null, null);
        });
        b[$9af1097fda9f2b31$var$uf] = null;
    }
};
function $9af1097fda9f2b31$var$nl(a) {
    this._internalRoot = a;
}
$9af1097fda9f2b31$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9af1097fda9f2b31$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9af1097fda9f2b31$var$Qc.length && 0 !== b && b < $9af1097fda9f2b31$var$Qc[c].priority; c++);
        $9af1097fda9f2b31$var$Qc.splice(c, 0, a);
        0 === c && $9af1097fda9f2b31$var$Vc(a);
    }
};
function $9af1097fda9f2b31$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9af1097fda9f2b31$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9af1097fda9f2b31$var$ql() {}
function $9af1097fda9f2b31$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $9af1097fda9f2b31$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $9af1097fda9f2b31$var$fl(b, d, a, 0, null, !1, !1, "", $9af1097fda9f2b31$var$ql);
        a._reactRootContainer = g;
        a[$9af1097fda9f2b31$var$uf] = g.current;
        $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9af1097fda9f2b31$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $9af1097fda9f2b31$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $9af1097fda9f2b31$var$cl(a, 0, !1, null, null, !1, !1, "", $9af1097fda9f2b31$var$ql);
    a._reactRootContainer = k;
    a[$9af1097fda9f2b31$var$uf] = k.current;
    $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9af1097fda9f2b31$var$Sk(function() {
        $9af1097fda9f2b31$var$gl(b, k, c, d);
    });
    return k;
}
function $9af1097fda9f2b31$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $9af1097fda9f2b31$var$hl(g);
                h.call(_$a);
            };
        }
        $9af1097fda9f2b31$var$gl(b, g, a, e);
    } else g = $9af1097fda9f2b31$var$rl(c, b, a, e, d);
    return $9af1097fda9f2b31$var$hl(g);
}
$9af1097fda9f2b31$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9af1097fda9f2b31$var$tc(b.pendingLanes);
                0 !== c && ($9af1097fda9f2b31$var$Cc(b, c | 1), $9af1097fda9f2b31$var$Ek(b, $9af1097fda9f2b31$var$B()), 0 === ($9af1097fda9f2b31$var$K & 6) && ($9af1097fda9f2b31$var$Hj = $9af1097fda9f2b31$var$B() + 500, $9af1097fda9f2b31$var$jg()));
            }
            break;
        case 13:
            $9af1097fda9f2b31$var$Sk(function() {
                var b = $9af1097fda9f2b31$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9af1097fda9f2b31$var$L();
                    $9af1097fda9f2b31$var$mh(b, a, 1, c);
                }
            }), $9af1097fda9f2b31$var$jl(a, 1);
    }
};
$9af1097fda9f2b31$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $9af1097fda9f2b31$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9af1097fda9f2b31$var$L();
            $9af1097fda9f2b31$var$mh(b, a, 134217728, c);
        }
        $9af1097fda9f2b31$var$jl(a, 134217728);
    }
};
$9af1097fda9f2b31$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $9af1097fda9f2b31$var$lh(a), c = $9af1097fda9f2b31$var$Zg(a, b);
        if (null !== c) {
            var d = $9af1097fda9f2b31$var$L();
            $9af1097fda9f2b31$var$mh(c, a, b, d);
        }
        $9af1097fda9f2b31$var$jl(a, b);
    }
};
$9af1097fda9f2b31$var$Hc = function Hc() {
    return $9af1097fda9f2b31$var$C;
};
$9af1097fda9f2b31$var$Ic = function Ic(a, b) {
    var c = $9af1097fda9f2b31$var$C;
    try {
        return $9af1097fda9f2b31$var$C = a, b();
    } finally{
        $9af1097fda9f2b31$var$C = c;
    }
};
$9af1097fda9f2b31$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $9af1097fda9f2b31$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9af1097fda9f2b31$var$Db(d);
                        if (!e) throw Error($9af1097fda9f2b31$var$p(90));
                        $9af1097fda9f2b31$var$Wa(d);
                        $9af1097fda9f2b31$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9af1097fda9f2b31$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9af1097fda9f2b31$var$fb(a, !!c.multiple, b, !1);
    }
};
$9af1097fda9f2b31$var$Gb = $9af1097fda9f2b31$var$Rk;
$9af1097fda9f2b31$var$Hb = $9af1097fda9f2b31$var$Sk;
var $9af1097fda9f2b31$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9af1097fda9f2b31$var$Cb,
        $9af1097fda9f2b31$var$ue,
        $9af1097fda9f2b31$var$Db,
        $9af1097fda9f2b31$var$Eb,
        $9af1097fda9f2b31$var$Fb,
        $9af1097fda9f2b31$var$Rk
    ]
}, $9af1097fda9f2b31$var$ul = {
    findFiberByHostInstance: $9af1097fda9f2b31$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9af1097fda9f2b31$var$vl = {
    bundleType: $9af1097fda9f2b31$var$ul.bundleType,
    version: $9af1097fda9f2b31$var$ul.version,
    rendererPackageName: $9af1097fda9f2b31$var$ul.rendererPackageName,
    rendererConfig: $9af1097fda9f2b31$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9af1097fda9f2b31$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $9af1097fda9f2b31$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9af1097fda9f2b31$var$ul.findFiberByHostInstance || $9af1097fda9f2b31$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9af1097fda9f2b31$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9af1097fda9f2b31$var$wl.isDisabled && $9af1097fda9f2b31$var$wl.supportsFiber) try {
        $9af1097fda9f2b31$var$kc = $9af1097fda9f2b31$var$wl.inject($9af1097fda9f2b31$var$vl), $9af1097fda9f2b31$var$lc = $9af1097fda9f2b31$var$wl;
    } catch (a) {}
}
$9af1097fda9f2b31$export$ae55be85d98224ed = $9af1097fda9f2b31$var$tl;
$9af1097fda9f2b31$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9af1097fda9f2b31$var$ol(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$dl(a, b, null, c);
};
$9af1097fda9f2b31$export$882461b6382ed46c = function(a, b) {
    if (!$9af1097fda9f2b31$var$ol(a)) throw Error($9af1097fda9f2b31$var$p(299));
    var c = !1, d = "", e = $9af1097fda9f2b31$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9af1097fda9f2b31$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9af1097fda9f2b31$var$uf] = b.current;
    $9af1097fda9f2b31$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9af1097fda9f2b31$var$ml(b);
};
$9af1097fda9f2b31$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9af1097fda9f2b31$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9af1097fda9f2b31$var$p(268, a));
    }
    a = $9af1097fda9f2b31$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9af1097fda9f2b31$export$cd75ccfd720a3cd4 = function(a) {
    return $9af1097fda9f2b31$var$Sk(a);
};
$9af1097fda9f2b31$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$pl(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$sl(null, a, b, !0, c);
};
$9af1097fda9f2b31$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$ol(a)) throw Error($9af1097fda9f2b31$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9af1097fda9f2b31$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9af1097fda9f2b31$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9af1097fda9f2b31$var$uf] = b.current;
    $9af1097fda9f2b31$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9af1097fda9f2b31$var$nl(b);
};
$9af1097fda9f2b31$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9af1097fda9f2b31$var$pl(b)) throw Error($9af1097fda9f2b31$var$p(200));
    return $9af1097fda9f2b31$var$sl(null, a, b, !1, c);
};
$9af1097fda9f2b31$export$502457920280e6be = function(a) {
    if (!$9af1097fda9f2b31$var$pl(a)) throw Error($9af1097fda9f2b31$var$p(40));
    return a._reactRootContainer ? ($9af1097fda9f2b31$var$Sk(function() {
        $9af1097fda9f2b31$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9af1097fda9f2b31$var$uf] = null;
        });
    }), !0) : !1;
};
$9af1097fda9f2b31$export$c78a37762a8d58e1 = $9af1097fda9f2b31$var$Rk;
$9af1097fda9f2b31$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9af1097fda9f2b31$var$pl(c)) throw Error($9af1097fda9f2b31$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9af1097fda9f2b31$var$p(38));
    return $9af1097fda9f2b31$var$sl(a, b, c, !1, d);
};
$9af1097fda9f2b31$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("uOv5F", function(module, exports) {
"use strict";

module.exports = (parcelRequire("b9vhv"));

});
parcelRegister("b9vhv", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $81e8ccd2b0929bab$export$c4744153514ff05d; }, function (v) { return $81e8ccd2b0929bab$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7; }, function (v) { return $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $81e8ccd2b0929bab$export$e26fe2ed2fa76875; }, function (v) { return $81e8ccd2b0929bab$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $81e8ccd2b0929bab$export$502329bbf4b505b1; }, function (v) { return $81e8ccd2b0929bab$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $81e8ccd2b0929bab$export$6e3807111c4874c4; }, function (v) { return $81e8ccd2b0929bab$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $81e8ccd2b0929bab$export$c27134553091fb3a; }, function (v) { return $81e8ccd2b0929bab$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $81e8ccd2b0929bab$export$33ee1acdc04fd2a2; }, function (v) { return $81e8ccd2b0929bab$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $81e8ccd2b0929bab$export$b00a404bbd5edef2; }, function (v) { return $81e8ccd2b0929bab$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $81e8ccd2b0929bab$export$8352ce38b91d0c62; }, function (v) { return $81e8ccd2b0929bab$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $81e8ccd2b0929bab$export$d66a1c1c77bd778b; }, function (v) { return $81e8ccd2b0929bab$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $81e8ccd2b0929bab$export$d3dfb8e4810cb555; }, function (v) { return $81e8ccd2b0929bab$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $81e8ccd2b0929bab$export$839f9183b0465a69; }, function (v) { return $81e8ccd2b0929bab$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $81e8ccd2b0929bab$export$72fdf0e06517287b; }, function (v) { return $81e8ccd2b0929bab$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $81e8ccd2b0929bab$export$4b844e58a3e414b4; }, function (v) { return $81e8ccd2b0929bab$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $81e8ccd2b0929bab$export$816d2913ae6b83b1; }, function (v) { return $81e8ccd2b0929bab$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $81e8ccd2b0929bab$export$61bcfe829111a1d0; }, function (v) { return $81e8ccd2b0929bab$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $81e8ccd2b0929bab$export$7ee8c9beb337bc3f; }, function (v) { return $81e8ccd2b0929bab$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $81e8ccd2b0929bab$export$b5836b71941fa3ed; }, function (v) { return $81e8ccd2b0929bab$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $81e8ccd2b0929bab$export$cf845f2c119da08a; }, function (v) { return $81e8ccd2b0929bab$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81e8ccd2b0929bab$export$c4744153514ff05d;
var $81e8ccd2b0929bab$export$3e506c1ccc9cc1a7;
var $81e8ccd2b0929bab$export$e26fe2ed2fa76875;
var $81e8ccd2b0929bab$export$502329bbf4b505b1;
var $81e8ccd2b0929bab$export$6e3807111c4874c4;
var $81e8ccd2b0929bab$export$c27134553091fb3a;
var $81e8ccd2b0929bab$export$33ee1acdc04fd2a2;
var $81e8ccd2b0929bab$export$b00a404bbd5edef2;
var $81e8ccd2b0929bab$export$8352ce38b91d0c62;
var $81e8ccd2b0929bab$export$d66a1c1c77bd778b;
var $81e8ccd2b0929bab$export$d3dfb8e4810cb555;
var $81e8ccd2b0929bab$export$839f9183b0465a69;
var $81e8ccd2b0929bab$export$72fdf0e06517287b;
var $81e8ccd2b0929bab$export$4b844e58a3e414b4;
var $81e8ccd2b0929bab$export$816d2913ae6b83b1;
var $81e8ccd2b0929bab$export$61bcfe829111a1d0;
var $81e8ccd2b0929bab$export$7ee8c9beb337bc3f;
var $81e8ccd2b0929bab$export$b5836b71941fa3ed;
var $81e8ccd2b0929bab$export$cf845f2c119da08a;
"use strict";
function $81e8ccd2b0929bab$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $81e8ccd2b0929bab$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $81e8ccd2b0929bab$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $81e8ccd2b0929bab$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $81e8ccd2b0929bab$var$g(C, c)) n < e && 0 > $81e8ccd2b0929bab$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $81e8ccd2b0929bab$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $81e8ccd2b0929bab$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $81e8ccd2b0929bab$var$l = performance;
    $81e8ccd2b0929bab$export$c4744153514ff05d = function() {
        return $81e8ccd2b0929bab$var$l.now();
    };
} else {
    var $81e8ccd2b0929bab$var$p = Date, $81e8ccd2b0929bab$var$q = $81e8ccd2b0929bab$var$p.now();
    $81e8ccd2b0929bab$export$c4744153514ff05d = function() {
        return $81e8ccd2b0929bab$var$p.now() - $81e8ccd2b0929bab$var$q;
    };
}
var $81e8ccd2b0929bab$var$r = [], $81e8ccd2b0929bab$var$t = [], $81e8ccd2b0929bab$var$u = 1, $81e8ccd2b0929bab$var$v = null, $81e8ccd2b0929bab$var$y = 3, $81e8ccd2b0929bab$var$z = !1, $81e8ccd2b0929bab$var$A = !1, $81e8ccd2b0929bab$var$B = !1, $81e8ccd2b0929bab$var$D = "function" === typeof setTimeout ? setTimeout : null, $81e8ccd2b0929bab$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $81e8ccd2b0929bab$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $81e8ccd2b0929bab$var$G(a) {
    for(var b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t); null !== b;){
        if (null === b.callback) $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$t);
        else if (b.startTime <= a) $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$t), b.sortIndex = b.expirationTime, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$r, b);
        else break;
        b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
    }
}
function $81e8ccd2b0929bab$var$H(a) {
    $81e8ccd2b0929bab$var$B = !1;
    $81e8ccd2b0929bab$var$G(a);
    if (!$81e8ccd2b0929bab$var$A) {
        if (null !== $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r)) $81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J);
        else {
            var b = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
            null !== b && $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, b.startTime - a);
        }
    }
}
function $81e8ccd2b0929bab$var$J(a, b) {
    $81e8ccd2b0929bab$var$A = !1;
    $81e8ccd2b0929bab$var$B && ($81e8ccd2b0929bab$var$B = !1, $81e8ccd2b0929bab$var$E($81e8ccd2b0929bab$var$L), $81e8ccd2b0929bab$var$L = -1);
    $81e8ccd2b0929bab$var$z = !0;
    var c = $81e8ccd2b0929bab$var$y;
    try {
        $81e8ccd2b0929bab$var$G(b);
        for($81e8ccd2b0929bab$var$v = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r); null !== $81e8ccd2b0929bab$var$v && (!($81e8ccd2b0929bab$var$v.expirationTime > b) || a && !$81e8ccd2b0929bab$var$M());){
            var d = $81e8ccd2b0929bab$var$v.callback;
            if ("function" === typeof d) {
                $81e8ccd2b0929bab$var$v.callback = null;
                $81e8ccd2b0929bab$var$y = $81e8ccd2b0929bab$var$v.priorityLevel;
                var e = d($81e8ccd2b0929bab$var$v.expirationTime <= b);
                b = $81e8ccd2b0929bab$export$c4744153514ff05d();
                "function" === typeof e ? $81e8ccd2b0929bab$var$v.callback = e : $81e8ccd2b0929bab$var$v === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r) && $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$r);
                $81e8ccd2b0929bab$var$G(b);
            } else $81e8ccd2b0929bab$var$k($81e8ccd2b0929bab$var$r);
            $81e8ccd2b0929bab$var$v = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r);
        }
        if (null !== $81e8ccd2b0929bab$var$v) var w = !0;
        else {
            var m = $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t);
            null !== m && $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $81e8ccd2b0929bab$var$v = null, $81e8ccd2b0929bab$var$y = c, $81e8ccd2b0929bab$var$z = !1;
    }
}
var $81e8ccd2b0929bab$var$N = !1, $81e8ccd2b0929bab$var$O = null, $81e8ccd2b0929bab$var$L = -1, $81e8ccd2b0929bab$var$P = 5, $81e8ccd2b0929bab$var$Q = -1;
function $81e8ccd2b0929bab$var$M() {
    return $81e8ccd2b0929bab$export$c4744153514ff05d() - $81e8ccd2b0929bab$var$Q < $81e8ccd2b0929bab$var$P ? !1 : !0;
}
function $81e8ccd2b0929bab$var$R() {
    if (null !== $81e8ccd2b0929bab$var$O) {
        var a = $81e8ccd2b0929bab$export$c4744153514ff05d();
        $81e8ccd2b0929bab$var$Q = a;
        var b = !0;
        try {
            b = $81e8ccd2b0929bab$var$O(!0, a);
        } finally{
            b ? $81e8ccd2b0929bab$var$S() : ($81e8ccd2b0929bab$var$N = !1, $81e8ccd2b0929bab$var$O = null);
        }
    } else $81e8ccd2b0929bab$var$N = !1;
}
var $81e8ccd2b0929bab$var$S;
if ("function" === typeof $81e8ccd2b0929bab$var$F) $81e8ccd2b0929bab$var$S = function S() {
    $81e8ccd2b0929bab$var$F($81e8ccd2b0929bab$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $81e8ccd2b0929bab$var$T = new MessageChannel, $81e8ccd2b0929bab$var$U = $81e8ccd2b0929bab$var$T.port2;
    $81e8ccd2b0929bab$var$T.port1.onmessage = $81e8ccd2b0929bab$var$R;
    $81e8ccd2b0929bab$var$S = function S() {
        $81e8ccd2b0929bab$var$U.postMessage(null);
    };
} else $81e8ccd2b0929bab$var$S = function S() {
    $81e8ccd2b0929bab$var$D($81e8ccd2b0929bab$var$R, 0);
};
function $81e8ccd2b0929bab$var$I(a) {
    $81e8ccd2b0929bab$var$O = a;
    $81e8ccd2b0929bab$var$N || ($81e8ccd2b0929bab$var$N = !0, $81e8ccd2b0929bab$var$S());
}
function $81e8ccd2b0929bab$var$K(a, b) {
    $81e8ccd2b0929bab$var$L = $81e8ccd2b0929bab$var$D(function() {
        a($81e8ccd2b0929bab$export$c4744153514ff05d());
    }, b);
}
$81e8ccd2b0929bab$export$3e506c1ccc9cc1a7 = 5;
$81e8ccd2b0929bab$export$e26fe2ed2fa76875 = 1;
$81e8ccd2b0929bab$export$502329bbf4b505b1 = 4;
$81e8ccd2b0929bab$export$6e3807111c4874c4 = 3;
$81e8ccd2b0929bab$export$c27134553091fb3a = null;
$81e8ccd2b0929bab$export$33ee1acdc04fd2a2 = 2;
$81e8ccd2b0929bab$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$81e8ccd2b0929bab$export$8352ce38b91d0c62 = function() {
    $81e8ccd2b0929bab$var$A || $81e8ccd2b0929bab$var$z || ($81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J));
};
$81e8ccd2b0929bab$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $81e8ccd2b0929bab$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$81e8ccd2b0929bab$export$d3dfb8e4810cb555 = function() {
    return $81e8ccd2b0929bab$var$y;
};
$81e8ccd2b0929bab$export$839f9183b0465a69 = function() {
    return $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r);
};
$81e8ccd2b0929bab$export$72fdf0e06517287b = function(a) {
    switch($81e8ccd2b0929bab$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $81e8ccd2b0929bab$var$y;
    }
    var c = $81e8ccd2b0929bab$var$y;
    $81e8ccd2b0929bab$var$y = b;
    try {
        return a();
    } finally{
        $81e8ccd2b0929bab$var$y = c;
    }
};
$81e8ccd2b0929bab$export$4b844e58a3e414b4 = function() {};
$81e8ccd2b0929bab$export$816d2913ae6b83b1 = function() {};
$81e8ccd2b0929bab$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $81e8ccd2b0929bab$var$y;
    $81e8ccd2b0929bab$var$y = a;
    try {
        return b();
    } finally{
        $81e8ccd2b0929bab$var$y = c;
    }
};
$81e8ccd2b0929bab$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $81e8ccd2b0929bab$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $81e8ccd2b0929bab$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$t, a), null === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$r) && a === $81e8ccd2b0929bab$var$h($81e8ccd2b0929bab$var$t) && ($81e8ccd2b0929bab$var$B ? ($81e8ccd2b0929bab$var$E($81e8ccd2b0929bab$var$L), $81e8ccd2b0929bab$var$L = -1) : $81e8ccd2b0929bab$var$B = !0, $81e8ccd2b0929bab$var$K($81e8ccd2b0929bab$var$H, c - d))) : (a.sortIndex = e, $81e8ccd2b0929bab$var$f($81e8ccd2b0929bab$var$r, a), $81e8ccd2b0929bab$var$A || $81e8ccd2b0929bab$var$z || ($81e8ccd2b0929bab$var$A = !0, $81e8ccd2b0929bab$var$I($81e8ccd2b0929bab$var$J)));
    return a;
};
$81e8ccd2b0929bab$export$b5836b71941fa3ed = $81e8ccd2b0929bab$var$M;
$81e8ccd2b0929bab$export$cf845f2c119da08a = function(a) {
    var b = $81e8ccd2b0929bab$var$y;
    return function() {
        var c = $81e8ccd2b0929bab$var$y;
        $81e8ccd2b0929bab$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $81e8ccd2b0929bab$var$y = c;
        }
    };
};

});



parcelRegister("5Pgs2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $43de7a0b82198241$export$7c398597f8905a1; });
function $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $43de7a0b82198241$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $43de7a0b82198241$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("50OuQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3a641f6367a2e6bd$export$2996f80ef42b8419; });
function $3a641f6367a2e6bd$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1XfpH", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $16c741eabde15b91$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $16c741eabde15b91$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $qb7pP = parcelRequire("qb7pP");
var $16c741eabde15b91$var$extendStatics = function extendStatics1(d, b) {
    $16c741eabde15b91$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $16c741eabde15b91$var$extendStatics(d, b);
};
function $16c741eabde15b91$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $16c741eabde15b91$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $16c741eabde15b91$export$18ce0697a983be9b = function __assign1() {
    $16c741eabde15b91$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $16c741eabde15b91$export$18ce0697a983be9b.apply(this, arguments);
};
function $16c741eabde15b91$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $16c741eabde15b91$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $16c741eabde15b91$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $16c741eabde15b91$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $16c741eabde15b91$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $16c741eabde15b91$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $qb7pP._)(x)) === "symbol" ? x : "".concat(x);
}
function $16c741eabde15b91$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $qb7pP._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $16c741eabde15b91$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $16c741eabde15b91$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $16c741eabde15b91$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $16c741eabde15b91$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $16c741eabde15b91$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $16c741eabde15b91$export$45d3717a4c69092e(o, m, p);
}
function $16c741eabde15b91$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $16c741eabde15b91$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $16c741eabde15b91$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($16c741eabde15b91$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $16c741eabde15b91$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $16c741eabde15b91$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $16c741eabde15b91$export$10c90e4f7922046c(v) {
    return this instanceof $16c741eabde15b91$export$10c90e4f7922046c ? (this.v = v, this) : new $16c741eabde15b91$export$10c90e4f7922046c(v);
}
function $16c741eabde15b91$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $16c741eabde15b91$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $16c741eabde15b91$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $16c741eabde15b91$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $16c741eabde15b91$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $16c741eabde15b91$export$19a8beecd37a4c45 === "function" ? $16c741eabde15b91$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $16c741eabde15b91$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $16c741eabde15b91$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $16c741eabde15b91$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $16c741eabde15b91$export$45d3717a4c69092e(result, mod, k);
    }
    $16c741eabde15b91$var$__setModuleDefault(result, mod);
    return result;
}
function $16c741eabde15b91$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $16c741eabde15b91$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $16c741eabde15b91$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $16c741eabde15b91$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $16c741eabde15b91$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $16c741eabde15b91$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $16c741eabde15b91$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $16c741eabde15b91$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $16c741eabde15b91$export$2e2bcd8739ae039 = {
    __extends: $16c741eabde15b91$export$a8ba968b8961cb8a,
    __assign: $16c741eabde15b91$export$18ce0697a983be9b,
    __rest: $16c741eabde15b91$export$3c9a16f847548506,
    __decorate: $16c741eabde15b91$export$29e00dfd3077644b,
    __param: $16c741eabde15b91$export$d5ad3fd78186038f,
    __metadata: $16c741eabde15b91$export$f1db080c865becb9,
    __awaiter: $16c741eabde15b91$export$1050f835b63b671e,
    __generator: $16c741eabde15b91$export$67ebef60e6f28a6,
    __createBinding: $16c741eabde15b91$export$45d3717a4c69092e,
    __exportStar: $16c741eabde15b91$export$f33643c0debef087,
    __values: $16c741eabde15b91$export$19a8beecd37a4c45,
    __read: $16c741eabde15b91$export$8d051b38c9118094,
    __spread: $16c741eabde15b91$export$afc72e2116322959,
    __spreadArrays: $16c741eabde15b91$export$6388937ca91ccae8,
    __spreadArray: $16c741eabde15b91$export$1216008129fb82ed,
    __await: $16c741eabde15b91$export$10c90e4f7922046c,
    __asyncGenerator: $16c741eabde15b91$export$e427f37a30a4de9b,
    __asyncDelegator: $16c741eabde15b91$export$bbd80228419bb833,
    __asyncValues: $16c741eabde15b91$export$e3b29a3d6162315f,
    __makeTemplateObject: $16c741eabde15b91$export$4fb47efe1390b86f,
    __importStar: $16c741eabde15b91$export$c21735bcef00d192,
    __importDefault: $16c741eabde15b91$export$da59b14a69baef04,
    __classPrivateFieldGet: $16c741eabde15b91$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $16c741eabde15b91$export$d40a35129aaff81f,
    __classPrivateFieldIn: $16c741eabde15b91$export$81fdc39f203e4e04,
    __addDisposableResource: $16c741eabde15b91$export$88ac25d8e944e405,
    __disposeResources: $16c741eabde15b91$export$8f076105dc360e92
};

});

parcelRegister("fGdZr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b6a5a160ea364895$export$d60067ff2358eee8; });
function $b6a5a160ea364895$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b6a5a160ea364895$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $b6a5a160ea364895$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b6a5a160ea364895$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("1atwj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0d9d9fb902e40dd3$export$7e4530ad35d3bb8; });

var $4USSx = parcelRequire("4USSx");
function $0d9d9fb902e40dd3$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $4USSx._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("4USSx", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $3946f6227d05c830$export$c2c98ac76e997b63; });
function $3946f6227d05c830$export$c2c98ac76e997b63(o, p) {
    $3946f6227d05c830$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3946f6227d05c830$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("iD0Am", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d8fc52c99c9971ba$export$8dd05c13f5255580; });

var $bykok = parcelRequire("bykok");

var $kW87r = parcelRequire("kW87r");

var $9FVhl = parcelRequire("9FVhl");
function $d8fc52c99c9971ba$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $kW87r._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $bykok._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $bykok._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9FVhl._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("bykok", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $8692aff7579d247b$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $8692aff7579d247b$export$f09211a7d3c496a1; });
function $8692aff7579d247b$export$f09211a7d3c496a1(o) {
    $8692aff7579d247b$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8692aff7579d247b$export$f09211a7d3c496a1(o);
}

});

parcelRegister("kW87r", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $f3df85b7abd0198b$export$685354647fba1516; });
function $f3df85b7abd0198b$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9FVhl", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $70b45fc14ae715f9$export$ef97c660ca164e52; });

var $dMjkN = parcelRequire("dMjkN");

var $qb7pP = parcelRequire("qb7pP");
function $70b45fc14ae715f9$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $qb7pP._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $dMjkN._assert_this_initialized)(self);
}

});
parcelRegister("dMjkN", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $a07ec17282910409$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $a07ec17282910409$export$f3b8ed2e4a5d10b8; });
function $a07ec17282910409$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("7bnAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53abdbccf28adaef$export$2e2bcd8739ae039; });

var $3aC2T = parcelRequire("3aC2T");
var $53abdbccf28adaef$var$UserContext = /*#__PURE__*/ (0, $3aC2T.createContext)({
    loggedInUser: "Default User"
});
var $53abdbccf28adaef$export$2e2bcd8739ae039 = $53abdbccf28adaef$var$UserContext;

});

parcelRegister("kKMGt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $f1bdde29c88e2618$export$bf730a2d8bf68b42; }, function (v) { return $f1bdde29c88e2618$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f1bdde29c88e2618$export$bf730a2d8bf68b42;
"use strict";

var $3aC2T = parcelRequire("3aC2T");
function $f1bdde29c88e2618$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $f1bdde29c88e2618$var$p = "function" === typeof Object.is ? Object.is : $f1bdde29c88e2618$var$n, $f1bdde29c88e2618$var$q = $3aC2T.useSyncExternalStore, $f1bdde29c88e2618$var$r = $3aC2T.useRef, $f1bdde29c88e2618$var$t = $3aC2T.useEffect, $f1bdde29c88e2618$var$u = $3aC2T.useMemo, $f1bdde29c88e2618$var$v = $3aC2T.useDebugValue;
$f1bdde29c88e2618$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $f1bdde29c88e2618$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $f1bdde29c88e2618$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($f1bdde29c88e2618$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $f1bdde29c88e2618$var$q(a, c[0], c[1]);
    $f1bdde29c88e2618$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $f1bdde29c88e2618$var$v(d);
    return d;
};

});

parcelRegister("9T74l", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $dMjkN = parcelRequire("dMjkN");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $jc6v0 = parcelRequire("jc6v0");

var $iD0Am = parcelRequire("iD0Am");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol["for"]("immer-nothing");
var DRAFTABLE = Symbol["for"]("immer-draftable");
var DRAFT_STATE = Symbol["for"]("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(function(param) {
        var _param = (0, $aSMts._)(param, 2), key = _param[0], value = _param[1];
        iter(key, value, obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && isPlainObject(base)) {
        if (!getPrototypeOf(base)) {
            var obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return __spreadValues({}, base);
    }
    var descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    var keys = Reflect.ownKeys(descriptors);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj["delete"] = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) each(obj, function(_key, value) {
        return freeze(value, true);
    }, true);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        }, true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $50OuQ._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _this = this;
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $dHvbf._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $dHvbf._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $fGdZr._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base["delete"](key);
                        case 3 /* Set */ :
                            return base["delete"](patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $aSMts._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $1atwj._)(DraftMap, Map1);
        var _super = (0, $iD0Am._)(DraftMap);
        function DraftMap(target, parent) {
            (0, $50OuQ._)(this, DraftMap);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: (0, $dMjkN._)(_this),
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $fGdZr._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_["delete"](key);
                    state.copy_["delete"](key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $2iBlG._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $2iBlG._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $2iBlG._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $2iBlG._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $jc6v0._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $1atwj._)(DraftSet, Set1);
        var _super = (0, $iD0Am._)(DraftSet);
        function DraftSet(target, parent) {
            (0, $50OuQ._)(this, DraftSet);
            var _this;
            _this = _super.call(this);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: (0, $dMjkN._)(_this),
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $fGdZr._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_["delete"](value) || (state.drafts_.has(value) ? state.copy_["delete"](state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $jc6v0._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("2iBlG", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $1aca3bdf51b67d66$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $1aca3bdf51b67d66$export$1e71eb4bef00f6b0; });
function $1aca3bdf51b67d66$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("dHvbf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9f977a4a91aacb97$export$1b5e630bc3aea29f; });

var $hKgIo = parcelRequire("hKgIo");

var $2j9E4 = parcelRequire("2j9E4");

var $55t4W = parcelRequire("55t4W");

var $fXGmO = parcelRequire("fXGmO");
function $9f977a4a91aacb97$export$1b5e630bc3aea29f(arr) {
    return (0, $hKgIo._array_without_holes)(arr) || (0, $2j9E4._iterable_to_array)(arr) || (0, $fXGmO._unsupported_iterable_to_array)(arr) || (0, $55t4W._non_iterable_spread)();
}

});
parcelRegister("hKgIo", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $ceb3b2d1d8d8e799$export$7e0947b5ad3404e2; });

var $5B3Hz = parcelRequire("5B3Hz");
function $ceb3b2d1d8d8e799$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $5B3Hz._array_like_to_array)(arr);
}

});

parcelRegister("2j9E4", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $1ae4d67339a61e6c$export$1eb58a6e75231000; });
function $1ae4d67339a61e6c$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("55t4W", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $3b43f9d018915a54$export$e6f3c4780d19eb2b; });
function $3b43f9d018915a54$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jc6v0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $df942de5c60d7946$export$2466d533fda16e33; });

var $kkvIW = parcelRequire("kkvIW");

var $bykok = parcelRequire("bykok");

var $lCPdn = parcelRequire("lCPdn");

var $4USSx = parcelRequire("4USSx");
function $df942de5c60d7946$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $df942de5c60d7946$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $lCPdn._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $kkvIW._construct)(Class, arguments, (0, $bykok._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $4USSx._set_prototype_of)(Wrapper, Class);
    };
    return $df942de5c60d7946$export$2466d533fda16e33(Class);
}

});
parcelRegister("kkvIW", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $ecce489e508aa395$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $ecce489e508aa395$export$2d841144c5f8c4ab; });

var $kW87r = parcelRequire("kW87r");

var $4USSx = parcelRequire("4USSx");
function $ecce489e508aa395$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $kW87r._is_native_reflect_construct)()) $ecce489e508aa395$export$2d841144c5f8c4ab = Reflect.construct;
    else $ecce489e508aa395$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $4USSx._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $ecce489e508aa395$export$2d841144c5f8c4ab.apply(null, arguments);
}

});

parcelRegister("lCPdn", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $fbe4dfc35693931c$export$514eda94019f4334; });
function $fbe4dfc35693931c$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("aVp1z", function(module, exports) {


module.exports = (parcelRequire("iwOd7"))((parcelRequire("7meeL")).resolve("5ykGR")).then(function() {
    return parcelRequire("i73Vv");
});

});
parcelRegister("iwOd7", function(module, exports) {
"use strict";

var $axrlS = parcelRequire("axrlS");
module.exports = $axrlS(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("axrlS", function(module, exports) {
"use strict";
var $7ac233fabe109637$var$cachedBundles = {};
var $7ac233fabe109637$var$cachedPreloads = {};
var $7ac233fabe109637$var$cachedPrefetches = {};
function $7ac233fabe109637$var$getCache(type) {
    switch(type){
        case "preload":
            return $7ac233fabe109637$var$cachedPreloads;
        case "prefetch":
            return $7ac233fabe109637$var$cachedPrefetches;
        default:
            return $7ac233fabe109637$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7ac233fabe109637$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lLa62", function(module, exports) {


module.exports = (parcelRequire("iwOd7"))((parcelRequire("7meeL")).resolve("k5wDQ")).then(function() {
    return parcelRequire("9W3fe");
});

});


var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
var $931d92b7390d92a2$exports = {};

$parcel$export($931d92b7390d92a2$exports, "createRoot", function () { return $931d92b7390d92a2$export$882461b6382ed46c; }, function (v) { return $931d92b7390d92a2$export$882461b6382ed46c = v; });
$parcel$export($931d92b7390d92a2$exports, "hydrateRoot", function () { return $931d92b7390d92a2$export$757ceba2d55c277e; }, function (v) { return $931d92b7390d92a2$export$757ceba2d55c277e = v; });
var $931d92b7390d92a2$export$882461b6382ed46c;
var $931d92b7390d92a2$export$757ceba2d55c277e;
"use strict";
var $cd654765cc6da6c6$exports = {};
"use strict";
function $cd654765cc6da6c6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($cd654765cc6da6c6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$cd654765cc6da6c6$var$checkDCE();

$cd654765cc6da6c6$exports = (parcelRequire("diKvV"));


var $931d92b7390d92a2$var$i;
$931d92b7390d92a2$export$882461b6382ed46c = $cd654765cc6da6c6$exports.createRoot;
$931d92b7390d92a2$export$757ceba2d55c277e = $cd654765cc6da6c6$exports.hydrateRoot;



var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
var $5e853a1acc52f212$exports = {};

$5e853a1acc52f212$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + "FEAST_FLEET.2fbdbd07.svg";


/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $aSMts = parcelRequire("aSMts");

var $1XfpH = parcelRequire("1XfpH");

var $3aC2T = parcelRequire("3aC2T");

/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $jG3FW = parcelRequire("jG3FW");

var $2j9E4 = parcelRequire("2j9E4");

var $8V4Ru = parcelRequire("8V4Ru");

var $fXGmO = parcelRequire("fXGmO");
function $9556b458da292bff$export$e62c166da838fa3(arr) {
    return (0, $jG3FW._array_with_holes)(arr) || (0, $2j9E4._iterable_to_array)(arr) || (0, $fXGmO._unsupported_iterable_to_array)(arr) || (0, $8V4Ru._non_iterable_rest)();
}



var $dHvbf = parcelRequire("dHvbf");

var $jc6v0 = parcelRequire("jc6v0");

var $iD0Am = parcelRequire("iD0Am");

var $1XfpH = parcelRequire("1XfpH");

var $1XfpH = parcelRequire("1XfpH");
function $55437416549418ff$var$_extends() {
    $55437416549418ff$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55437416549418ff$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55437416549418ff$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55437416549418ff$export$e19cd5f9376f8cee || ($55437416549418ff$export$e19cd5f9376f8cee = {}));
var $55437416549418ff$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55437416549418ff$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $55437416549418ff$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55437416549418ff$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55437416549418ff$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $55437416549418ff$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
    }
    return $55437416549418ff$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55437416549418ff$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $55437416549418ff$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55437416549418ff$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55437416549418ff$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55437416549418ff$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55437416549418ff$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55437416549418ff$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55437416549418ff$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55437416549418ff$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55437416549418ff$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $55437416549418ff$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55437416549418ff$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55437416549418ff$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55437416549418ff$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55437416549418ff$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55437416549418ff$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Push;
        var location = $55437416549418ff$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $55437416549418ff$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
        var location = $55437416549418ff$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $55437416549418ff$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $55437416549418ff$export$fe53371bee54353d(to);
        $55437416549418ff$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55437416549418ff$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($55437416549418ff$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55437416549418ff$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55437416549418ff$var$ResultType || ($55437416549418ff$var$ResultType = {}));
var $55437416549418ff$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55437416549418ff$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55437416549418ff$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $dHvbf._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55437416549418ff$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55437416549418ff$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($55437416549418ff$var$isIndexRoute(route)) {
            var indexRoute = $55437416549418ff$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $55437416549418ff$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55437416549418ff$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $55437416549418ff$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $55437416549418ff$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $55437416549418ff$var$flattenRoutes(routes);
    $55437416549418ff$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $55437416549418ff$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $55437416549418ff$var$safelyDecodeURI(pathname));
    return matches;
}
function $55437416549418ff$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55437416549418ff$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55437416549418ff$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $55437416549418ff$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55437416549418ff$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $55437416549418ff$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55437416549418ff$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $55437416549418ff$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55437416549418ff$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $9556b458da292bff$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $55437416549418ff$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $dHvbf._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $dHvbf._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $55437416549418ff$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $55437416549418ff$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $55437416549418ff$var$paramRe = /^:[\w-]+$/;
var $55437416549418ff$var$dynamicSegmentValue = 3;
var $55437416549418ff$var$indexRouteValue = 2;
var $55437416549418ff$var$emptySegmentValue = 1;
var $55437416549418ff$var$staticSegmentValue = 10;
var $55437416549418ff$var$splatPenalty = -2;
var $55437416549418ff$var$isSplat = function(s) {
    return s === "*";
};
function $55437416549418ff$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($55437416549418ff$var$isSplat)) initialScore += $55437416549418ff$var$splatPenalty;
    if (index) initialScore += $55437416549418ff$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$55437416549418ff$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($55437416549418ff$var$paramRe.test(segment) ? $55437416549418ff$var$dynamicSegmentValue : segment === "" ? $55437416549418ff$var$emptySegmentValue : $55437416549418ff$var$staticSegmentValue);
    }, initialScore);
}
function $55437416549418ff$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55437416549418ff$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $55437416549418ff$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55437416549418ff$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55437416549418ff$export$a5c6d149b50c1d86($55437416549418ff$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55437416549418ff$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $55437416549418ff$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $aSMts._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $55437416549418ff$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $55437416549418ff$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $aSMts._)($55437416549418ff$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $55437416549418ff$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55437416549418ff$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55437416549418ff$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55437416549418ff$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $55437416549418ff$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $55437416549418ff$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55437416549418ff$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $55437416549418ff$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55437416549418ff$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55437416549418ff$var$normalizeSearch(search),
        hash: $55437416549418ff$var$normalizeHash(hash)
    };
}
function $55437416549418ff$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55437416549418ff$var$getInvalidPathError(_char, field, dest, path) {
    return "Cannot include a '" + _char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55437416549418ff$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55437416549418ff$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $55437416549418ff$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === matches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $55437416549418ff$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $55437416549418ff$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55437416549418ff$var$_extends({}, toArg);
        $55437416549418ff$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55437416549418ff$var$getInvalidPathError("?", "pathname", "search", to));
        $55437416549418ff$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55437416549418ff$var$getInvalidPathError("#", "pathname", "hash", to));
        $55437416549418ff$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55437416549418ff$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $55437416549418ff$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55437416549418ff$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $55437416549418ff$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $55437416549418ff$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $55437416549418ff$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $55437416549418ff$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $55437416549418ff$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55437416549418ff$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $55437416549418ff$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $1atwj._)(AbortedDeferredError, Error1);
    var _super = (0, $iD0Am._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $50OuQ._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $jc6v0._)(Error));
var $55437416549418ff$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $50OuQ._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55437416549418ff$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $55437416549418ff$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $aSMts._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $2iBlG._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $fGdZr._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise["catch"](function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $55437416549418ff$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet["delete"](key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers["delete"](fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet["delete"](k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $5Pgs2._)(function() {
                    var aborted, onAbort;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $55437416549418ff$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $aSMts._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $2iBlG._)({}, key, $55437416549418ff$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $55437416549418ff$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55437416549418ff$var$unwrapTrackedPromise(value) {
    if (!$55437416549418ff$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $55437416549418ff$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55437416549418ff$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $55437416549418ff$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55437416549418ff$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $55437416549418ff$export$a6cd19cd1951a23c = function(url, init) {
    var response = $55437416549418ff$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $55437416549418ff$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $50OuQ._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55437416549418ff$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $55437416549418ff$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $55437416549418ff$var$validMutationMethods = new Set($55437416549418ff$var$validMutationMethodsArr);
var $55437416549418ff$var$validRequestMethodsArr = [
    "get"
].concat((0, $dHvbf._)($55437416549418ff$var$validMutationMethodsArr));
var $55437416549418ff$var$validRequestMethods = new Set($55437416549418ff$var$validRequestMethodsArr);
var $55437416549418ff$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $55437416549418ff$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $55437416549418ff$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $55437416549418ff$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $55437416549418ff$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $55437416549418ff$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $55437416549418ff$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $55437416549418ff$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55437416549418ff$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $55437416549418ff$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $55437416549418ff$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $55437416549418ff$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $55437416549418ff$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $2iBlG._)({}, route.id, error);
    }
    var initialized;
    var hasLazyRoutes = initialMatches.some(function(m) {
        return m.route.lazy;
    });
    var hasLoaders = initialMatches.some(function(m) {
        return m.route.loader;
    });
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every(function(m) {
            return m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55437416549418ff$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $55437416549418ff$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55437416549418ff$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55437416549418ff$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $55437416549418ff$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55437416549418ff$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers["delete"](fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55437416549418ff$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $dHvbf._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers["delete"](key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $55437416549418ff$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $55437416549418ff$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $55437416549418ff$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55437416549418ff$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55437416549418ff$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55437416549418ff$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55437416549418ff$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $5Pgs2._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $55437416549418ff$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $55437416549418ff$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $55437416549418ff$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $55437416549418ff$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $55437416549418ff$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $55437416549418ff$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $55437416549418ff$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $5Pgs2._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $55437416549418ff$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $55437416549418ff$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $2iBlG._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $55437416549418ff$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55437416549418ff$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $55437416549418ff$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $2iBlG._)({}, $55437416549418ff$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $55437416549418ff$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $55437416549418ff$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $55437416549418ff$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $5Pgs2._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $55437416549418ff$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        actionMatch = $55437416549418ff$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $55437416549418ff$var$ResultType.error,
                            error: $55437416549418ff$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$55437416549418ff$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($55437416549418ff$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $55437416549418ff$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $2iBlG._)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($55437416549418ff$var$isDeferredResult(result)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $5Pgs2._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $55437416549418ff$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $55437416549418ff$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $aSMts._)($55437416549418ff$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $55437416549418ff$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since iot's not a "navigation"
                        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $55437416549418ff$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($55437416549418ff$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers["delete"](rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $55437416549418ff$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        // Process and commit output from loaders
                        _processLoaderData = $55437416549418ff$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds["delete"](routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $55437416549418ff$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $55437416549418ff$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $55437416549418ff$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $55437416549418ff$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $55437416549418ff$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $55437416549418ff$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55437416549418ff$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $5Pgs2._)(function(key, routeId, path, match, requestMatches, flushSync, submission) {
            var error, existingFetcher, abortController, fetchRequest, originatingLoadId, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches["delete"](key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $55437416549418ff$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $55437416549418ff$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = $55437416549418ff$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($55437416549418ff$var$isRedirectResult(actionResult) || $55437416549418ff$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $55437416549418ff$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($55437416549418ff$var$isRedirectResult(actionResult)) {
                                fetchControllers["delete"](key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $55437416549418ff$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $55437416549418ff$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(state, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($55437416549418ff$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($55437416549418ff$var$isDeferredResult(actionResult)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $55437416549418ff$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $55437416549418ff$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $55437416549418ff$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $55437416549418ff$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $aSMts._)($55437416549418ff$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $2iBlG._)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $55437416549418ff$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds["delete"](key);
                        fetchControllers["delete"](key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers["delete"](r.key);
                        });
                        redirect = $55437416549418ff$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $55437416549418ff$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $55437416549418ff$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $55437416549418ff$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $55437416549418ff$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $5Pgs2._)(function(key, routeId, path, match, matches, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, originatingLoadId, result;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $55437416549418ff$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = $55437416549418ff$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$55437416549418ff$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $55437416549418ff$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers["delete"](key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $55437416549418ff$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$55437416549418ff$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $55437416549418ff$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($55437416549418ff$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $55437416549418ff$export$3e9cee6b33872309(!$55437416549418ff$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $55437416549418ff$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $5Pgs2._)(function(state, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $55437416549418ff$var$createLocation(state.location, redirect.location, {
                            _isRedirect: true
                        });
                        $55437416549418ff$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($55437416549418ff$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                                url = init.history.createURL(redirect.location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $55437416549418ff$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $55437416549418ff$export$e19cd5f9376f8cee.Replace : $55437416549418ff$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55437416549418ff$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($55437416549418ff$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $55437416549418ff$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $55437416549418ff$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $55437416549418ff$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $5Pgs2._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $dHvbf._)(matchesToLoad.map(function(match) {
                                return $55437416549418ff$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                            })).concat((0, $dHvbf._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $55437416549418ff$var$callLoaderOrAction("loader", $55437416549418ff$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                                else {
                                    var error = {
                                        type: $55437416549418ff$var$ResultType.error,
                                        error: $55437416549418ff$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $55437416549418ff$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $55437416549418ff$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $dHvbf._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $55437416549418ff$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $2iBlG._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers["delete"](key);
        }
        return state.fetchers.get(key) || $55437416549418ff$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches["delete"](key);
        fetchReloadIds["delete"](key);
        fetchRedirectIds["delete"](key);
        deletedFetchers["delete"](key);
        state.fetchers["delete"](key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers["delete"](key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $55437416549418ff$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers["delete"](key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $55437416549418ff$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $55437416549418ff$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds["delete"](key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $55437416549418ff$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds["delete"](key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $55437416549418ff$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers["delete"](key);
        blockerFunctions["delete"](key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $55437416549418ff$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55437416549418ff$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55437416549418ff$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $aSMts._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds["delete"](routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55437416549418ff$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $55437416549418ff$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $55437416549418ff$export$4d0306f8f6a4585b = Symbol("deferred");
function $55437416549418ff$export$3336b097a6fbc59a(routes, opts) {
    $55437416549418ff$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $55437416549418ff$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $55437416549418ff$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $55437416549418ff$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $5Pgs2._)(function(request, _temp3) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp3 === void 0 ? {} : _temp3).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $55437416549418ff$var$createLocation("", $55437416549418ff$export$fe53371bee54353d(url), null, "default");
                        matches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$55437416549418ff$var$isValidMethod(method) && method !== "HEAD") {
                            error = $55437416549418ff$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $2iBlG._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $55437416549418ff$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $55437416549418ff$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $2iBlG._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($55437416549418ff$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $55437416549418ff$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $5Pgs2._)(function(request, _temp4) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $55437416549418ff$var$createLocation("", $55437416549418ff$export$fe53371bee54353d(url), null, "default");
                        matches = $55437416549418ff$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$55437416549418ff$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55437416549418ff$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $55437416549418ff$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $55437416549418ff$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $55437416549418ff$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $55437416549418ff$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($55437416549418ff$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55437416549418ff$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $5Pgs2._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $55437416549418ff$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$55437416549418ff$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $55437416549418ff$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $55437416549418ff$var$isResponse(result1) ? result1 : $55437416549418ff$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($55437416549418ff$var$isQueryRouteResponse(e)) {
                            if (e.type === $55437416549418ff$var$ResultType.error) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($55437416549418ff$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $5Pgs2._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $55437416549418ff$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $55437416549418ff$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $55437416549418ff$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) $55437416549418ff$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($55437416549418ff$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($55437416549418ff$var$isDeferredResult(result)) {
                            error1 = $55437416549418ff$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $55437416549418ff$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($55437416549418ff$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$55437416549418ff$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $2iBlG._)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context, {
                                statusCode: $55437416549418ff$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $55437416549418ff$var$_extends({}, result.headers ? (0, $2iBlG._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $2iBlG._)({}, actionMatch.route.id, result.data),
                                actionHeaders: $55437416549418ff$var$_extends({}, result.headers ? (0, $2iBlG._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $5Pgs2._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55437416549418ff$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $2iBlG._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $dHvbf._)(matchesToLoad.map(function(match) {
                                return $55437416549418ff$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $55437416549418ff$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $55437416549418ff$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55437416549418ff$export$fec11da027c70692(routes, context, error) {
    var newContext = $55437416549418ff$var$_extends({}, context, {
        statusCode: $55437416549418ff$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $2iBlG._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $55437416549418ff$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55437416549418ff$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55437416549418ff$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $55437416549418ff$export$cae722b0cc860f13(to ? to : ".", $55437416549418ff$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55437416549418ff$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$55437416549418ff$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55437416549418ff$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55437416549418ff$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55437416549418ff$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55437416549418ff$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55437416549418ff$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55437416549418ff$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $55437416549418ff$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $55437416549418ff$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55437416549418ff$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $aSMts._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55437416549418ff$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55437416549418ff$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $55437416549418ff$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55437416549418ff$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55437416549418ff$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55437416549418ff$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55437416549418ff$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $55437416549418ff$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55437416549418ff$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55437416549418ff$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $55437416549418ff$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $55437416549418ff$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($55437416549418ff$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $55437416549418ff$var$shouldRevalidateLoader(match, $55437416549418ff$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55437416549418ff$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $55437416549418ff$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $55437416549418ff$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55437416549418ff$var$shouldRevalidateLoader(fetcherMatch, $55437416549418ff$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55437416549418ff$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55437416549418ff$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55437416549418ff$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55437416549418ff$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $55437416549418ff$var$_loadLazyRouteModule.apply(this, arguments);
}
function $55437416549418ff$var$_loadLazyRouteModule() {
    $55437416549418ff$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $5Pgs2._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $55437416549418ff$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $55437416549418ff$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$55437416549418ff$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $55437416549418ff$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $55437416549418ff$var$_loadLazyRouteModule.apply(this, arguments);
}
function $55437416549418ff$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    return $55437416549418ff$var$_callLoaderOrAction.apply(this, arguments);
}
function $55437416549418ff$var$_callLoaderOrAction() {
    $55437416549418ff$var$_callLoaderOrAction = (0, $5Pgs2._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
        var resultType, result, onReject, runHandler, handler, handlerError, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, queryRouteResponse, data, contentType, e1, _result$init, _result$init2;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler)["catch"](function(e) {
                                handlerError = e;
                            }),
                            $55437416549418ff$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    if (handlerError) throw handlerError;
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $55437416549418ff$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $55437416549418ff$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $55437416549418ff$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $55437416549418ff$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $55437416549418ff$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$55437416549418ff$var$isResponse(result)) return [
                        3,
                        24
                    ];
                    status = result.status;
                    // Process redirects
                    if ($55437416549418ff$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $55437416549418ff$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$55437416549418ff$var$ABSOLUTE_URL_REGEX.test(location)) location = $55437416549418ff$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
                        else if (!opts.isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $55437416549418ff$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) {
                        queryRouteResponse = {
                            type: resultType === $55437416549418ff$var$ResultType.error ? $55437416549418ff$var$ResultType.error : $55437416549418ff$var$ResultType.data,
                            response: result
                        };
                        throw queryRouteResponse;
                    }
                    _state.label = 15;
                case 15:
                    _state.trys.push([
                        15,
                        22,
                        ,
                        23
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        19
                    ];
                    if (!(result.body == null)) return [
                        3,
                        16
                    ];
                    data = null;
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.json()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    return [
                        4,
                        result.text()
                    ];
                case 20:
                    data = _state.sent();
                    _state.label = 21;
                case 21:
                    return [
                        3,
                        23
                    ];
                case 22:
                    e1 = _state.sent();
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.error,
                            error: e1
                        }
                    ];
                case 23:
                    if (resultType === $55437416549418ff$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $55437416549418ff$export$6c6580e81da25755(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 24:
                    if (resultType === $55437416549418ff$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($55437416549418ff$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $55437416549418ff$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55437416549418ff$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($55437416549418ff$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $55437416549418ff$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55437416549418ff$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55437416549418ff$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $55437416549418ff$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $55437416549418ff$export$3e9cee6b33872309(!$55437416549418ff$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55437416549418ff$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $55437416549418ff$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55437416549418ff$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($55437416549418ff$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55437416549418ff$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $55437416549418ff$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $55437416549418ff$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($55437416549418ff$var$isErrorResult(result)) {
            var boundaryMatch = $55437416549418ff$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55437416549418ff$var$_extends({}, errors, (0, $2iBlG._)({}, boundaryMatch.route.id, result.error));
            state.fetchers["delete"](key);
        } else if ($55437416549418ff$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55437416549418ff$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55437416549418ff$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55437416549418ff$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $55437416549418ff$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55437416549418ff$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $55437416549418ff$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55437416549418ff$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $dHvbf._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $55437416549418ff$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55437416549418ff$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $55437416549418ff$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55437416549418ff$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($55437416549418ff$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $55437416549418ff$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(path) : path;
    return $55437416549418ff$export$fe53371bee54353d($55437416549418ff$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55437416549418ff$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55437416549418ff$var$isDeferredResult(result) {
    return result.type === $55437416549418ff$var$ResultType.deferred;
}
function $55437416549418ff$var$isErrorResult(result) {
    return result.type === $55437416549418ff$var$ResultType.error;
}
function $55437416549418ff$var$isRedirectResult(result) {
    return (result && result.type) === $55437416549418ff$var$ResultType.redirect;
}
function $55437416549418ff$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55437416549418ff$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55437416549418ff$var$isRedirectResponse(result) {
    if (!$55437416549418ff$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55437416549418ff$var$isQueryRouteResponse(obj) {
    return obj && $55437416549418ff$var$isResponse(obj.response) && (obj.type === $55437416549418ff$var$ResultType.data || obj.type === $55437416549418ff$var$ResultType.error);
}
function $55437416549418ff$var$isValidMethod(method) {
    return $55437416549418ff$var$validRequestMethods.has(method.toLowerCase());
}
function $55437416549418ff$var$isMutationMethod(method) {
    return $55437416549418ff$var$validMutationMethods.has(method.toLowerCase());
}
function $55437416549418ff$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $55437416549418ff$var$_resolveDeferredResults.apply(this, arguments);
}
function $55437416549418ff$var$_resolveDeferredResults() {
    $55437416549418ff$var$_resolveDeferredResults = (0, $5Pgs2._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $1XfpH.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$55437416549418ff$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($55437416549418ff$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $55437416549418ff$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $55437416549418ff$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $1XfpH.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $55437416549418ff$var$_resolveDeferredResults.apply(this, arguments);
}
function $55437416549418ff$var$resolveDeferredData(result, signal, unwrap) {
    return $55437416549418ff$var$_resolveDeferredData.apply(this, arguments);
}
function $55437416549418ff$var$_resolveDeferredData() {
    $55437416549418ff$var$_resolveDeferredData = (0, $5Pgs2._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $55437416549418ff$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $55437416549418ff$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $55437416549418ff$var$_resolveDeferredData.apply(this, arguments);
}
function $55437416549418ff$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $55437416549418ff$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $55437416549418ff$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55437416549418ff$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $55437416549418ff$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55437416549418ff$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55437416549418ff$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $55437416549418ff$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55437416549418ff$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $55437416549418ff$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55437416549418ff$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55437416549418ff$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($55437416549418ff$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $aSMts._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                        _iterator["return"]();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55437416549418ff$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $aSMts._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $dHvbf._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($55437416549418ff$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55437416549418ff$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $1atwj = parcelRequire("1atwj");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $iD0Am = parcelRequire("iD0Am");

var $3aC2T = parcelRequire("3aC2T");

function $7aa78ce6d363d479$var$_extends() {
    $7aa78ce6d363d479$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7aa78ce6d363d479$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $7aa78ce6d363d479$export$3add0d5dce533e2e = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$145dfa71566a64dc = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$var$AwaitContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $7aa78ce6d363d479$export$26749e8557646306 = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$c7914228fb69b0f5 = /*#__PURE__*/ $3aC2T.createContext(null);
var $7aa78ce6d363d479$export$9072aa6dd1f93057 = /*#__PURE__*/ $3aC2T.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $7aa78ce6d363d479$var$RouteErrorContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7aa78ce6d363d479$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $7aa78ce6d363d479$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55437416549418ff$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7aa78ce6d363d479$export$9c954a9d03d32f4a() {
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7aa78ce6d363d479$export$45d76561a5302f2b() {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7aa78ce6d363d479$export$1b3f31771c5d07c() {
    return $3aC2T.useContext($7aa78ce6d363d479$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7aa78ce6d363d479$export$6c330e8992e8a295(pattern) {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var pathname = $7aa78ce6d363d479$export$45d76561a5302f2b().pathname;
    return $3aC2T.useMemo(function() {
        return (0, $55437416549418ff$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $7aa78ce6d363d479$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306)["static"];
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3aC2T.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7aa78ce6d363d479$export$9770f232ac06a008() {
    var isDataRoute = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7aa78ce6d363d479$var$useNavigateStable() : $7aa78ce6d363d479$var$useNavigateUnstable();
}
function $7aa78ce6d363d479$var$useNavigateUnstable() {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var dataRouterContext = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $55437416549418ff$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $3aC2T.useRef(false);
    $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $3aC2T.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $55437416549418ff$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55437416549418ff$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $7aa78ce6d363d479$var$OutletContext = /*#__PURE__*/ $3aC2T.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7aa78ce6d363d479$export$4138103a3ae699cc() {
    return $3aC2T.useContext($7aa78ce6d363d479$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7aa78ce6d363d479$export$a3be3530d8e40d0b(context) {
    var outlet = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7aa78ce6d363d479$export$99eaa27ddbbb95ef() {
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7aa78ce6d363d479$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306).future;
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $55437416549418ff$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $3aC2T.useMemo(function() {
        return (0, $55437416549418ff$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7aa78ce6d363d479$export$5d3fca4a98652595(routes, locationArg) {
    return $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var navigator = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306).navigator;
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $7aa78ce6d363d479$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $55437416549418ff$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $55437416549418ff$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $7aa78ce6d363d479$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55437416549418ff$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55437416549418ff$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7aa78ce6d363d479$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55437416549418ff$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7aa78ce6d363d479$var$DefaultErrorComponent() {
    var error = $7aa78ce6d363d479$export$ed527bf60f6e05f2();
    var message = (0, $55437416549418ff$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3aC2T.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3aC2T.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $7aa78ce6d363d479$var$defaultErrorElement = /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$DefaultErrorComponent, null);
var $7aa78ce6d363d479$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1atwj._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $iD0Am._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $50OuQ._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $fGdZr._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($3aC2T.Component);
function $7aa78ce6d363d479$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext["static"] && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7aa78ce6d363d479$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7aa78ce6d363d479$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7aa78ce6d363d479$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3aC2T.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7aa78ce6d363d479$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7aa78ce6d363d479$var$DataRouterHook || {});
var $7aa78ce6d363d479$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7aa78ce6d363d479$var$DataRouterStateHook || {});
function $7aa78ce6d363d479$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7aa78ce6d363d479$var$useDataRouterContext(hookName) {
    var ctx = $3aC2T.useContext($7aa78ce6d363d479$export$3add0d5dce533e2e);
    !ctx && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7aa78ce6d363d479$var$useDataRouterState(hookName) {
    var state = $3aC2T.useContext($7aa78ce6d363d479$export$145dfa71566a64dc);
    !state && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return state;
}
function $7aa78ce6d363d479$var$useRouteContext(hookName) {
    var route = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057);
    !route && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7aa78ce6d363d479$var$useCurrentRouteId(hookName) {
    var route = $7aa78ce6d363d479$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7aa78ce6d363d479$export$5fc8298006ad9e58() {
    return $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7aa78ce6d363d479$export$d0fd4b7106de2769() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7aa78ce6d363d479$export$600dc272ed516c15() {
    var dataRouterContext = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseRevalidator);
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRevalidator);
    return $3aC2T.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7aa78ce6d363d479$export$2378eb7f5ff86053() {
    var _useDataRouterState = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $3aC2T.useMemo(function() {
        return matches.map(function(m) {
            return (0, $55437416549418ff$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7aa78ce6d363d479$export$1448a5050d252c4d() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseLoaderData);
    var routeId = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7aa78ce6d363d479$export$fd5d37484eab868d(routeId) {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7aa78ce6d363d479$export$fdc00f3f26066d5e() {
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseActionData);
    var routeId = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7aa78ce6d363d479$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $3aC2T.useContext($7aa78ce6d363d479$var$RouteErrorContext);
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteError);
    var routeId = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7aa78ce6d363d479$export$78a72ddb39bdd145() {
    var value = $3aC2T.useContext($7aa78ce6d363d479$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7aa78ce6d363d479$export$17f53340677d5831() {
    var value = $3aC2T.useContext($7aa78ce6d363d479$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $7aa78ce6d363d479$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7aa78ce6d363d479$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $7aa78ce6d363d479$var$useDataRouterState($7aa78ce6d363d479$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $aSMts._)($3aC2T.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $3aC2T.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $7aa78ce6d363d479$var$_extends({}, currentLocation, {
                pathname: (0, $55437416549418ff$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7aa78ce6d363d479$var$_extends({}, nextLocation, {
                pathname: (0, $55437416549418ff$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3aC2T.useEffect(function() {
        var key = String(++$7aa78ce6d363d479$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3aC2T.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55437416549418ff$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7aa78ce6d363d479$var$useNavigateStable() {
    var router = $7aa78ce6d363d479$var$useDataRouterContext($7aa78ce6d363d479$var$DataRouterHook.UseNavigateStable).router;
    var id = $7aa78ce6d363d479$var$useCurrentRouteId($7aa78ce6d363d479$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $3aC2T.useRef(false);
    $7aa78ce6d363d479$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $3aC2T.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7aa78ce6d363d479$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $7aa78ce6d363d479$var$alreadyWarned = {};
function $7aa78ce6d363d479$var$warningOnce(key, cond, message) {
    if (!cond && !$7aa78ce6d363d479$var$alreadyWarned[key]) $7aa78ce6d363d479$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $7aa78ce6d363d479$var$START_TRANSITION = "startTransition";
var $7aa78ce6d363d479$var$startTransitionImpl = $3aC2T[$7aa78ce6d363d479$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7aa78ce6d363d479$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        if (v7_startTransition && $7aa78ce6d363d479$var$startTransitionImpl) $7aa78ce6d363d479$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3aC2T.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $3aC2T.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $3aC2T.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $3aC2T.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7aa78ce6d363d479$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $7aa78ce6d363d479$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7aa78ce6d363d479$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55437416549418ff$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $7aa78ce6d363d479$var$startTransitionImpl ? $7aa78ce6d363d479$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7aa78ce6d363d479$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var _React_useContext = $3aC2T.useContext($7aa78ce6d363d479$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext["static"];
    var matches = $3aC2T.useContext($7aa78ce6d363d479$export$9072aa6dd1f93057).matches;
    var _useLocation = $7aa78ce6d363d479$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $7aa78ce6d363d479$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $55437416549418ff$export$cae722b0cc860f13)(to, (0, $55437416549418ff$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $3aC2T.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7aa78ce6d363d479$export$910ae8079b2c2852(props) {
    return $7aa78ce6d363d479$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7aa78ce6d363d479$export$e7b0ac011bb776c6(_props) {
    (0, $55437416549418ff$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7aa78ce6d363d479$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $55437416549418ff$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5["static"], staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$7aa78ce6d363d479$export$9c954a9d03d32f4a() && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $3aC2T.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7aa78ce6d363d479$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55437416549418ff$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $3aC2T.useMemo(function() {
        var trailingPathname = (0, $55437416549418ff$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7aa78ce6d363d479$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $7aa78ce6d363d479$export$5d3fca4a98652595($7aa78ce6d363d479$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7aa78ce6d363d479$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$ResolveAwait, null, children));
}
var $7aa78ce6d363d479$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7aa78ce6d363d479$var$AwaitRenderStatus || {});
var $7aa78ce6d363d479$var$neverSettledPromise = new Promise(function() {});
var $7aa78ce6d363d479$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $1atwj._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $iD0Am._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $50OuQ._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $fGdZr._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject()["catch"](function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $7aa78ce6d363d479$var$AwaitRenderStatus.error : promise._data !== undefined ? $7aa78ce6d363d479$var$AwaitRenderStatus.success : $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $7aa78ce6d363d479$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error && promise._error instanceof (0, $55437416549418ff$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $7aa78ce6d363d479$var$neverSettledPromise;
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $7aa78ce6d363d479$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $3aC2T.createElement($7aa78ce6d363d479$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($3aC2T.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7aa78ce6d363d479$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $7aa78ce6d363d479$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7aa78ce6d363d479$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $3aC2T.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $3aC2T.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $dHvbf._)(parentPath).concat([
            index
        ]);
        if (element.type === $3aC2T.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7aa78ce6d363d479$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7aa78ce6d363d479$export$e7b0ac011bb776c6) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7aa78ce6d363d479$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7aa78ce6d363d479$export$daf73786167a7f72(matches) {
    return $7aa78ce6d363d479$var$_renderMatches(matches);
}
function $7aa78ce6d363d479$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3aC2T.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $3aC2T.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3aC2T.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7aa78ce6d363d479$export$f30f7e456d254e83(routes, opts) {
    return (0, $55437416549418ff$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7aa78ce6d363d479$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55437416549418ff$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7aa78ce6d363d479$export$52b333d321859367
    }).initialize();
}



function $453a12ddee1c3125$var$_extends() {
    $453a12ddee1c3125$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $453a12ddee1c3125$var$_extends.apply(this, arguments);
}
function $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $453a12ddee1c3125$var$defaultMethod = "get";
var $453a12ddee1c3125$var$defaultEncType = "application/x-www-form-urlencoded";
function $453a12ddee1c3125$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $453a12ddee1c3125$var$isButtonElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $453a12ddee1c3125$var$isFormElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $453a12ddee1c3125$var$isInputElement(object) {
    return $453a12ddee1c3125$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $453a12ddee1c3125$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $453a12ddee1c3125$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$453a12ddee1c3125$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $453a12ddee1c3125$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $453a12ddee1c3125$var$_formDataSupportsSubmitter = null;
function $453a12ddee1c3125$var$isFormDataSubmitterSupported() {
    if ($453a12ddee1c3125$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $453a12ddee1c3125$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $453a12ddee1c3125$var$_formDataSupportsSubmitter = true;
    }
    return $453a12ddee1c3125$var$_formDataSupportsSubmitter;
}
var $453a12ddee1c3125$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $453a12ddee1c3125$var$getFormEncType(encType) {
    if (encType != null && !$453a12ddee1c3125$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $453a12ddee1c3125$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($453a12ddee1c3125$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $55437416549418ff$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $453a12ddee1c3125$var$defaultMethod;
        encType = $453a12ddee1c3125$var$getFormEncType(target.getAttribute("enctype")) || $453a12ddee1c3125$var$defaultEncType;
        formData = new FormData(target);
    } else if ($453a12ddee1c3125$var$isButtonElement(target) || $453a12ddee1c3125$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $55437416549418ff$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $453a12ddee1c3125$var$defaultMethod;
        encType = $453a12ddee1c3125$var$getFormEncType(target.getAttribute("formenctype")) || $453a12ddee1c3125$var$getFormEncType(form.getAttribute("enctype")) || $453a12ddee1c3125$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$453a12ddee1c3125$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($453a12ddee1c3125$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $453a12ddee1c3125$var$defaultMethod;
        action = null;
        encType = $453a12ddee1c3125$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $453a12ddee1c3125$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $453a12ddee1c3125$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $453a12ddee1c3125$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $453a12ddee1c3125$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $453a12ddee1c3125$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $453a12ddee1c3125$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55437416549418ff$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $453a12ddee1c3125$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55437416549418ff$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $453a12ddee1c3125$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7aa78ce6d363d479$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $453a12ddee1c3125$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55437416549418ff$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $453a12ddee1c3125$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55437416549418ff$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $453a12ddee1c3125$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7aa78ce6d363d479$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $453a12ddee1c3125$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $453a12ddee1c3125$var$_extends({}, state, {
        errors: $453a12ddee1c3125$var$deserializeErrors(state.errors)
    });
    return state;
}
function $453a12ddee1c3125$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55437416549418ff$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $453a12ddee1c3125$export$7ad602f0e94e62d1 = /*#__PURE__*/ $3aC2T.createContext({
    isTransitioning: false
});
var $453a12ddee1c3125$export$148fd98d095596d4 = /*#__PURE__*/ $3aC2T.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $453a12ddee1c3125$var$START_TRANSITION = "startTransition";
var $453a12ddee1c3125$var$startTransitionImpl = $3aC2T[$453a12ddee1c3125$var$START_TRANSITION];
var $453a12ddee1c3125$var$FLUSH_SYNC = "flushSync";
var $453a12ddee1c3125$var$flushSyncImpl = $cd654765cc6da6c6$exports[$453a12ddee1c3125$var$FLUSH_SYNC];
var $453a12ddee1c3125$var$USE_ID = "useId";
var $453a12ddee1c3125$var$useIdImpl = $3aC2T[$453a12ddee1c3125$var$USE_ID];
function $453a12ddee1c3125$var$startTransitionSafe(cb) {
    if ($453a12ddee1c3125$var$startTransitionImpl) $453a12ddee1c3125$var$startTransitionImpl(cb);
    else cb();
}
function $453a12ddee1c3125$var$flushSyncSafe(cb) {
    if ($453a12ddee1c3125$var$flushSyncImpl) $453a12ddee1c3125$var$flushSyncImpl(cb);
    else cb();
}
var $453a12ddee1c3125$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $50OuQ._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $453a12ddee1c3125$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $aSMts._)($3aC2T.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $aSMts._)($3aC2T.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $aSMts._)($3aC2T.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $aSMts._)($3aC2T.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $aSMts._)($3aC2T.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $aSMts._)($3aC2T.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $3aC2T.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $3aC2T.useCallback(function(cb) {
        if (v7_startTransition) $453a12ddee1c3125$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $3aC2T.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current["delete"](key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $453a12ddee1c3125$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $453a12ddee1c3125$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $453a12ddee1c3125$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished["finally"](function() {
                $453a12ddee1c3125$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $453a12ddee1c3125$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3aC2T.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $3aC2T.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $453a12ddee1c3125$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $3aC2T.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $5Pgs2._)(function() {
                return (0, $1XfpH.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished["finally"](function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $3aC2T.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $3aC2T.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $3aC2T.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $3aC2T.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $3aC2T.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3aC2T.createElement($3aC2T.Fragment, null, /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $453a12ddee1c3125$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $7aa78ce6d363d479$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $453a12ddee1c3125$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55437416549418ff$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $453a12ddee1c3125$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $3aC2T.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55437416549418ff$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $453a12ddee1c3125$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $aSMts._)($3aC2T.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $3aC2T.useCallback(function(newState) {
        v7_startTransition && $453a12ddee1c3125$var$startTransitionImpl ? $453a12ddee1c3125$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3aC2T.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3aC2T.createElement((0, $7aa78ce6d363d479$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $453a12ddee1c3125$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $453a12ddee1c3125$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $453a12ddee1c3125$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3aC2T.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref7, $453a12ddee1c3125$var$_excluded);
    var basename = $3aC2T.useContext((0, $7aa78ce6d363d479$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $453a12ddee1c3125$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($453a12ddee1c3125$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $55437416549418ff$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $7aa78ce6d363d479$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $453a12ddee1c3125$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3aC2T.createElement("a", $453a12ddee1c3125$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $453a12ddee1c3125$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3aC2T.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref8, $453a12ddee1c3125$var$_excluded2);
    var path = (0, $7aa78ce6d363d479$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $7aa78ce6d363d479$export$45d76561a5302f2b)();
    var routerState = $3aC2T.useContext((0, $7aa78ce6d363d479$export$145dfa71566a64dc));
    var _React_useContext = $3aC2T.useContext((0, $7aa78ce6d363d479$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $453a12ddee1c3125$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55437416549418ff$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$export$a6c7ac8248d6e38a, $453a12ddee1c3125$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $453a12ddee1c3125$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3aC2T.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $453a12ddee1c3125$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $453a12ddee1c3125$var$_objectWithoutPropertiesLoose(_ref9, $453a12ddee1c3125$var$_excluded3);
    var submit = $453a12ddee1c3125$export$47c85c6e3a081d3();
    var formAction = $453a12ddee1c3125$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $3aC2T.createElement("form", $453a12ddee1c3125$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $453a12ddee1c3125$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $453a12ddee1c3125$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $453a12ddee1c3125$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($453a12ddee1c3125$var$DataRouterHook || ($453a12ddee1c3125$var$DataRouterHook = {}));
var $453a12ddee1c3125$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($453a12ddee1c3125$var$DataRouterStateHook || ($453a12ddee1c3125$var$DataRouterStateHook = {}));
// Internal hooks
function $453a12ddee1c3125$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $453a12ddee1c3125$var$useDataRouterContext(hookName) {
    var ctx = $3aC2T.useContext((0, $7aa78ce6d363d479$export$3add0d5dce533e2e));
    !ctx && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return ctx;
}
function $453a12ddee1c3125$var$useDataRouterState(hookName) {
    var state = $3aC2T.useContext((0, $7aa78ce6d363d479$export$145dfa71566a64dc));
    !state && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $453a12ddee1c3125$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $7aa78ce6d363d479$export$9770f232ac06a008)();
    var location = (0, $7aa78ce6d363d479$export$45d76561a5302f2b)();
    var path = (0, $7aa78ce6d363d479$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $3aC2T.useCallback(function(event) {
        if ($453a12ddee1c3125$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $55437416549418ff$export$fe53371bee54353d)(location) === (0, $55437416549418ff$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $453a12ddee1c3125$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $3aC2T.useRef($453a12ddee1c3125$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $3aC2T.useRef(false);
    var location = (0, $7aa78ce6d363d479$export$45d76561a5302f2b)();
    var searchParams = $3aC2T.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $453a12ddee1c3125$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $7aa78ce6d363d479$export$9770f232ac06a008)();
    var setSearchParams = $3aC2T.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $453a12ddee1c3125$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $453a12ddee1c3125$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $453a12ddee1c3125$var$fetcherId = 0;
var $453a12ddee1c3125$var$getUniqueFetcherId = function() {
    return "__" + String(++$453a12ddee1c3125$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $453a12ddee1c3125$export$47c85c6e3a081d3() {
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseSubmit).router;
    var basename = $3aC2T.useContext((0, $7aa78ce6d363d479$export$26749e8557646306)).basename;
    var currentRouteId = (0, $7aa78ce6d363d479$export$5fc8298006ad9e58)();
    return $3aC2T.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $453a12ddee1c3125$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $453a12ddee1c3125$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $453a12ddee1c3125$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $453a12ddee1c3125$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $3aC2T.useContext((0, $7aa78ce6d363d479$export$26749e8557646306)).basename;
    var routeContext = $3aC2T.useContext((0, $7aa78ce6d363d479$export$9072aa6dd1f93057));
    !routeContext && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $aSMts._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $453a12ddee1c3125$var$_extends({}, (0, $7aa78ce6d363d479$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $7aa78ce6d363d479$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params["delete"]("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55437416549418ff$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55437416549418ff$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $453a12ddee1c3125$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseFetcher).router;
    var state = $453a12ddee1c3125$var$useDataRouterState($453a12ddee1c3125$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $3aC2T.useContext($453a12ddee1c3125$export$148fd98d095596d4);
    var route = $3aC2T.useContext((0, $7aa78ce6d363d479$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    !route && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $453a12ddee1c3125$var$useIdImpl ? $453a12ddee1c3125$var$useIdImpl() : "";
    var _React_useState = (0, $aSMts._)($3aC2T.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($453a12ddee1c3125$var$getUniqueFetcherId());
    // Registration/cleanup
    $3aC2T.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $3aC2T.useCallback(function(href, opts) {
        !routeId && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $453a12ddee1c3125$export$47c85c6e3a081d3();
    var submit = $3aC2T.useCallback(function(target, opts) {
        submitImpl(target, $453a12ddee1c3125$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $3aC2T.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $3aC2T.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $3aC2T.createElement($453a12ddee1c3125$export$a7fed597f4b8afd8, $453a12ddee1c3125$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $55437416549418ff$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $3aC2T.useMemo(function() {
        return $453a12ddee1c3125$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $453a12ddee1c3125$export$fa996778a3a31087() {
    var state = $453a12ddee1c3125$var$useDataRouterState($453a12ddee1c3125$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $aSMts._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $453a12ddee1c3125$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $453a12ddee1c3125$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $453a12ddee1c3125$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $453a12ddee1c3125$var$useDataRouterState($453a12ddee1c3125$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $3aC2T.useContext((0, $7aa78ce6d363d479$export$26749e8557646306)).basename;
    var location = (0, $7aa78ce6d363d479$export$45d76561a5302f2b)();
    var matches = (0, $7aa78ce6d363d479$export$2378eb7f5ff86053)();
    var navigation = (0, $7aa78ce6d363d479$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $3aC2T.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $453a12ddee1c3125$var$usePageHide($3aC2T.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $453a12ddee1c3125$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($453a12ddee1c3125$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $453a12ddee1c3125$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $453a12ddee1c3125$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($453a12ddee1c3125$var$_extends({}, location, {
                    pathname: (0, $55437416549418ff$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($453a12ddee1c3125$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3aC2T.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $453a12ddee1c3125$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $3aC2T.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $453a12ddee1c3125$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $3aC2T.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $453a12ddee1c3125$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $7aa78ce6d363d479$export$b273b3273281a049)(when);
    $3aC2T.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3aC2T.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $453a12ddee1c3125$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $3aC2T.useContext($453a12ddee1c3125$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55437416549418ff$export$3e9cee6b33872309)(false);
    var basename = $453a12ddee1c3125$var$useDataRouterContext($453a12ddee1c3125$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $7aa78ce6d363d479$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $55437416549418ff$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $55437416549418ff$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55437416549418ff$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55437416549418ff$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");
var $af69156f66a9e6f4$var$useOnlineStatus = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    window.addEventListener("online", function() {
        setOnlineStatus(true);
    });
    window.addEventListener("offline", function() {
        setOnlineStatus(false);
    });
    return onlineStatus;
};
var $af69156f66a9e6f4$export$2e2bcd8739ae039 = $af69156f66a9e6f4$var$useOnlineStatus;



var $7bnAA = parcelRequire("7bnAA");

var $2iBlG = parcelRequire("2iBlG");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");

var $3aC2T = parcelRequire("3aC2T");
var $74e058fd8742b5ff$exports = {};
"use strict";

$74e058fd8742b5ff$exports = (parcelRequire("kKMGt"));


var $c9b06aa5b40d17ee$var$__defProp = Object.defineProperty;
var $c9b06aa5b40d17ee$var$__defProps = Object.defineProperties;
var $c9b06aa5b40d17ee$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c9b06aa5b40d17ee$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c9b06aa5b40d17ee$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c9b06aa5b40d17ee$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c9b06aa5b40d17ee$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c9b06aa5b40d17ee$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c9b06aa5b40d17ee$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c9b06aa5b40d17ee$var$__hasOwnProp.call(b, prop)) $c9b06aa5b40d17ee$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c9b06aa5b40d17ee$var$__getOwnPropSymbols) try {
        for(var _iterator = $c9b06aa5b40d17ee$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($c9b06aa5b40d17ee$var$__propIsEnum.call(b, prop)) $c9b06aa5b40d17ee$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $c9b06aa5b40d17ee$var$__spreadProps = function(a, b) {
    return $c9b06aa5b40d17ee$var$__defProps(a, $c9b06aa5b40d17ee$var$__getOwnPropDescs(b));
};
var $c9b06aa5b40d17ee$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($c9b06aa5b40d17ee$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $c9b06aa5b40d17ee$var$__getOwnPropSymbols) try {
        for(var _iterator = $c9b06aa5b40d17ee$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $c9b06aa5b40d17ee$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $c9b06aa5b40d17ee$var$React = // prettier-ignore
// @ts-ignore
"default" in $3aC2T ? $3aC2T["default"] : $3aC2T;
// src/components/Context.ts
var $c9b06aa5b40d17ee$var$ContextKey = Symbol["for"]("react-redux-context");
var $c9b06aa5b40d17ee$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c9b06aa5b40d17ee$var$getContext() {
    var _a;
    if (!$c9b06aa5b40d17ee$var$React.createContext) return {};
    var contextMap = (_a = $c9b06aa5b40d17ee$var$gT[$c9b06aa5b40d17ee$var$ContextKey]) != null ? _a : $c9b06aa5b40d17ee$var$gT[$c9b06aa5b40d17ee$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($c9b06aa5b40d17ee$var$React.createContext);
    if (!realContext) {
        realContext = $c9b06aa5b40d17ee$var$React.createContext(null);
        contextMap.set($c9b06aa5b40d17ee$var$React.createContext, realContext);
    }
    return realContext;
}
var $c9b06aa5b40d17ee$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c9b06aa5b40d17ee$var$getContext();
// src/utils/useSyncExternalStore.ts
var $c9b06aa5b40d17ee$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $c9b06aa5b40d17ee$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c9b06aa5b40d17ee$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $c9b06aa5b40d17ee$var$React.useContext(context);
        return contextValue;
    };
}
var $c9b06aa5b40d17ee$var$useReduxContext = /* @__PURE__ */ $c9b06aa5b40d17ee$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $c9b06aa5b40d17ee$var$useSyncExternalStoreWithSelector = $c9b06aa5b40d17ee$var$notInitialized;
var $c9b06aa5b40d17ee$var$initializeUseSelector = function(fn) {
    $c9b06aa5b40d17ee$var$useSyncExternalStoreWithSelector = fn;
};
var $c9b06aa5b40d17ee$var$refEquality = function(a, b) {
    return a === b;
};
function $c9b06aa5b40d17ee$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c9b06aa5b40d17ee$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c9b06aa5b40d17ee$export$cc80c08dc91f1c00 ? $c9b06aa5b40d17ee$var$useReduxContext : $c9b06aa5b40d17ee$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $c9b06aa5b40d17ee$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $c9b06aa5b40d17ee$var$React.useRef(true);
        var wrappedSelector = $c9b06aa5b40d17ee$var$React.useCallback((0, $2iBlG._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $c9b06aa5b40d17ee$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $c9b06aa5b40d17ee$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $c9b06aa5b40d17ee$export$2105062e25df4afe = /* @__PURE__ */ $c9b06aa5b40d17ee$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $c9b06aa5b40d17ee$var$REACT_ELEMENT_TYPE = Symbol["for"]("react.element");
var $c9b06aa5b40d17ee$var$REACT_PORTAL_TYPE = Symbol["for"]("react.portal");
var $c9b06aa5b40d17ee$var$REACT_FRAGMENT_TYPE = Symbol["for"]("react.fragment");
var $c9b06aa5b40d17ee$var$REACT_STRICT_MODE_TYPE = Symbol["for"]("react.strict_mode");
var $c9b06aa5b40d17ee$var$REACT_PROFILER_TYPE = Symbol["for"]("react.profiler");
var $c9b06aa5b40d17ee$var$REACT_PROVIDER_TYPE = Symbol["for"]("react.provider");
var $c9b06aa5b40d17ee$var$REACT_CONTEXT_TYPE = Symbol["for"]("react.context");
var $c9b06aa5b40d17ee$var$REACT_SERVER_CONTEXT_TYPE = Symbol["for"]("react.server_context");
var $c9b06aa5b40d17ee$var$REACT_FORWARD_REF_TYPE = Symbol["for"]("react.forward_ref");
var $c9b06aa5b40d17ee$var$REACT_SUSPENSE_TYPE = Symbol["for"]("react.suspense");
var $c9b06aa5b40d17ee$var$REACT_SUSPENSE_LIST_TYPE = Symbol["for"]("react.suspense_list");
var $c9b06aa5b40d17ee$var$REACT_MEMO_TYPE = Symbol["for"]("react.memo");
var $c9b06aa5b40d17ee$var$REACT_LAZY_TYPE = Symbol["for"]("react.lazy");
var $c9b06aa5b40d17ee$var$REACT_OFFSCREEN_TYPE = Symbol["for"]("react.offscreen");
var $c9b06aa5b40d17ee$var$REACT_CLIENT_REFERENCE = Symbol["for"]("react.client.reference");
var $c9b06aa5b40d17ee$var$ForwardRef = $c9b06aa5b40d17ee$var$REACT_FORWARD_REF_TYPE;
var $c9b06aa5b40d17ee$var$Memo = $c9b06aa5b40d17ee$var$REACT_MEMO_TYPE;
function $c9b06aa5b40d17ee$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $c9b06aa5b40d17ee$var$REACT_FRAGMENT_TYPE || type === $c9b06aa5b40d17ee$var$REACT_PROFILER_TYPE || type === $c9b06aa5b40d17ee$var$REACT_STRICT_MODE_TYPE || type === $c9b06aa5b40d17ee$var$REACT_SUSPENSE_TYPE || type === $c9b06aa5b40d17ee$var$REACT_SUSPENSE_LIST_TYPE || type === $c9b06aa5b40d17ee$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $c9b06aa5b40d17ee$var$REACT_LAZY_TYPE || type.$$typeof === $c9b06aa5b40d17ee$var$REACT_MEMO_TYPE || type.$$typeof === $c9b06aa5b40d17ee$var$REACT_PROVIDER_TYPE || type.$$typeof === $c9b06aa5b40d17ee$var$REACT_CONTEXT_TYPE || type.$$typeof === $c9b06aa5b40d17ee$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $c9b06aa5b40d17ee$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $c9b06aa5b40d17ee$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c9b06aa5b40d17ee$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $c9b06aa5b40d17ee$var$REACT_FRAGMENT_TYPE:
                        case $c9b06aa5b40d17ee$var$REACT_PROFILER_TYPE:
                        case $c9b06aa5b40d17ee$var$REACT_STRICT_MODE_TYPE:
                        case $c9b06aa5b40d17ee$var$REACT_SUSPENSE_TYPE:
                        case $c9b06aa5b40d17ee$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $c9b06aa5b40d17ee$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $c9b06aa5b40d17ee$var$REACT_CONTEXT_TYPE:
                                    case $c9b06aa5b40d17ee$var$REACT_FORWARD_REF_TYPE:
                                    case $c9b06aa5b40d17ee$var$REACT_LAZY_TYPE:
                                    case $c9b06aa5b40d17ee$var$REACT_MEMO_TYPE:
                                    case $c9b06aa5b40d17ee$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $c9b06aa5b40d17ee$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $c9b06aa5b40d17ee$var$isContextConsumer(object) {
    return $c9b06aa5b40d17ee$var$typeOf(object) === $c9b06aa5b40d17ee$var$REACT_CONTEXT_TYPE;
}
function $c9b06aa5b40d17ee$var$isMemo(object) {
    return $c9b06aa5b40d17ee$var$typeOf(object) === $c9b06aa5b40d17ee$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c9b06aa5b40d17ee$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c9b06aa5b40d17ee$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c9b06aa5b40d17ee$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $c9b06aa5b40d17ee$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c9b06aa5b40d17ee$var$verify(mapStateToProps, "mapStateToProps");
    $c9b06aa5b40d17ee$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c9b06aa5b40d17ee$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c9b06aa5b40d17ee$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c9b06aa5b40d17ee$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $c9b06aa5b40d17ee$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $c9b06aa5b40d17ee$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c9b06aa5b40d17ee$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $dHvbf._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c9b06aa5b40d17ee$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c9b06aa5b40d17ee$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c9b06aa5b40d17ee$var$isPlainObject(value)) $c9b06aa5b40d17ee$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $c9b06aa5b40d17ee$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c9b06aa5b40d17ee$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c9b06aa5b40d17ee$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c9b06aa5b40d17ee$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c9b06aa5b40d17ee$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c9b06aa5b40d17ee$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $qb7pP._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $c9b06aa5b40d17ee$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $c9b06aa5b40d17ee$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $c9b06aa5b40d17ee$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $c9b06aa5b40d17ee$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c9b06aa5b40d17ee$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c9b06aa5b40d17ee$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c9b06aa5b40d17ee$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c9b06aa5b40d17ee$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c9b06aa5b40d17ee$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c9b06aa5b40d17ee$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c9b06aa5b40d17ee$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $c9b06aa5b40d17ee$var$__spreadValues($c9b06aa5b40d17ee$var$__spreadValues($c9b06aa5b40d17ee$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $c9b06aa5b40d17ee$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c9b06aa5b40d17ee$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $c9b06aa5b40d17ee$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $c9b06aa5b40d17ee$var$wrapMergePropsFunc(mergeProps) : $c9b06aa5b40d17ee$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c9b06aa5b40d17ee$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c9b06aa5b40d17ee$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $c9b06aa5b40d17ee$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c9b06aa5b40d17ee$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $c9b06aa5b40d17ee$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $c9b06aa5b40d17ee$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c9b06aa5b40d17ee$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c9b06aa5b40d17ee$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c9b06aa5b40d17ee$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffect = $c9b06aa5b40d17ee$var$canUseDOM ? $c9b06aa5b40d17ee$var$React.useLayoutEffect : $c9b06aa5b40d17ee$var$React.useEffect;
// src/utils/shallowEqual.ts
function $c9b06aa5b40d17ee$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c9b06aa5b40d17ee$export$d36bdfa510afb180(objA, objB) {
    if ($c9b06aa5b40d17ee$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c9b06aa5b40d17ee$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c9b06aa5b40d17ee$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c9b06aa5b40d17ee$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c9b06aa5b40d17ee$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c9b06aa5b40d17ee$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c9b06aa5b40d17ee$var$_obj;
var $c9b06aa5b40d17ee$var$TYPE_STATICS = ($c9b06aa5b40d17ee$var$_obj = {}, (0, $2iBlG._)($c9b06aa5b40d17ee$var$_obj, $c9b06aa5b40d17ee$var$ForwardRef, $c9b06aa5b40d17ee$var$FORWARD_REF_STATICS), (0, $2iBlG._)($c9b06aa5b40d17ee$var$_obj, $c9b06aa5b40d17ee$var$Memo, $c9b06aa5b40d17ee$var$MEMO_STATICS), $c9b06aa5b40d17ee$var$_obj);
function $c9b06aa5b40d17ee$var$getStatics(component) {
    if ($c9b06aa5b40d17ee$var$isMemo(component)) return $c9b06aa5b40d17ee$var$MEMO_STATICS;
    return $c9b06aa5b40d17ee$var$TYPE_STATICS[component["$$typeof"]] || $c9b06aa5b40d17ee$var$REACT_STATICS;
}
var $c9b06aa5b40d17ee$var$defineProperty = Object.defineProperty;
var $c9b06aa5b40d17ee$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c9b06aa5b40d17ee$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c9b06aa5b40d17ee$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c9b06aa5b40d17ee$var$getPrototypeOf = Object.getPrototypeOf;
var $c9b06aa5b40d17ee$var$objectPrototype = Object.prototype;
function $c9b06aa5b40d17ee$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c9b06aa5b40d17ee$var$objectPrototype) {
            var inheritedComponent = $c9b06aa5b40d17ee$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c9b06aa5b40d17ee$var$objectPrototype) $c9b06aa5b40d17ee$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $c9b06aa5b40d17ee$var$getOwnPropertyNames(sourceComponent);
        if ($c9b06aa5b40d17ee$var$getOwnPropertySymbols) keys = keys.concat($c9b06aa5b40d17ee$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c9b06aa5b40d17ee$var$getStatics(targetComponent);
        var sourceStatics = $c9b06aa5b40d17ee$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c9b06aa5b40d17ee$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c9b06aa5b40d17ee$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c9b06aa5b40d17ee$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $c9b06aa5b40d17ee$var$useSyncExternalStore = $c9b06aa5b40d17ee$var$notInitialized;
var $c9b06aa5b40d17ee$var$initializeConnect = function(fn) {
    $c9b06aa5b40d17ee$var$useSyncExternalStore = fn;
};
var $c9b06aa5b40d17ee$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c9b06aa5b40d17ee$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $dHvbf._)(effectArgs));
    }, dependencies);
}
function $c9b06aa5b40d17ee$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c9b06aa5b40d17ee$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c9b06aa5b40d17ee$var$strictEqual(a, b) {
    return a === b;
}
var $c9b06aa5b40d17ee$var$hasWarnedAboutDeprecatedPureOption = false;
function $c9b06aa5b40d17ee$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $c9b06aa5b40d17ee$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $c9b06aa5b40d17ee$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $c9b06aa5b40d17ee$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $c9b06aa5b40d17ee$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $c9b06aa5b40d17ee$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $c9b06aa5b40d17ee$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $c9b06aa5b40d17ee$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $c9b06aa5b40d17ee$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $aSMts._)($c9b06aa5b40d17ee$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $c9b06aa5b40d17ee$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $c9b06aa5b40d17ee$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                return $c9b06aa5b40d17ee$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $aSMts._)($c9b06aa5b40d17ee$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $c9b06aa5b40d17ee$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $c9b06aa5b40d17ee$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $c9b06aa5b40d17ee$var$__spreadProps($c9b06aa5b40d17ee$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $c9b06aa5b40d17ee$var$React.useRef();
            var lastWrapperProps = $c9b06aa5b40d17ee$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $c9b06aa5b40d17ee$var$React.useRef();
            var renderIsScheduled = $c9b06aa5b40d17ee$var$React.useRef(false);
            var isProcessingDispatch = $c9b06aa5b40d17ee$var$React.useRef(false);
            var isMounted = $c9b06aa5b40d17ee$var$React.useRef(false);
            var latestSubscriptionCallbackError = $c9b06aa5b40d17ee$var$React.useRef();
            $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $c9b06aa5b40d17ee$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffectWithArgs($c9b06aa5b40d17ee$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $c9b06aa5b40d17ee$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $c9b06aa5b40d17ee$var$React.createElement(WrappedComponent, $c9b06aa5b40d17ee$var$__spreadProps($c9b06aa5b40d17ee$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $c9b06aa5b40d17ee$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $c9b06aa5b40d17ee$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $c9b06aa5b40d17ee$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $c9b06aa5b40d17ee$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $c9b06aa5b40d17ee$var$React.createElement(Connect, $c9b06aa5b40d17ee$var$__spreadProps($c9b06aa5b40d17ee$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c9b06aa5b40d17ee$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c9b06aa5b40d17ee$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c9b06aa5b40d17ee$export$64605811ab45167f = $c9b06aa5b40d17ee$var$connect;
// src/components/Provider.tsx
function $c9b06aa5b40d17ee$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $c9b06aa5b40d17ee$var$React.useMemo(function() {
        var subscription = $c9b06aa5b40d17ee$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $c9b06aa5b40d17ee$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $c9b06aa5b40d17ee$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $c9b06aa5b40d17ee$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $c9b06aa5b40d17ee$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c9b06aa5b40d17ee$export$2881499e37b75b9a = $c9b06aa5b40d17ee$var$Provider;
// src/hooks/useStore.ts
function $c9b06aa5b40d17ee$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c9b06aa5b40d17ee$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c9b06aa5b40d17ee$export$cc80c08dc91f1c00 ? $c9b06aa5b40d17ee$var$useReduxContext : // @ts-ignore
    $c9b06aa5b40d17ee$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $c9b06aa5b40d17ee$export$6ccbb43953eebf8 = /* @__PURE__ */ $c9b06aa5b40d17ee$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c9b06aa5b40d17ee$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c9b06aa5b40d17ee$export$cc80c08dc91f1c00;
    var useStore2 = context === $c9b06aa5b40d17ee$export$cc80c08dc91f1c00 ? $c9b06aa5b40d17ee$export$6ccbb43953eebf8 : $c9b06aa5b40d17ee$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $c9b06aa5b40d17ee$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c9b06aa5b40d17ee$export$bc9b55530897c558();
// src/exports.ts
var $c9b06aa5b40d17ee$export$712ea50be43a7858 = $c9b06aa5b40d17ee$var$defaultNoopBatch;
// src/index.ts
$c9b06aa5b40d17ee$var$initializeUseSelector((0, $74e058fd8742b5ff$exports.useSyncExternalStoreWithSelector));
$c9b06aa5b40d17ee$var$initializeConnect($3aC2T.useSyncExternalStore);


var $b7407642b5bd3f78$var$Header = function() {
    var loggedInUser = (0, $3aC2T.useContext)((0, $7bnAA.default)).loggedInUser;
    //Subscribing to the store using a Selector, subscribing only to cart not theme, not user, only cart and that to not entire cart only items in cart
    var cartItems = (0, $c9b06aa5b40d17ee$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    // let btnName = "Login"
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)("Login"), 2), btnName = _useState[0], setbtnName = _useState[1];
    var onlineStatus = (0, $af69156f66a9e6f4$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "header top-0 sticky z-30 px-20 py-2 flex justify-between items-center shadow-lg text-lg font-poppins bg-white",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $esXub.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                        width: "96",
                        height: "96",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5e853a1acc52f212$exports))),
                        // During Testing
                        // src="https://img.icons8.com/fluency/96/pizza-delivery.png" 
                        alt: "logo"
                    })
                })
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "nav-items",
                children: /*#__PURE__*/ (0, $esXub.jsxs)("ul", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                            className: "m-1 p-1",
                            children: onlineStatus ? "\u2705 Online" : "\u274C Disconnected"
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)("li", {
                            className: "m-1 p-1",
                            children: [
                                /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: " Home "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                to: "/grocery",
                                children: "Grocery"
                            })
                        }),
                        /*#__PURE__*/ (0, $esXub.jsxs)("li", {
                            className: "m-1 p-1 font-bold",
                            children: [
                                /*#__PURE__*/ (0, $esXub.jsxs)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: [
                                        "Cart (",
                                        cartItems.length,
                                        ")"
                                    ]
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)("button", {
                            className: "login-btn",
                            onClick: function() {
                                btnName === "Login" ? setbtnName("Logout") : setbtnName("Login");
                            },
                            children: btnName
                        }),
                        /*#__PURE__*/ (0, $esXub.jsx)("li", {
                            className: "m-1 p-1 font-semibold",
                            children: loggedInUser
                        })
                    ]
                })
            })
        ]
    });
};
var $b7407642b5bd3f78$export$2e2bcd8739ae039 = $b7407642b5bd3f78$var$Header;



var $5Pgs2 = parcelRequire("5Pgs2");

var $aSMts = parcelRequire("aSMts");

var $1XfpH = parcelRequire("1XfpH");

var $esXub = parcelRequire("esXub");

var $2iBlG = parcelRequire("2iBlG");
function $50aa2eeb65885e7e$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $2iBlG._define_property)(target, key, source[key]);
        });
    }
    return target;
}



var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
var $8b2e38a7724326b9$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $8b2e38a7724326b9$export$1f59aa9c7691335c = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9328638&lng=77.6139346&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
var $8b2e38a7724326b9$export$944d0eca8e7f4cb3 = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/update");
var $8b2e38a7724326b9$export$b77c1aa4fb57bd1c = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9328638&lng=77.6139346&restaurantId=") //  const LOGO_URL = "../../icons/logo.png";
 // export {CDN_URL}
;



var $7bnAA = parcelRequire("7bnAA");
var $e5ed1ec31eab7e2e$var$ResCard = function(param) {
    var resData = param.resData;
    // console.log(resData);
    var loggedInUser = (0, $3aC2T.useContext)((0, $7bnAA.default)).loggedInUser;
    var _ref = resData === null || resData === void 0 ? void 0 : resData.info, cloudinaryImageId = _ref.cloudinaryImageId, name = _ref.name, cuisines = _ref.cuisines, avgRating = _ref.avgRating, slaString = _ref.sla.slaString, costForTwo = _ref.costForTwo;
    // console.log(resData);
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "res-card w-64 pb-2   hover:shadow-xl rounded-xl",
        "data-testid": "resCard",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("img", {
                className: "res-logo rounded-lg h-44 w-full",
                src: (0, $8b2e38a7724326b9$export$31adfacaf07ffe63) + cloudinaryImageId,
                alt: "res-img"
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "textDetails m-2",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)("h3", {
                        className: "font-medium text-xl truncate",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("h4", {
                        className: "truncate",
                        children: cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)("h5", {
                        className: "font-medium",
                        children: [
                            avgRating,
                            " \u2B50",
                            /*#__PURE__*/ (0, $esXub.jsxs)("span", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        className: "w-5",
                                        src: (0, $8b2e38a7724326b9$export$31adfacaf07ffe63) + "v1648635511/Delivery_fee_new_cjxumu"
                                    }),
                                    slaString
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("p", {
                        children: costForTwo
                    })
                ]
            })
        ]
    });
};
var $e5ed1ec31eab7e2e$export$70ba389ae48934f4 = function(ResCard) {
    //component returning
    return function(props) {
        var _props_resData_info, _props_resData;
        var _ref = props === null || props === void 0 ? void 0 : (_props_resData = props.resData) === null || _props_resData === void 0 ? void 0 : (_props_resData_info = _props_resData.info) === null || _props_resData_info === void 0 ? void 0 : _props_resData_info.aggregatedDiscountInfoV3, header = _ref.header, subHeader = _ref.subHeader;
        // console.log(props.resData.info.aggregatedDiscountInfoV3);
        return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
            className: "relative ",
            children: [
                /*#__PURE__*/ (0, $esXub.jsx)(ResCard, (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, props)),
                /*#__PURE__*/ (0, $esXub.jsx)("div", {
                    className: "bg-red  absolute top-[150px] w-full bg-gradient-to-b from-transparent to-gray-900 rounded-lg",
                    children: /*#__PURE__*/ (0, $esXub.jsx)("label", {
                        className: " text-white ml-2 text-xl font-bold",
                        children: header + " " + subHeader
                    })
                })
            ]
        });
    };
};
var $e5ed1ec31eab7e2e$export$2e2bcd8739ae039 = $e5ed1ec31eab7e2e$var$ResCard;



var $esXub = parcelRequire("esXub");

var $esXub = parcelRequire("esXub");
var $467aa445efe9155f$var$ShimmerCard = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "shimmer-card flex flex-col gap-5 w-64 h-80 p-2",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "img bg-gray-200 w-full h-44 rounded-lg"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "text-1 bg-gray-200 w-2/3 h-3 rounded-lg"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "text-2 bg-gray-200 w-1/2 h-3 rounded-lg"
            })
        ]
    });
};
var $467aa445efe9155f$export$2e2bcd8739ae039 = $467aa445efe9155f$var$ShimmerCard;


var $4fcb5d63c47ef7d3$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "mx-16",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-96 h-10 mt-10 mx-20 bg-gray-300 rounded-full"
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "shimmer-container flex flex-wrap justify-around  py-3 px-20",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $467aa445efe9155f$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $4fcb5d63c47ef7d3$export$2e2bcd8739ae039 = $4fcb5d63c47ef7d3$var$Shimmer;



var $3aC2T = parcelRequire("3aC2T");



var $7bnAA = parcelRequire("7bnAA");

var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
var $caa618b787ece62a$var$ScrollDetector = function() {
    // State to track scroll position
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(0), 2), scrollPosition = _useState[0], setScrollPosition = _useState[1];
    // Define the position you want to detect
    var positionToDetect = 500; // Adjust this value to the desired position
    // Function to handle scroll event
    var handleScroll = function() {
        var currentPosition = window.scrollY || window.pageYOffset;
        setScrollPosition(currentPosition);
    };
    // Effect to add scroll event listener when component mounts
    (0, $3aC2T.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        // Cleanup: remove event listener when component unmounts
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    // Effect to perform action when scroll position reaches desired position
    (0, $3aC2T.useEffect)(function() {
        if (scrollPosition >= positionToDetect) // Scroll has reached the desired position
        console.log("Scroll has reached the desired position.");
    }, [
        scrollPosition,
        positionToDetect
    ]);
    return /*#__PURE__*/ (0, $esXub.jsx)("div", {
        style: {
            height: "2000px"
        },
        children: " "
    });
};
var $caa618b787ece62a$export$2e2bcd8739ae039 = $caa618b787ece62a$var$ScrollDetector;


var $a2937e22c1ddf1d8$var$Main = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)([]), 2), listOfRes = _useState[0], setListOfRes = _useState[1];
    // another state variable
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)([]), 2), beforeList = _useState1[0], setBeforeList = _useState1[1];
    var _useState2 = (0, $aSMts._)((0, $3aC2T.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var _useContext = (0, $3aC2T.useContext)((0, $7bnAA.default)), loggedInUser = _useContext.loggedInUser, setUserName = _useContext.setUserName;
    (0, $3aC2T.useEffect)(function() {
        fetchData();
    }, []);
    // const handleShowMore = async () => {
    //   const payload ={
    //     "lat": 12.9328638,
    //     "lng": 77.6139346,
    //     "nextOffset": "COVCELQ4KIDo+J+28sP6NzCnEzgE",
    //     "widgetOffset": {
    //         "NewListingView_category_bar_chicletranking_TwoRows": "",
    //         "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
    //         "Restaurant_Group_WebView_PB_Theme": "",
    //         "Restaurant_Group_WebView_SEO_PB_Theme": "",
    //         "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "10",
    //         "inlineFacetFilter": "",
    //         "restaurantCountWidget": ""
    //     },
    //     "filters": {},
    //     "seoParams": {
    //         "seoUrl": "https://www.swiggy.com/",
    //         "pageType": "FOOD_HOMEPAGE",
    //         "apiName": "FoodHomePage"
    //     },
    //     "page_type": "DESKTOP_WEB_LISTING",
    //     "_csrf": "dWtQ4mDE4eqE-I7bUVuw-IIkO7t-sbzJH_2KI45U"
    // }
    // fetch(UPDATE_LIST, {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(payload),
    // })
    // .then(response => {
    //     if (!response.ok) {
    //         throw new Error('Network response was not ok');
    //     }
    //     return response.json();
    // })
    // .then(data => {
    //     console.log(data); // Handle response data here
    // })
    // .catch(error => {
    //     console.error('There was a problem with the fetch operation:', error);
    // });
    // }
    var fetchData = function() {
        var _ref = (0, $5Pgs2._)(function() {
            var _json_data_cards__card_card_gridElements_infoWithStyle, _json_data_cards__card_card_gridElements, _json_data_cards__card_card, _json_data_cards__card, _json_data_cards_, _json_data, data, json, apiData;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $8b2e38a7724326b9$export$1f59aa9c7691335c))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        //  console.log(json)
                        // Optional Chaining
                        apiData = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[4]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__card = _json_data_cards_.card) === null || _json_data_cards__card === void 0 ? void 0 : (_json_data_cards__card_card = _json_data_cards__card.card) === null || _json_data_cards__card_card === void 0 ? void 0 : (_json_data_cards__card_card_gridElements = _json_data_cards__card_card.gridElements) === null || _json_data_cards__card_card_gridElements === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle = _json_data_cards__card_card_gridElements.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle.restaurants;
                        // console.log(apiData)
                        setListOfRes(apiData);
                        return [
                            2
                        ];
                }
            });
        // console.log(listOfRes)
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var OfferedResCard = (0, $e5ed1ec31eab7e2e$export$70ba389ae48934f4)((0, $e5ed1ec31eab7e2e$export$2e2bcd8739ae039));
    // Conditional Rendering
    // if(listOfRes.length === 0){
    //   return <Shimmer />
    // }
    // Ternary Operator
    return listOfRes.length === 0 ? /*#__PURE__*/ (0, $esXub.jsx)((0, $4fcb5d63c47ef7d3$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "main mx-24",
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "filter p-5 mx-16 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "search flex justify-around",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("input", {
                                className: "w-96 px-2 border-solid border-2 border-gray-300 rounded-full shadow-lg",
                                type: "text",
                                "data-testid": "searchInput",
                                placeholder: "Search for Restaurants...",
                                value: searchText,
                                onChange: function(e) {
                                    setSearchText(e.target.value);
                                },
                                onFocus: function() {
                                    if (beforeList.length !== 0) setListOfRes(beforeList);
                                }
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("button", {
                                id: "search-btn",
                                className: "p-2",
                                "data-testid": "searchBtn",
                                onClick: function() {
                                    // copying listOfRes to beforeList
                                    setBeforeList(listOfRes);
                                    // filtering, this is modifying the main list
                                    var searchList = listOfRes.filter(function(res) {
                                        return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    //modifying the main list listOfRes
                                    setListOfRes(searchList);
                                },
                                children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                    width: "30",
                                    height: "30",
                                    src: "https://img.icons8.com/ios/50/search--v1.png",
                                    alt: "search--v1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("button", {
                        className: "filter-btn w-60 py-2 border-solid border-2 border-black-700 rounded-full text-center shadow-lg hover:bg-green-200 transition ease-in duration-500",
                        onClick: function() {
                            //updating the UI
                            var filterList = listOfRes.filter(function(res) {
                                return res.info.avgRating > 4.2;
                            });
                            setListOfRes(filterList);
                        },
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "res-container gap-10 mx-16 m-5 flex flex-wrap justify-start",
                children: listOfRes.map(function(res, index) {
                    return /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                        className: "",
                        to: "/restaurant/" + res.info.id,
                        children: // If any of these objects are undefined, attempting to access properties deeper in the hierarchy will result in a TypeError. To prevent the error, you should ensure that all the nested properties are defined before trying to access discountTag.
                        res && res.info && res.info.aggregatedDiscountInfoV3 && res.info.aggregatedDiscountInfoV3.discountTag === undefined ? /*#__PURE__*/ (0, $esXub.jsx)(OfferedResCard, {
                            resData: res
                        }) : /*#__PURE__*/ (0, $esXub.jsx)((0, $e5ed1ec31eab7e2e$export$2e2bcd8739ae039), {
                            resData: res
                        })
                    }, res.info.id);
                })
            })
        ]
    });
};
var $a2937e22c1ddf1d8$export$2e2bcd8739ae039 = $a2937e22c1ddf1d8$var$Main;




var $esXub = parcelRequire("esXub");
var $1e75e520e4c41f31$var$Contact = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "contact m-12",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                className: "text-5xl font-lg",
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("h3", {
                children: "Email contact@feastfleet.com"
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)("form", {
                action: "/contact",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)("input", {
                        type: "text",
                        placeholder: "name",
                        className: "border border-gray-300 rounded-lg p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("input", {
                        type: "text",
                        placeholder: "email",
                        className: "border border-gray-300 rounded-lg p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("button", {
                        className: "border border-gray-300 rounded-lg p-2 m-2 bg-green-200",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $1e75e520e4c41f31$export$2e2bcd8739ae039 = $1e75e520e4c41f31$var$Contact;



var $esXub = parcelRequire("esXub");

var $94229c684d67f149$var$Error = function() {
    var err = (0, $7aa78ce6d363d479$export$ed527bf60f6e05f2)();
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "m-16",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                className: "text-3xl",
                children: "Oops!!!"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("h3", {
                children: "The page you requested was not found..."
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)("h5", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $94229c684d67f149$export$2e2bcd8739ae039 = $94229c684d67f149$var$Error;



var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $esXub = parcelRequire("esXub");
var $31614b666dbabba2$var$ShimmerMenu = function() {
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "mx-56",
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: " flex mt-10 gap-2 mx-auto justify-center ",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "w-2/3",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                                className: "m-2 w-9/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "m-2 w-6/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "m-2 w-7/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "m-2 w-6/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "m-2 w-5/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "m-2 w-5/12 h-6 bg-gray-200 rounded-lg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("div", {
                        className: "rounded-lg h-36 w-36 bg-gray-200"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            })
        ]
    });
};
var $31614b666dbabba2$export$2e2bcd8739ae039 = $31614b666dbabba2$var$ShimmerMenu;




var $3aC2T = parcelRequire("3aC2T");

var $5Pgs2 = parcelRequire("5Pgs2");

var $aSMts = parcelRequire("aSMts");

var $1XfpH = parcelRequire("1XfpH");

var $3aC2T = parcelRequire("3aC2T");

var $f7b586262587f0c1$var$useResMenu = function(resId) {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $3aC2T.useEffect)(function() {
        fetchMenuData();
    }, []);
    var fetchMenuData = function() {
        var _ref = (0, $5Pgs2._)(function() {
            var apiData, json;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $8b2e38a7724326b9$export$b77c1aa4fb57bd1c) + resId)
                        ];
                    case 1:
                        apiData = _state.sent();
                        return [
                            4,
                            apiData.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setResInfo(json.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMenuData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $f7b586262587f0c1$export$2e2bcd8739ae039 = $f7b586262587f0c1$var$useResMenu;



var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");
var $012467c92d666826$exports = {};

$012467c92d666826$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + "icons8-veg-32.1b7d3419.png";


var $3d009e9898e6b53f$exports = {};

$3d009e9898e6b53f$exports = (parcelRequire("c6lZy")).getBundleURL("kbjbz") + "icons8-non-veg-32.14536350.png";




// src/index.ts

var $dMjkN = parcelRequire("dMjkN");

var $5Pgs2 = parcelRequire("5Pgs2");

var $50OuQ = parcelRequire("50OuQ");

var $kkvIW = parcelRequire("kkvIW");

var $fGdZr = parcelRequire("fGdZr");

var $2iBlG = parcelRequire("2iBlG");

var $bykok = parcelRequire("bykok");
function $58845b2ea49534ba$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $bykok._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}


function $7a025f0ee85622d7$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $7a025f0ee85622d7$export$afb3516d9d608401 = Reflect.get;
    else $7a025f0ee85622d7$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $58845b2ea49534ba$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $7a025f0ee85622d7$export$afb3516d9d608401(target, property, receiver || target);
}



var $bykok = parcelRequire("bykok");

var $1atwj = parcelRequire("1atwj");

function $219ff6b9141574a5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $219ff6b9141574a5$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $219ff6b9141574a5$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


function $77b09736095ba578$export$7a4a7e38737aceb4(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $08757aa37edf87c6$export$69fdd232f62cde60(source, excluded) {
    if (source == null) return {};
    var target = (0, $77b09736095ba578$export$7a4a7e38737aceb4)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");

var $jc6v0 = parcelRequire("jc6v0");

var $iD0Am = parcelRequire("iD0Am");

var $1XfpH = parcelRequire("1XfpH");
// src/utils/formatProdErrorMessage.ts

var $2iBlG = parcelRequire("2iBlG");



var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");
function $bffafe2e1cf4f4f1$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $bffafe2e1cf4f4f1$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $bffafe2e1cf4f4f1$var$symbol_observable_default = $bffafe2e1cf4f4f1$var$$$observable;
// src/utils/actionTypes.ts
var $bffafe2e1cf4f4f1$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $bffafe2e1cf4f4f1$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($bffafe2e1cf4f4f1$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($bffafe2e1cf4f4f1$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($bffafe2e1cf4f4f1$var$randomString());
    }
};
var $bffafe2e1cf4f4f1$export$4219e499db7ca678 = $bffafe2e1cf4f4f1$var$ActionTypes;
// src/utils/isPlainObject.ts
function $bffafe2e1cf4f4f1$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $bffafe2e1cf4f4f1$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($bffafe2e1cf4f4f1$var$isDate(val)) return "date";
    if ($bffafe2e1cf4f4f1$var$isError(val)) return "error";
    var constructorName = $bffafe2e1cf4f4f1$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $bffafe2e1cf4f4f1$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $bffafe2e1cf4f4f1$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $bffafe2e1cf4f4f1$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $bffafe2e1cf4f4f1$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $bffafe2e1cf4f4f1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(1));
        return enhancer($bffafe2e1cf4f4f1$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners["delete"](listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$bffafe2e1cf4f4f1$export$53b83ca8eaab0383(action)) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $bffafe2e1cf4f4f1$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $2iBlG._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $bffafe2e1cf4f4f1$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $bffafe2e1cf4f4f1$export$4219e499db7ca678.INIT
    });
    var store = (0, $2iBlG._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $bffafe2e1cf4f4f1$var$symbol_observable_default, observable);
    return store;
}
function $bffafe2e1cf4f4f1$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $bffafe2e1cf4f4f1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $bffafe2e1cf4f4f1$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $bffafe2e1cf4f4f1$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $bffafe2e1cf4f4f1$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$bffafe2e1cf4f4f1$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($bffafe2e1cf4f4f1$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $bffafe2e1cf4f4f1$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $bffafe2e1cf4f4f1$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $bffafe2e1cf4f4f1$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $bffafe2e1cf4f4f1$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(13));
    });
}
function $bffafe2e1cf4f4f1$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $bffafe2e1cf4f4f1$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $bffafe2e1cf4f4f1$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $bffafe2e1cf4f4f1$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $bffafe2e1cf4f4f1$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $bffafe2e1cf4f4f1$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $dHvbf._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $bffafe2e1cf4f4f1$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($bffafe2e1cf4f4f1$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $dHvbf._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7.apply(void 0, (0, $dHvbf._)(chain))(store.dispatch);
            return (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $bffafe2e1cf4f4f1$export$b956e38827fca970(action) {
    return $bffafe2e1cf4f4f1$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $9T74l = parcelRequire("9T74l");

var $50OuQ = parcelRequire("50OuQ");

var $fGdZr = parcelRequire("fGdZr");

var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");

var $qb7pP = parcelRequire("qb7pP");
var $cbff44edd9e681e5$var$__defProp = Object.defineProperty;
var $cbff44edd9e681e5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cbff44edd9e681e5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cbff44edd9e681e5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cbff44edd9e681e5$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $cbff44edd9e681e5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $cbff44edd9e681e5$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($cbff44edd9e681e5$var$__hasOwnProp.call(b, prop)) $cbff44edd9e681e5$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($cbff44edd9e681e5$var$__getOwnPropSymbols) try {
        for(var _iterator = $cbff44edd9e681e5$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($cbff44edd9e681e5$var$__propIsEnum.call(b, prop)) $cbff44edd9e681e5$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $cbff44edd9e681e5$var$__publicField = function(obj, key, value) {
    $cbff44edd9e681e5$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $qb7pP._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $cbff44edd9e681e5$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $cbff44edd9e681e5$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $dHvbf._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $cbff44edd9e681e5$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $cbff44edd9e681e5$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($cbff44edd9e681e5$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $cbff44edd9e681e5$var$NOT_FOUND = "NOT_FOUND";
function $cbff44edd9e681e5$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $qb7pP._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $cbff44edd9e681e5$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $qb7pP._)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $cbff44edd9e681e5$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $qb7pP._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $cbff44edd9e681e5$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $cbff44edd9e681e5$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $cbff44edd9e681e5$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $cbff44edd9e681e5$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $cbff44edd9e681e5$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $cbff44edd9e681e5$var$__spreadValues($cbff44edd9e681e5$var$__spreadValues({}, $cbff44edd9e681e5$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $cbff44edd9e681e5$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $cbff44edd9e681e5$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $cbff44edd9e681e5$var$$REVISION = 0;
var $cbff44edd9e681e5$var$CURRENT_TRACKER = null;
var $cbff44edd9e681e5$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cbff44edd9e681e5$var$tripleEq;
        (0, $50OuQ._)(this, Cell);
        $cbff44edd9e681e5$var$__publicField(this, "revision", $cbff44edd9e681e5$var$$REVISION);
        $cbff44edd9e681e5$var$__publicField(this, "_value");
        $cbff44edd9e681e5$var$__publicField(this, "_lastValue");
        $cbff44edd9e681e5$var$__publicField(this, "_isEqual", $cbff44edd9e681e5$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $fGdZr._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $cbff44edd9e681e5$var$CURRENT_TRACKER == null || $cbff44edd9e681e5$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$cbff44edd9e681e5$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $cbff44edd9e681e5$var$tripleEq(a, b) {
    return a === b;
}
var $cbff44edd9e681e5$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $50OuQ._)(this, TrackingCache);
        $cbff44edd9e681e5$var$__publicField(this, "_cachedValue");
        $cbff44edd9e681e5$var$__publicField(this, "_cachedRevision", -1);
        $cbff44edd9e681e5$var$__publicField(this, "_deps", []);
        $cbff44edd9e681e5$var$__publicField(this, "hits", 0);
        $cbff44edd9e681e5$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $fGdZr._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $cbff44edd9e681e5$var$CURRENT_TRACKER;
                    $cbff44edd9e681e5$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $cbff44edd9e681e5$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $cbff44edd9e681e5$var$CURRENT_TRACKER == null || $cbff44edd9e681e5$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $dHvbf._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $cbff44edd9e681e5$var$getValue(cell) {
    if (!(cell instanceof $cbff44edd9e681e5$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $cbff44edd9e681e5$var$setValue(storage, value) {
    if (!(storage instanceof $cbff44edd9e681e5$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $cbff44edd9e681e5$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cbff44edd9e681e5$var$tripleEq;
    return new $cbff44edd9e681e5$var$Cell(initialValue, isEqual);
}
function $cbff44edd9e681e5$var$createCache(fn) {
    $cbff44edd9e681e5$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $cbff44edd9e681e5$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $cbff44edd9e681e5$var$neverEq = function(a, b) {
    return false;
};
function $cbff44edd9e681e5$var$createTag() {
    return $cbff44edd9e681e5$var$createCell(null, $cbff44edd9e681e5$var$neverEq);
}
function $cbff44edd9e681e5$var$dirtyTag(tag, value) {
    $cbff44edd9e681e5$var$setValue(tag, value);
}
var $cbff44edd9e681e5$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $cbff44edd9e681e5$var$createTag();
    $cbff44edd9e681e5$var$getValue(tag);
};
var $cbff44edd9e681e5$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $cbff44edd9e681e5$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $cbff44edd9e681e5$var$REDUX_PROXY_LABEL = Symbol();
var $cbff44edd9e681e5$var$nextId = 0;
var $cbff44edd9e681e5$var$proto = Object.getPrototypeOf({});
var $cbff44edd9e681e5$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $50OuQ._)(this, ObjectTreeNode);
    this.value = value;
    $cbff44edd9e681e5$var$__publicField(this, "proxy", new Proxy(this, $cbff44edd9e681e5$var$objectProxyHandler));
    $cbff44edd9e681e5$var$__publicField(this, "tag", $cbff44edd9e681e5$var$createTag());
    $cbff44edd9e681e5$var$__publicField(this, "tags", {});
    $cbff44edd9e681e5$var$__publicField(this, "children", {});
    $cbff44edd9e681e5$var$__publicField(this, "collectionTag", null);
    $cbff44edd9e681e5$var$__publicField(this, "id", $cbff44edd9e681e5$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $cbff44edd9e681e5$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $qb7pP._)(key)) === "symbol") return childValue;
            if (key in $cbff44edd9e681e5$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $cbff44edd9e681e5$var$createNode(childValue);
                if (childNode.tag) $cbff44edd9e681e5$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $cbff44edd9e681e5$var$createTag();
                    tag.value = childValue;
                }
                $cbff44edd9e681e5$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $cbff44edd9e681e5$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $cbff44edd9e681e5$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $50OuQ._)(this, ArrayTreeNode);
    this.value = value;
    $cbff44edd9e681e5$var$__publicField(this, "proxy", new Proxy([
        this
    ], $cbff44edd9e681e5$var$arrayProxyHandler));
    $cbff44edd9e681e5$var$__publicField(this, "tag", $cbff44edd9e681e5$var$createTag());
    $cbff44edd9e681e5$var$__publicField(this, "tags", {});
    $cbff44edd9e681e5$var$__publicField(this, "children", {});
    $cbff44edd9e681e5$var$__publicField(this, "collectionTag", null);
    $cbff44edd9e681e5$var$__publicField(this, "id", $cbff44edd9e681e5$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $cbff44edd9e681e5$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $aSMts._)(param, 1), node = _param[0];
        if (key === "length") $cbff44edd9e681e5$var$consumeCollection(node);
        return $cbff44edd9e681e5$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $aSMts._)(param, 1), node = _param[0];
        return $cbff44edd9e681e5$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $aSMts._)(param, 1), node = _param[0];
        return $cbff44edd9e681e5$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $aSMts._)(param, 1), node = _param[0];
        return $cbff44edd9e681e5$var$objectProxyHandler.has(node, prop);
    }
};
function $cbff44edd9e681e5$var$createNode(value) {
    if (Array.isArray(value)) return new $cbff44edd9e681e5$var$ArrayTreeNode(value);
    return new $cbff44edd9e681e5$var$ObjectTreeNode(value);
}
function $cbff44edd9e681e5$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $cbff44edd9e681e5$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $cbff44edd9e681e5$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $cbff44edd9e681e5$var$dirtyCollection(node);
            $cbff44edd9e681e5$var$dirtyTag(tags[key1], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if (typeof newChildValue1 === "object" && newChildValue1 !== null) $cbff44edd9e681e5$var$updateNode(childNode, newChildValue1);
        else {
            $cbff44edd9e681e5$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $cbff44edd9e681e5$var$deleteNode(node) {
    if (node.tag) $cbff44edd9e681e5$var$dirtyTag(node.tag, null);
    $cbff44edd9e681e5$var$dirtyCollection(node);
    for(var key in node.tags)$cbff44edd9e681e5$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$cbff44edd9e681e5$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $cbff44edd9e681e5$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $cbff44edd9e681e5$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $cbff44edd9e681e5$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $cbff44edd9e681e5$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $cbff44edd9e681e5$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $cbff44edd9e681e5$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $cbff44edd9e681e5$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $cbff44edd9e681e5$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $cbff44edd9e681e5$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $cbff44edd9e681e5$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize === 1 ? $cbff44edd9e681e5$var$createSingletonCache(comparator) : $cbff44edd9e681e5$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $cbff44edd9e681e5$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $cbff44edd9e681e5$export$c8f9cf88d9fdee55(func) {
    var node = $cbff44edd9e681e5$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $cbff44edd9e681e5$var$createCacheKeyComparator($cbff44edd9e681e5$export$3f025202a230c6dd);
    var cache = $cbff44edd9e681e5$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $cbff44edd9e681e5$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $cbff44edd9e681e5$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $50OuQ._)(this, StrongRef);
        this.value = value;
    }
    (0, $fGdZr._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $cbff44edd9e681e5$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $cbff44edd9e681e5$var$StrongRef;
var $cbff44edd9e681e5$var$UNTERMINATED = 0;
var $cbff44edd9e681e5$var$TERMINATED = 1;
function $cbff44edd9e681e5$var$createCacheNode() {
    return {
        s: $cbff44edd9e681e5$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $cbff44edd9e681e5$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $cbff44edd9e681e5$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $cbff44edd9e681e5$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $cbff44edd9e681e5$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $cbff44edd9e681e5$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $cbff44edd9e681e5$var$TERMINATED;
        if (resultEqualityCheck) {
            var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            var needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $cbff44edd9e681e5$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $cbff44edd9e681e5$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $cbff44edd9e681e5$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $cbff44edd9e681e5$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $qb7pP._)(resultFunc), "]"));
        var combinedOptions = $cbff44edd9e681e5$var$__spreadValues($cbff44edd9e681e5$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $cbff44edd9e681e5$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $cbff44edd9e681e5$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $cbff44edd9e681e5$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $cbff44edd9e681e5$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $dHvbf._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $cbff44edd9e681e5$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $dHvbf._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $cbff44edd9e681e5$export$595d22ed68ca2841 = /* @__PURE__ */ $cbff44edd9e681e5$export$5943f4447f6ef248($cbff44edd9e681e5$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $cbff44edd9e681e5$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cbff44edd9e681e5$export$595d22ed68ca2841;
    $cbff44edd9e681e5$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $qb7pP._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $cbff44edd9e681e5$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $790c029d7851122a$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $790c029d7851122a$export$dd164f5517779f15 = $790c029d7851122a$var$createThunkMiddleware();
var $790c029d7851122a$export$16d06542a1949d9e = $790c029d7851122a$var$createThunkMiddleware;


var $b1aadf8304182be4$exports = {};
// shim for using process in browser
var $b1aadf8304182be4$var$process = $b1aadf8304182be4$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b1aadf8304182be4$var$cachedSetTimeout;
var $b1aadf8304182be4$var$cachedClearTimeout;
function $b1aadf8304182be4$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b1aadf8304182be4$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        else $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedSetTimeout = $b1aadf8304182be4$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        else $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    } catch (e) {
        $b1aadf8304182be4$var$cachedClearTimeout = $b1aadf8304182be4$var$defaultClearTimeout;
    }
})();
function $b1aadf8304182be4$var$runTimeout(fun) {
    if ($b1aadf8304182be4$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedSetTimeout === $b1aadf8304182be4$var$defaultSetTimout || !$b1aadf8304182be4$var$cachedSetTimeout) && setTimeout) {
        $b1aadf8304182be4$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b1aadf8304182be4$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b1aadf8304182be4$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b1aadf8304182be4$var$runClearTimeout(marker) {
    if ($b1aadf8304182be4$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b1aadf8304182be4$var$cachedClearTimeout === $b1aadf8304182be4$var$defaultClearTimeout || !$b1aadf8304182be4$var$cachedClearTimeout) && clearTimeout) {
        $b1aadf8304182be4$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aadf8304182be4$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b1aadf8304182be4$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b1aadf8304182be4$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b1aadf8304182be4$var$queue = [];
var $b1aadf8304182be4$var$draining = false;
var $b1aadf8304182be4$var$currentQueue;
var $b1aadf8304182be4$var$queueIndex = -1;
function $b1aadf8304182be4$var$cleanUpNextTick() {
    if (!$b1aadf8304182be4$var$draining || !$b1aadf8304182be4$var$currentQueue) return;
    $b1aadf8304182be4$var$draining = false;
    if ($b1aadf8304182be4$var$currentQueue.length) $b1aadf8304182be4$var$queue = $b1aadf8304182be4$var$currentQueue.concat($b1aadf8304182be4$var$queue);
    else $b1aadf8304182be4$var$queueIndex = -1;
    if ($b1aadf8304182be4$var$queue.length) $b1aadf8304182be4$var$drainQueue();
}
function $b1aadf8304182be4$var$drainQueue() {
    if ($b1aadf8304182be4$var$draining) return;
    var timeout = $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$cleanUpNextTick);
    $b1aadf8304182be4$var$draining = true;
    var len = $b1aadf8304182be4$var$queue.length;
    while(len){
        $b1aadf8304182be4$var$currentQueue = $b1aadf8304182be4$var$queue;
        $b1aadf8304182be4$var$queue = [];
        while(++$b1aadf8304182be4$var$queueIndex < len)if ($b1aadf8304182be4$var$currentQueue) $b1aadf8304182be4$var$currentQueue[$b1aadf8304182be4$var$queueIndex].run();
        $b1aadf8304182be4$var$queueIndex = -1;
        len = $b1aadf8304182be4$var$queue.length;
    }
    $b1aadf8304182be4$var$currentQueue = null;
    $b1aadf8304182be4$var$draining = false;
    $b1aadf8304182be4$var$runClearTimeout(timeout);
}
$b1aadf8304182be4$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b1aadf8304182be4$var$queue.push(new $b1aadf8304182be4$var$Item(fun, args));
    if ($b1aadf8304182be4$var$queue.length === 1 && !$b1aadf8304182be4$var$draining) $b1aadf8304182be4$var$runTimeout($b1aadf8304182be4$var$drainQueue);
};
// v8 likes predictible objects
function $b1aadf8304182be4$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b1aadf8304182be4$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b1aadf8304182be4$var$process.title = "browser";
$b1aadf8304182be4$var$process.browser = true;
$b1aadf8304182be4$var$process.env = {};
$b1aadf8304182be4$var$process.argv = [];
$b1aadf8304182be4$var$process.version = ""; // empty string to avoid regexp issues
$b1aadf8304182be4$var$process.versions = {};
function $b1aadf8304182be4$var$noop() {}
$b1aadf8304182be4$var$process.on = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.addListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.once = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.off = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.removeAllListeners = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.emit = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.prependOnceListener = $b1aadf8304182be4$var$noop;
$b1aadf8304182be4$var$process.listeners = function(name) {
    return [];
};
$b1aadf8304182be4$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b1aadf8304182be4$var$process.cwd = function() {
    return "/";
};
$b1aadf8304182be4$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b1aadf8304182be4$var$process.umask = function() {
    return 0;
};


var $dd193db6d1f94c14$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $cbff44edd9e681e5$export$5943f4447f6ef248).apply(void 0, (0, $dHvbf._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $dHvbf._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $9T74l.isDraft)(value) ? (0, $9T74l.current)(value) : value
            ].concat((0, $dHvbf._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $dd193db6d1f94c14$export$a5d3c27355e35910 = $dd193db6d1f94c14$export$aab6de9e3dbb1473((0, $cbff44edd9e681e5$export$8402dc26d96f6902));
var $dd193db6d1f94c14$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7;
    return (0, $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $dd193db6d1f94c14$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $dd193db6d1f94c14$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $dd193db6d1f94c14$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $dHvbf._)(args));
            if (!prepared) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(0));
            return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }, "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $bffafe2e1cf4f4f1$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $dd193db6d1f94c14$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $dd193db6d1f94c14$var$hasMatchFunction(action);
}
function $dd193db6d1f94c14$export$ebd532f9034651f3(action) {
    return (0, $bffafe2e1cf4f4f1$export$b956e38827fca970)(action) && Object.keys(action).every($dd193db6d1f94c14$var$isValidKey);
}
function $dd193db6d1f94c14$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $dd193db6d1f94c14$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $dd193db6d1f94c14$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $dd193db6d1f94c14$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $dd193db6d1f94c14$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $dd193db6d1f94c14$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $1atwj._)(_Tuple, Array1);
    var _super = (0, $iD0Am._)(_Tuple);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $50OuQ._)(this, _Tuple);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $dHvbf._)(items)));
        Object.setPrototypeOf((0, $dMjkN._)(_this), _Tuple.prototype);
        return _this;
    }
    (0, $fGdZr._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $7a025f0ee85622d7$export$afb3516d9d608401)((0, $bykok._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $kkvIW._)(_Tuple, (0, $dHvbf._)(arr[0].concat(this)));
                return (0, $kkvIW._)(_Tuple, (0, $dHvbf._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $jc6v0._)(Array));
function $dd193db6d1f94c14$var$freezeDraftable(val) {
    return (0, $9T74l.isDraftable)(val) ? (0, $9T74l.produce)(val, function() {}) : val;
}
function $dd193db6d1f94c14$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $dd193db6d1f94c14$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $dd193db6d1f94c14$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $dd193db6d1f94c14$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $dd193db6d1f94c14$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $dd193db6d1f94c14$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $dd193db6d1f94c14$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $dd193db6d1f94c14$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $dd193db6d1f94c14$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $qb7pP._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $dd193db6d1f94c14$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $dd193db6d1f94c14$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $qb7pP._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $bffafe2e1cf4f4f1$export$53b83ca8eaab0383)(val);
}
function $dd193db6d1f94c14$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $dd193db6d1f94c14$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache === null || cache === void 0 ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $aSMts._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if (typeof nestedValue === "object") {
                foundNestedSerializable = $dd193db6d1f94c14$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $qb7pP._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $dd193db6d1f94c14$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $dd193db6d1f94c14$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if (typeof nestedValue !== "object" || nestedValue === null) continue;
            if (!$dd193db6d1f94c14$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $dd193db6d1f94c14$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $dd193db6d1f94c14$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $dd193db6d1f94c14$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $dd193db6d1f94c14$export$1908877435b1d5e9();
        if (thunk) {
            if ($dd193db6d1f94c14$var$isBoolean(thunk)) middlewareArray.push((0, $790c029d7851122a$export$dd164f5517779f15));
            else middlewareArray.push((0, $790c029d7851122a$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $dd193db6d1f94c14$export$8fb31c0f05df007b = "RTK_autoBatch";
var $dd193db6d1f94c14$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $2iBlG._)({}, $dd193db6d1f94c14$export$8fb31c0f05df007b, true)
        };
    };
};
var $dd193db6d1f94c14$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $dd193db6d1f94c14$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $dd193db6d1f94c14$var$createQueueWithTimer(10);
var $dd193db6d1f94c14$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $dHvbf._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $dd193db6d1f94c14$var$rAF : options.type === "callback" ? options.queueNotification : $dd193db6d1f94c14$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners["delete"](listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    try {
                        var _action_meta;
                        notifying = !(action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta[$dd193db6d1f94c14$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $dd193db6d1f94c14$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options !== null && options !== void 0 ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $dd193db6d1f94c14$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($dd193db6d1f94c14$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $dd193db6d1f94c14$var$IS_PRODUCTION = true;
function $dd193db6d1f94c14$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $dd193db6d1f94c14$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $bffafe2e1cf4f4f1$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $bffafe2e1cf4f4f1$export$66e4520cdb265d18)(reducer);
    else throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(1));
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$dd193db6d1f94c14$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(4));
    var finalCompose = (0, $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $dd193db6d1f94c14$var$composeWithDevTools((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$dd193db6d1f94c14$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var middlewareEnhancer = (0, $bffafe2e1cf4f4f1$export$9ff26e0402cc7b7).apply(void 0, (0, $dHvbf._)(finalMiddleware));
    var getDefaultEnhancers = $dd193db6d1f94c14$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(6));
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(7));
    if (!$dd193db6d1f94c14$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $dHvbf._)(storeEnhancers));
    return (0, $bffafe2e1cf4f4f1$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $dd193db6d1f94c14$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $dd193db6d1f94c14$var$isStateFunction(x) {
    return typeof x === "function";
}
function $dd193db6d1f94c14$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $aSMts._)($dd193db6d1f94c14$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($dd193db6d1f94c14$var$isStateFunction(initialState)) getInitialState = function() {
        return $dd193db6d1f94c14$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $dd193db6d1f94c14$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $dHvbf._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $9T74l.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $9T74l.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $9T74l.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $dd193db6d1f94c14$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $dd193db6d1f94c14$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $dd193db6d1f94c14$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $dd193db6d1f94c14$var$matches = function(matcher, action) {
    if ($dd193db6d1f94c14$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $dd193db6d1f94c14$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $dd193db6d1f94c14$var$matches(matcher, action);
        });
    };
}
function $dd193db6d1f94c14$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $dd193db6d1f94c14$var$matches(matcher, action);
        });
    };
}
function $dd193db6d1f94c14$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $dd193db6d1f94c14$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $dd193db6d1f94c14$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd193db6d1f94c14$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$dd193db6d1f94c14$var$isAsyncThunkArray(asyncThunks)) return $dd193db6d1f94c14$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $dd193db6d1f94c14$export$2c3435c7647f7b0d.apply(void 0, (0, $dHvbf._)(matchers));
        return combinedMatcher(action);
    };
}
function $dd193db6d1f94c14$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd193db6d1f94c14$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$dd193db6d1f94c14$var$isAsyncThunkArray(asyncThunks)) return $dd193db6d1f94c14$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $dd193db6d1f94c14$export$2c3435c7647f7b0d.apply(void 0, (0, $dHvbf._)(matchers));
        return combinedMatcher(action);
    };
}
function $dd193db6d1f94c14$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $dd193db6d1f94c14$export$9dd1fb32974da385($dd193db6d1f94c14$export$a5c5d27e3994c5be.apply(void 0, (0, $dHvbf._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
    if (!$dd193db6d1f94c14$var$isAsyncThunkArray(asyncThunks)) return $dd193db6d1f94c14$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $dd193db6d1f94c14$export$9dd1fb32974da385($dd193db6d1f94c14$export$a5c5d27e3994c5be.apply(void 0, (0, $dHvbf._)(asyncThunks)), hasFlag);
        return combinedMatcher(action);
    };
}
function $dd193db6d1f94c14$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd193db6d1f94c14$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$dd193db6d1f94c14$var$isAsyncThunkArray(asyncThunks)) return $dd193db6d1f94c14$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $dd193db6d1f94c14$export$2c3435c7647f7b0d.apply(void 0, (0, $dHvbf._)(matchers));
        return combinedMatcher(action);
    };
}
function $dd193db6d1f94c14$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $dd193db6d1f94c14$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$dd193db6d1f94c14$var$isAsyncThunkArray(asyncThunks)) return $dd193db6d1f94c14$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = asyncThunks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var asyncThunk = _step.value;
                matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var combinedMatcher = $dd193db6d1f94c14$export$2c3435c7647f7b0d.apply(void 0, (0, $dHvbf._)(matchers));
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $dd193db6d1f94c14$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $dd193db6d1f94c14$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $50OuQ._)(this, RejectWithValue);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $2iBlG._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $dd193db6d1f94c14$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $50OuQ._)(this, FulfillWithMeta);
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ (0, $2iBlG._)(this, "_type", void 0);
    this.payload = payload;
    this.meta = meta;
};
var $dd193db6d1f94c14$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $dd193db6d1f94c14$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $dd193db6d1f94c14$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $dd193db6d1f94c14$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $dd193db6d1f94c14$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $dd193db6d1f94c14$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $dd193db6d1f94c14$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error === null || error === void 0 ? void 0 : error.name) === "AbortError",
                    condition: (error === null || error === void 0 ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options === null || options === void 0 ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $dd193db6d1f94c14$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $5Pgs2._)(function() {
                    var finalAction, _options_condition, _options_getPendingMeta, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $1XfpH.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = options === null || options === void 0 ? void 0 : (_options_condition = options.condition) === null || _options_condition === void 0 ? void 0 : _options_condition.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$dd193db6d1f94c14$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, options === null || options === void 0 ? void 0 : (_options_getPendingMeta = options.getPendingMeta) === null || _options_getPendingMeta === void 0 ? void 0 : _options_getPendingMeta.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $dd193db6d1f94c14$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $dd193db6d1f94c14$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $dd193db6d1f94c14$var$RejectWithValue) throw result;
                                            if (result instanceof $dd193db6d1f94c14$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $dd193db6d1f94c14$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($dd193db6d1f94c14$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $dd193db6d1f94c14$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $dd193db6d1f94c14$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $dd193db6d1f94c14$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $dd193db6d1f94c14$var$asyncThunkSymbol = Symbol["for"]("rtk-slice-createasyncthunk");
var $dd193db6d1f94c14$export$343355ed40c51c46 = (0, $2iBlG._)({}, $dd193db6d1f94c14$var$asyncThunkSymbol, $dd193db6d1f94c14$export$6abd22dc03e5063f);
var $dd193db6d1f94c14$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($dd193db6d1f94c14$export$23a094319a4b586 || {});
function $dd193db6d1f94c14$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $dd193db6d1f94c14$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _creators_asyncThunk;
    var cAT = creators === null || creators === void 0 ? void 0 : (_creators_asyncThunk = creators.asyncThunk) === null || _creators_asyncThunk === void 0 ? void 0 : _creators_asyncThunk[$dd193db6d1f94c14$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(11));
        typeof $b1aadf8304182be4$exports === "undefined" ? "undefined" : (0, $qb7pP._)($b1aadf8304182be4$exports);
        var reducers = (typeof options.reducers === "function" ? options.reducers($dd193db6d1f94c14$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $dd193db6d1f94c14$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($dd193db6d1f94c14$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $dd193db6d1f94c14$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $dd193db6d1f94c14$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $aSMts._)(typeof options.extraReducers === "function" ? $dd193db6d1f94c14$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, extraReducers, context.sliceCaseReducersByType);
            return $dd193db6d1f94c14$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                            _iterator1["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $dd193db6d1f94c14$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $dd193db6d1f94c14$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var map = {};
                        var _options_selectors;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_options_selectors = options.selectors) !== null && _options_selectors !== void 0 ? _options_selectors : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $aSMts._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $dd193db6d1f94c14$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var pathOpt = _param.reducerPath, config = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(_param, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt !== null && pathOpt !== void 0 ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, slice, makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $dd193db6d1f94c14$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $dHvbf._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $dd193db6d1f94c14$export$4d8d9bd83c24ae8b = $dd193db6d1f94c14$export$affdea4146de9cf5();
function $dd193db6d1f94c14$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $2iBlG._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $dHvbf._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $dd193db6d1f94c14$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$dd193db6d1f94c14$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $dd193db6d1f94c14$export$309c7a02b0b0bc62(type, prepareCallback) : $dd193db6d1f94c14$export$309c7a02b0b0bc62(type));
}
function $dd193db6d1f94c14$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $dd193db6d1f94c14$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $dd193db6d1f94c14$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $dd193db6d1f94c14$var$noop,
        pending: pending || $dd193db6d1f94c14$var$noop,
        rejected: rejected || $dd193db6d1f94c14$var$noop,
        settled: settled || $dd193db6d1f94c14$var$noop
    });
}
function $dd193db6d1f94c14$var$noop() {}
// src/entities/entity_state.ts
function $dd193db6d1f94c14$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $dd193db6d1f94c14$var$createInitialStateFactory() {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return Object.assign($dd193db6d1f94c14$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $dd193db6d1f94c14$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $dd193db6d1f94c14$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $dd193db6d1f94c14$var$isDraftTyped = (0, $9T74l.isDraft);
function $dd193db6d1f94c14$var$createSingleArgumentStateOperator(mutator) {
    var operator = $dd193db6d1f94c14$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $dd193db6d1f94c14$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $dd193db6d1f94c14$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($dd193db6d1f94c14$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $9T74l.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $dd193db6d1f94c14$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $dd193db6d1f94c14$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $dd193db6d1f94c14$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $dd193db6d1f94c14$var$selectIdValue(entity, selectId);
            if (id in state.entities) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                _iterator["return"]();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $dd193db6d1f94c14$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $dd193db6d1f94c14$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $dd193db6d1f94c14$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $dd193db6d1f94c14$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null, update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $dd193db6d1f94c14$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $aSMts._)($dd193db6d1f94c14$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $dd193db6d1f94c14$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $dd193db6d1f94c14$var$createStateOperator(addOneMutably),
        addMany: $dd193db6d1f94c14$var$createStateOperator(addManyMutably),
        setOne: $dd193db6d1f94c14$var$createStateOperator(setOneMutably),
        setMany: $dd193db6d1f94c14$var$createStateOperator(setManyMutably),
        setAll: $dd193db6d1f94c14$var$createStateOperator(setAllMutably),
        updateOne: $dd193db6d1f94c14$var$createStateOperator(updateOneMutably),
        updateMany: $dd193db6d1f94c14$var$createStateOperator(updateManyMutably),
        upsertOne: $dd193db6d1f94c14$var$createStateOperator(upsertOneMutably),
        upsertMany: $dd193db6d1f94c14$var$createStateOperator(upsertManyMutably),
        removeOne: $dd193db6d1f94c14$var$createStateOperator(removeOneMutably),
        removeMany: $dd193db6d1f94c14$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $dd193db6d1f94c14$var$createSortedStateAdapter(selectId, sort) {
    var _createUnsortedStateAdapter = $dd193db6d1f94c14$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($dd193db6d1f94c14$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $dd193db6d1f94c14$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    delete state.entities[update.id];
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $aSMts._)($dd193db6d1f94c14$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $dd193db6d1f94c14$var$createStateOperator(addOneMutably),
        updateOne: $dd193db6d1f94c14$var$createStateOperator(updateOneMutably),
        upsertOne: $dd193db6d1f94c14$var$createStateOperator(upsertOneMutably),
        setOne: $dd193db6d1f94c14$var$createStateOperator(setOneMutably),
        setMany: $dd193db6d1f94c14$var$createStateOperator(setManyMutably),
        setAll: $dd193db6d1f94c14$var$createStateOperator(setAllMutably),
        addMany: $dd193db6d1f94c14$var$createStateOperator(addManyMutably),
        updateMany: $dd193db6d1f94c14$var$createStateOperator(updateManyMutably),
        upsertMany: $dd193db6d1f94c14$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $dd193db6d1f94c14$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$_object_spread = (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _$_object_spread.selectId, sortComparer = _$_object_spread.sortComparer;
    var stateFactory = $dd193db6d1f94c14$var$createInitialStateFactory();
    var selectorsFactory = $dd193db6d1f94c14$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $dd193db6d1f94c14$var$createSortedStateAdapter(selectId, sortComparer) : $dd193db6d1f94c14$var$createUnsortedStateAdapter(selectId);
    return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory, selectorsFactory, stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $dd193db6d1f94c14$var$task = "task";
var $dd193db6d1f94c14$var$listener = "listener";
var $dd193db6d1f94c14$var$completed = "completed";
var $dd193db6d1f94c14$var$cancelled = "cancelled";
var $dd193db6d1f94c14$var$taskCancelled = "task-".concat($dd193db6d1f94c14$var$cancelled);
var $dd193db6d1f94c14$var$taskCompleted = "task-".concat($dd193db6d1f94c14$var$completed);
var $dd193db6d1f94c14$var$listenerCancelled = "".concat($dd193db6d1f94c14$var$listener, "-").concat($dd193db6d1f94c14$var$cancelled);
var $dd193db6d1f94c14$var$listenerCompleted = "".concat($dd193db6d1f94c14$var$listener, "-").concat($dd193db6d1f94c14$var$completed);
var $dd193db6d1f94c14$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $50OuQ._)(this, TaskAbortError);
    (0, $2iBlG._)(this, "name", "TaskAbortError");
    (0, $2iBlG._)(this, "message", void 0);
    this.code = code;
    this.message = "".concat($dd193db6d1f94c14$var$task, " ").concat($dd193db6d1f94c14$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $dd193db6d1f94c14$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(32));
};
var $dd193db6d1f94c14$var$noop2 = function() {};
var $dd193db6d1f94c14$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $dd193db6d1f94c14$var$noop2;
    promise["catch"](onError);
    return promise;
};
var $dd193db6d1f94c14$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $dd193db6d1f94c14$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $dd193db6d1f94c14$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $dd193db6d1f94c14$export$cb1bdac908fed7f(reason);
    }
};
function $dd193db6d1f94c14$var$raceWithSignal(signal, promise) {
    var cleanup = $dd193db6d1f94c14$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $dd193db6d1f94c14$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $dd193db6d1f94c14$var$addAbortSignalListener(signal, notifyRejection);
        promise["finally"](function() {
            return cleanup();
        }).then(resolve, reject);
    })["finally"](function() {
        cleanup = $dd193db6d1f94c14$var$noop2;
    });
}
var $dd193db6d1f94c14$var$runTask = function() {
    var _ref = (0, $5Pgs2._)(function(task2, cleanUp) {
        var value, error;
        return (0, $1XfpH.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $dd193db6d1f94c14$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp === null || cleanUp === void 0 ? void 0 : cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $dd193db6d1f94c14$var$createPause = function(signal) {
    return function(promise) {
        return $dd193db6d1f94c14$var$catchRejection($dd193db6d1f94c14$var$raceWithSignal(signal, promise).then(function(output) {
            $dd193db6d1f94c14$var$validateActive(signal);
            return output;
        }));
    };
};
var $dd193db6d1f94c14$var$createDelay = function(signal) {
    var pause = $dd193db6d1f94c14$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $dd193db6d1f94c14$var$assign = Object.assign;
var $dd193db6d1f94c14$var$INTERNAL_NIL_TOKEN = {};
var $dd193db6d1f94c14$var$alm = "listenerMiddleware";
var $dd193db6d1f94c14$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $dd193db6d1f94c14$var$addAbortSignalListener(parentAbortSignal, function() {
            return $dd193db6d1f94c14$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $dd193db6d1f94c14$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $dd193db6d1f94c14$var$runTask(/*#__PURE__*/ (0, $5Pgs2._)(function() {
            var result2;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dd193db6d1f94c14$var$validateActive(parentAbortSignal);
                        $dd193db6d1f94c14$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $dd193db6d1f94c14$var$createPause(childAbortController.signal),
                                delay: $dd193db6d1f94c14$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $dd193db6d1f94c14$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $dd193db6d1f94c14$var$abortControllerWithReason(childAbortController, $dd193db6d1f94c14$var$taskCompleted);
        });
        if (opts === null || opts === void 0 ? void 0 : opts.autoJoin) parentBlockingPromises.push(result["catch"]($dd193db6d1f94c14$var$noop2));
        return {
            result: $dd193db6d1f94c14$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $dd193db6d1f94c14$var$abortControllerWithReason(childAbortController, $dd193db6d1f94c14$var$taskCancelled);
            }
        };
    };
};
var $dd193db6d1f94c14$var$createTakePattern = function(startListening, signal) {
    var take = function() {
        var _ref = (0, $5Pgs2._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dd193db6d1f94c14$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $dd193db6d1f94c14$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $dd193db6d1f94c14$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $dd193db6d1f94c14$var$catchRejection(take(predicate, timeout));
    };
};
var $dd193db6d1f94c14$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $dd193db6d1f94c14$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(21));
    $dd193db6d1f94c14$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $dd193db6d1f94c14$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $dd193db6d1f94c14$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $dd193db6d1f94c14$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $dd193db6d1f94c14$var$createListenerEntry;
    }
});
var $dd193db6d1f94c14$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $dd193db6d1f94c14$var$abortControllerWithReason(controller, $dd193db6d1f94c14$var$listenerCancelled);
    });
};
var $dd193db6d1f94c14$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($dd193db6d1f94c14$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $dd193db6d1f94c14$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $dd193db6d1f94c14$export$f03a6b845d3fb58b = Object.assign($dd193db6d1f94c14$export$309c7a02b0b0bc62("".concat($dd193db6d1f94c14$var$alm, "/add")), {
    withTypes: function() {
        return $dd193db6d1f94c14$export$f03a6b845d3fb58b;
    }
});
var $dd193db6d1f94c14$export$b1b8022855fb2b71 = $dd193db6d1f94c14$export$309c7a02b0b0bc62("".concat($dd193db6d1f94c14$var$alm, "/removeAll"));
var $dd193db6d1f94c14$export$b03e9483f936dccb = Object.assign($dd193db6d1f94c14$export$309c7a02b0b0bc62("".concat($dd193db6d1f94c14$var$alm, "/remove")), {
    withTypes: function() {
        return $dd193db6d1f94c14$export$b03e9483f936dccb;
    }
});
var $dd193db6d1f94c14$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($dd193db6d1f94c14$var$alm, "/error")
    ].concat((0, $dHvbf._)(args)));
};
var $dd193db6d1f94c14$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $dd193db6d1f94c14$var$defaultErrorHandler : _middlewareOptions_onError;
    $dd193db6d1f94c14$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap["delete"](entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions === null || cancelOptions === void 0 ? void 0 : cancelOptions.cancelActive) $dd193db6d1f94c14$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $dd193db6d1f94c14$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $dd193db6d1f94c14$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $dd193db6d1f94c14$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $dd193db6d1f94c14$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $dd193db6d1f94c14$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = function() {
        var _ref = (0, $5Pgs2._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $1XfpH.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $dd193db6d1f94c14$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $dd193db6d1f94c14$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $dd193db6d1f94c14$var$createDelay(internalTaskController.signal),
                                pause: $dd193db6d1f94c14$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $dd193db6d1f94c14$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $dd193db6d1f94c14$var$abortControllerWithReason(controller, $dd193db6d1f94c14$var$listenerCancelled);
                                            set["delete"](controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $dd193db6d1f94c14$var$abortControllerWithReason(internalTaskController, $dd193db6d1f94c14$var$listenerCancelled);
                                    entry.pending["delete"](internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $dd193db6d1f94c14$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $dd193db6d1f94c14$export$cb1bdac908fed7f)) $dd193db6d1f94c14$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $dd193db6d1f94c14$var$abortControllerWithReason(internalTaskController, $dd193db6d1f94c14$var$listenerCompleted);
                        entry.pending["delete"](internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $dd193db6d1f94c14$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $bffafe2e1cf4f4f1$export$b956e38827fca970)(action)) return next(action);
                if ($dd193db6d1f94c14$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($dd193db6d1f94c14$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($dd193db6d1f94c14$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $dd193db6d1f94c14$var$INTERNAL_NIL_TOKEN) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $dd193db6d1f94c14$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                    _iterator["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $dd193db6d1f94c14$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $dd193db6d1f94c14$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $dd193db6d1f94c14$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $dd193db6d1f94c14$var$matchInstance = function(instanceId) {
    return function(action) {
        var _action_meta;
        return (action === null || action === void 0 ? void 0 : (_action_meta = action.meta) === null || _action_meta === void 0 ? void 0 : _action_meta.instanceId) === instanceId;
    };
};
var $dd193db6d1f94c14$export$4bb1606a79445586 = function() {
    var instanceId = $dd193db6d1f94c14$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($dd193db6d1f94c14$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $dd193db6d1f94c14$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $dd193db6d1f94c14$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $dd193db6d1f94c14$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $bffafe2e1cf4f4f1$export$f672e0b6f7222cd7).apply(void 0, (0, $dHvbf._)(appliedMiddleware));
    };
    var isWithMiddleware = $dd193db6d1f94c14$export$9dd1fb32974da385(withMiddleware, $dd193db6d1f94c14$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $dHvbf._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $dd193db6d1f94c14$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $dd193db6d1f94c14$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $dd193db6d1f94c14$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $dd193db6d1f94c14$var$ORIGINAL_STATE = Symbol["for"]("rtk-state-proxy-original");
var $dd193db6d1f94c14$var$isStateProxy = function(value) {
    return !!value && !!value[$dd193db6d1f94c14$var$ORIGINAL_STATE];
};
var $dd193db6d1f94c14$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $dd193db6d1f94c14$var$createStateProxy = function(state, reducerMap) {
    return $dd193db6d1f94c14$var$emplace($dd193db6d1f94c14$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $dd193db6d1f94c14$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $dd193db6d1f94c14$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $dd193db6d1f94c14$var$original = function(state) {
    if (!$dd193db6d1f94c14$var$isStateProxy(state)) throw new Error($dd193db6d1f94c14$export$378fa86b259c0280(25));
    return state[$dd193db6d1f94c14$var$ORIGINAL_STATE];
};
function $dd193db6d1f94c14$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($dd193db6d1f94c14$var$getReducers(slices));
    var getReducer = function() {
        return (0, $bffafe2e1cf4f4f1$export$66e4520cdb265d18)(reducerMap);
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $b1aadf8304182be4$exports === "undefined" ? "undefined" : (0, $qb7pP._)($b1aadf8304182be4$exports);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $dd193db6d1f94c14$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $dHvbf._)(args))) : state, reducerMap)
            ].concat((0, $dHvbf._)(args)));
        };
    }, {
        original: $dd193db6d1f94c14$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $dd193db6d1f94c14$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}


var $a0cc13637f716510$var$cartSlice = (0, $dd193db6d1f94c14$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: function(state, action) {
            state.items.push(action.payload);
        },
        removeItem: function(state, action) {
            var removedArray = state.items.filter(function(item) {
                return item.card.info.id !== action.payload.card.info.id;
            });
            return {
                items: removedArray
            };
        },
        clearCart: function(state, action) {
            state.items.length = 0;
        }
    }
});
var $a0cc13637f716510$var$_cartSlice_actions = $a0cc13637f716510$var$cartSlice.actions;
var $a0cc13637f716510$export$fb9705de59d96855 = $a0cc13637f716510$var$_cartSlice_actions.addItem, $a0cc13637f716510$export$fe2d9b4e03920b4c = $a0cc13637f716510$var$_cartSlice_actions.removeItem, $a0cc13637f716510$export$810121176e3e3671 = $a0cc13637f716510$var$_cartSlice_actions.clearCart;
var $a0cc13637f716510$export$2e2bcd8739ae039 = $a0cc13637f716510$var$cartSlice.reducer;



var $3aC2T = parcelRequire("3aC2T");



var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");
function $2641cb1ee5dd360d$export$2e2bcd8739ae039() {
    $2641cb1ee5dd360d$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2641cb1ee5dd360d$export$2e2bcd8739ae039.apply(this, arguments);
}



var $3aC2T = parcelRequire("3aC2T");

function $0bcc6b3945dce3a7$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.checkForDefaultPrevented, checkForDefaultPrevented = tmp === void 0 ? true : tmp;
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $412308b0c5df3cb9$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $412308b0c5df3cb9$export$43e446d32b3d21af() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(node) {
        return refs.forEach(function(ref) {
            return $412308b0c5df3cb9$var$$6ed0406888f73fc4$var$setRef(ref, node);
        });
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $412308b0c5df3cb9$export$c7b2cbe3552a0d05() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $3aC2T.useCallback)($412308b0c5df3cb9$export$43e446d32b3d21af.apply(void 0, (0, $dHvbf._)(refs)), refs);
}



var $2iBlG = parcelRequire("2iBlG");



var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");

var $2iBlG = parcelRequire("2iBlG");




var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");
function $9632a9140807dc32$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    var Context = /*#__PURE__*/ (0, $3aC2T.createContext)(defaultContext);
    function Provider(props) {
        var children = props.children, context = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
            "children"
        ]); // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var value = (0, $3aC2T.useMemo)(function() {
            return context;
        }, Object.values(context));
        return /*#__PURE__*/ (0, $3aC2T.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        var context = (0, $3aC2T.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $9632a9140807dc32$export$50c7b4e9d9f19c1(scopeName) {
    var createContextScopeDeps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        var BaseContext = /*#__PURE__*/ (0, $3aC2T.createContext)(defaultContext);
        var index = defaultContexts.length;
        defaultContexts = (0, $dHvbf._)(defaultContexts).concat([
            defaultContext
        ]);
        function Provider(props) {
            var scope = props.scope, children = props.children, context = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
                "scope",
                "children"
            ]);
            var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            var value = (0, $3aC2T.useMemo)(function() {
                return context;
            }, Object.values(context));
            return /*#__PURE__*/ (0, $3aC2T.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            var Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            var context = (0, $3aC2T.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error("`".concat(consumerName, "` must be used within `").concat(rootComponentName, "`"));
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ var createScope = function() {
        var scopeContexts = defaultContexts.map(function(defaultContext) {
            return /*#__PURE__*/ (0, $3aC2T.createContext)(defaultContext);
        });
        return function useScope(scope) {
            var contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $3aC2T.useMemo)(function() {
                return (0, $2iBlG._)({}, "__scope".concat(scopeName), (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, scope), (0, $2iBlG._)({}, scopeName, contexts)));
            }, [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $9632a9140807dc32$var$$c512c27ab02ef895$var$composeContextScopes.apply(void 0, [
            createScope
        ].concat((0, $dHvbf._)(createContextScopeDeps)))
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $9632a9140807dc32$var$$c512c27ab02ef895$var$composeContextScopes() {
    for(var _len = arguments.length, scopes = new Array(_len), _key = 0; _key < _len; _key++){
        scopes[_key] = arguments[_key];
    }
    var baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    var createScope1 = function() {
        var scopeHooks = scopes.map(function(createScope) {
            return {
                useScope: createScope(),
                scopeName: createScope.scopeName
            };
        });
        return function useComposedScopes(overrideScopes) {
            var nextScopes1 = scopeHooks.reduce(function(nextScopes, param) {
                var useScope = param.useScope, scopeName = param.scopeName;
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var scopeProps = useScope(overrideScopes);
                var currentScope = scopeProps["__scope".concat(scopeName)];
                return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, nextScopes, currentScope);
            }, {});
            return (0, $3aC2T.useMemo)(function() {
                return (0, $2iBlG._)({}, "__scope".concat(baseScope.scopeName), nextScopes1);
            }, [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}







var $dHvbf = parcelRequire("dHvbf");


var $3aC2T = parcelRequire("3aC2T");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ var $ac5a52088dda9880$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var children = props.children, slotProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    var childrenArray = (0, $3aC2T.Children).toArray(children);
    var slottable = childrenArray.find($ac5a52088dda9880$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        var newElement = slottable.props.children;
        var newChildren = childrenArray.map(function(child) {
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $3aC2T.Children).count(newElement) > 1) return (0, $3aC2T.Children).only(null);
                return /*#__PURE__*/ (0, $3aC2T.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $3aC2T.createElement)($ac5a52088dda9880$var$$5e63c961fc1ce211$var$SlotClone, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $3aC2T.isValidElement)(newElement) ? /*#__PURE__*/ (0, $3aC2T.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $3aC2T.createElement)($ac5a52088dda9880$var$$5e63c961fc1ce211$var$SlotClone, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$ac5a52088dda9880$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ var $ac5a52088dda9880$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var children = props.children, slotProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "children"
    ]);
    if (/*#__PURE__*/ (0, $3aC2T.isValidElement)(children)) return /*#__PURE__*/ (0, $3aC2T.cloneElement)(children, (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, $ac5a52088dda9880$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props)), {
        ref: forwardedRef ? (0, $412308b0c5df3cb9$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    }));
    return (0, $3aC2T.Children).count(children) > 1 ? (0, $3aC2T.Children).only(null) : null;
});
$ac5a52088dda9880$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ var $ac5a52088dda9880$export$d9f1ccf0bdb05d45 = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $3aC2T.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $ac5a52088dda9880$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $3aC2T.isValidElement)(child) && child.type === $ac5a52088dda9880$export$d9f1ccf0bdb05d45;
}
function $ac5a52088dda9880$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    var _loop = function(propName) {
        var slotPropValue = slotProps[propName];
        var childPropValue = childProps[propName];
        var isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                childPropValue.apply(void 0, (0, $dHvbf._)(args));
                slotPropValue.apply(void 0, (0, $dHvbf._)(args));
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, slotPropValue, childPropValue);
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    };
    // all child props should override
    var overrideProps = (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, childProps);
    for(var propName in childProps)_loop(propName);
    return (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, slotProps, overrideProps);
}
var $ac5a52088dda9880$export$be92b6f5f03c0fe9 = $ac5a52088dda9880$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $7429be92871737da$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ var PROVIDER_NAME = name + "CollectionProvider";
    var _$6vYhU$createContextScope = (0, $aSMts._)((0, $9632a9140807dc32$export$50c7b4e9d9f19c1)(PROVIDER_NAME), 2), createCollectionContext = _$6vYhU$createContextScope[0], createCollectionScope = _$6vYhU$createContextScope[1];
    var _createCollectionContext = (0, $aSMts._)(createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    }), 2), CollectionProviderImpl = _createCollectionContext[0], useCollectionContext = _createCollectionContext[1];
    var CollectionProvider = function(props) {
        var scope = props.scope, children = props.children;
        var ref = (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).useRef(null);
        var itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ var COLLECTION_SLOT_NAME = name + "CollectionSlot";
    var CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).forwardRef(function(props, forwardedRef) {
        var scope = props.scope, children = props.children;
        var context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, $ac5a52088dda9880$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ var ITEM_SLOT_NAME = name + "CollectionItemSlot";
    var ITEM_DATA_ATTR = "data-radix-collection-item";
    var CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).forwardRef(function(props, forwardedRef) {
        var scope = props.scope, children = props.children, itemData = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
            "scope",
            "children"
        ]);
        var ref = (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).useRef(null);
        var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        var context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).useEffect(function() {
            context.itemMap.set(ref, (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
                ref: ref
            }, itemData));
            return function() {
                return void context.itemMap["delete"](ref);
            };
        });
        var _obj;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).createElement((0, $ac5a52088dda9880$export$8c6ed5c666ac1360), (_obj = {}, (0, $2iBlG._)(_obj, ITEM_DATA_ATTR, ""), (0, $2iBlG._)(_obj, "ref", composedRefs), _obj), children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        var context = useCollectionContext(name + "CollectionConsumer", scope);
        var getItems = (0, (/*@__PURE__*/$parcel$interopDefault($3aC2T))).useCallback(function() {
            var collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            var orderedNodes = Array.from(collectionNode.querySelectorAll("[".concat(ITEM_DATA_ATTR, "]")));
            var items = Array.from(context.itemMap.values());
            var orderedItems = items.sort(function(a, b) {
                return orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current);
            });
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}






var $aSMts = parcelRequire("aSMts");

var $dHvbf = parcelRequire("dHvbf");


var $3aC2T = parcelRequire("3aC2T");


var $2iBlG = parcelRequire("2iBlG");





var $3aC2T = parcelRequire("3aC2T");


var $9ce0b5db9b85dbae$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ var $9ce0b5db9b85dbae$export$250ffa63cdc0d034 = $9ce0b5db9b85dbae$var$$8927f6f2acc4f386$var$NODES.reduce(function(primitive, node) {
    var Node = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
        var asChild = props.asChild, primitiveProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
            "asChild"
        ]);
        var Comp = asChild ? (0, $ac5a52088dda9880$export$8c6ed5c666ac1360) : node;
        (0, $3aC2T.useEffect)(function() {
            window[Symbol["for"]("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $3aC2T.createElement)(Comp, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = "Primitive.".concat(node);
    return (0, $219ff6b9141574a5$export$4fa2f4023c9cbda5)((0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({}, primitive), (0, $2iBlG._)({}, node, Node));
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $9ce0b5db9b85dbae$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $cd654765cc6da6c6$exports.flushSync)(function() {
        return target.dispatchEvent(event);
    });
}
/* -----------------------------------------------------------------------------------------------*/ var $9ce0b5db9b85dbae$export$be92b6f5f03c0fe9 = $9ce0b5db9b85dbae$export$250ffa63cdc0d034;




var $dHvbf = parcelRequire("dHvbf");

var $3aC2T = parcelRequire("3aC2T");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $99a6ed5a8631b664$export$25bec8c6f54ee79a(callback) {
    var callbackRef = (0, $3aC2T.useRef)(callback);
    (0, $3aC2T.useEffect)(function() {
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $3aC2T.useMemo)(function() {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _callbackRef$current;
            var _callbackRef$current1;
            return (_callbackRef$current1 = callbackRef.current) === null || _callbackRef$current1 === void 0 ? void 0 : (_callbackRef$current = _callbackRef$current1).call.apply(_callbackRef$current, [
                callbackRef
            ].concat((0, $dHvbf._)(args)));
        };
    }, []);
}



var $3aC2T = parcelRequire("3aC2T");

/**
 * Listens for when the escape key is down
 */ function $175a0bdac97215ec$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var onEscapeKeyDown = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $3aC2T.useEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return function() {
            return ownerDocument.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $3aC2T.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
var $37c1eb94e3048b3d$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var _node$ownerDocument;
    var tmp = props.disableOutsidePointerEvents, disableOutsidePointerEvents = tmp === void 0 ? false : tmp, onEscapeKeyDown = props.onEscapeKeyDown, onPointerDownOutside = props.onPointerDownOutside, onFocusOutside = props.onFocusOutside, onInteractOutside = props.onInteractOutside, onDismiss = props.onDismiss, layerProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside",
        "onDismiss"
    ]);
    var context = (0, $3aC2T.useContext)($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$DismissableLayerContext);
    var _$kqwpH$useState = (0, $aSMts._)((0, $3aC2T.useState)(null), 2), node1 = _$kqwpH$useState[0], setNode = _$kqwpH$useState[1];
    var ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var _$kqwpH$useState1 = (0, $aSMts._)((0, $3aC2T.useState)({}), 2), force = _$kqwpH$useState1[1];
    var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setNode(node);
    });
    var layers = Array.from(context.layers);
    var _to_consumable_array_slice = (0, $aSMts._)((0, $dHvbf._)(context.layersWithOutsidePointerEventsDisabled).slice(-1), 1), highestLayerWithOutsidePointerEventsDisabled = _to_consumable_array_slice[0]; // prettier-ignore
    var highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    var index = node1 ? layers.indexOf(node1) : -1;
    var isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    var isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    var pointerDownOutside = $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$usePointerDownOutside(function(event) {
        var target = event.target;
        var isPointerDownOnBranch = (0, $dHvbf._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    var focusOutside = $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$useFocusOutside(function(event) {
        var target = event.target;
        var isFocusInBranch = (0, $dHvbf._)(context.branches).some(function(branch) {
            return branch.contains(target);
        });
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $175a0bdac97215ec$export$3a72a57244d6e765)(function(event) {
        var isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $3aC2T.useEffect)(function() {
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$dispatchUpdate();
        return function() {
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $3aC2T.useEffect)(function() {
        return function() {
            if (!node1) return;
            context.layers["delete"](node1);
            context.layersWithOutsidePointerEventsDisabled["delete"](node1);
            $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $3aC2T.useEffect)(function() {
        var handleUpdate = function() {
            return force({});
        };
        document.addEventListener($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return function() {
            return document.removeEventListener($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        };
    }, []);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined
        }, props.style),
        onFocusCapture: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($37c1eb94e3048b3d$export$177fb62ff3ec1f22, {
    displayName: $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ var $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
var $37c1eb94e3048b3d$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var context = (0, $3aC2T.useContext)($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$DismissableLayerContext);
    var ref = (0, $3aC2T.useRef)(null);
    var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $3aC2T.useEffect)(function() {
        var node = ref.current;
        if (node) {
            context.branches.add(node);
            return function() {
                context.branches["delete"](node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($37c1eb94e3048b3d$export$4d5eb2109db14228, {
    displayName: $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var handlePointerDownOutside = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(onPointerDownOutside);
    var isPointerInsideReactTreeRef = (0, $3aC2T.useRef)(false);
    var handleClickRef = (0, $3aC2T.useRef)(function() {});
    (0, $3aC2T.useEffect)(function() {
        var handlePointerDown = function(event) {
            if (event.target && !isPointerInsideReactTreeRef.current) {
                var handleAndDispatchPointerDownOutsideEvent = function handleAndDispatchPointerDownOutsideEvent() {
                    $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var eventDetail = {
                    originalEvent: event
                };
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ var timerId = window.setTimeout(function() {
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return function() {
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: function() {
            return isPointerInsideReactTreeRef.current = true;
        }
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    var ownerDocument = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    var handleFocusOutside = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(onFocusOutside);
    var isFocusInsideReactTreeRef = (0, $3aC2T.useRef)(false);
    (0, $3aC2T.useEffect)(function() {
        var handleFocus = function(event) {
            if (event.target && !isFocusInsideReactTreeRef.current) {
                var eventDetail = {
                    originalEvent: event
                };
                $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return function() {
            return ownerDocument.removeEventListener("focusin", handleFocus);
        };
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: function() {
            return isFocusInsideReactTreeRef.current = true;
        },
        onBlurCapture: function() {
            return isFocusInsideReactTreeRef.current = false;
        }
    };
}
function $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$dispatchUpdate() {
    var event = new CustomEvent($37c1eb94e3048b3d$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $37c1eb94e3048b3d$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, param) {
    var discrete = param.discrete;
    var target = detail.originalEvent.target;
    var event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9ce0b5db9b85dbae$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $37c1eb94e3048b3d$export$be92b6f5f03c0fe9 = $37c1eb94e3048b3d$export$177fb62ff3ec1f22;
var $37c1eb94e3048b3d$export$aecb2ddcb55c95be = $37c1eb94e3048b3d$export$4d5eb2109db14228;





var $3aC2T = parcelRequire("3aC2T");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ var $fd81f363624b1018$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
var $fd81f363624b1018$export$602eac185826482c = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var _globalThis$document;
    var tmp = props.container, container = tmp === void 0 ? globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body : tmp, portalProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "container"
    ]);
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cd654765cc6da6c6$exports))).createPortal(/*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($fd81f363624b1018$export$602eac185826482c, {
    displayName: $fd81f363624b1018$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $fd81f363624b1018$export$be92b6f5f03c0fe9 = $fd81f363624b1018$export$602eac185826482c;



var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");



var $3aC2T = parcelRequire("3aC2T");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ var $87c460e54a6a0a0a$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $3aC2T.useLayoutEffect) : function() {};


function $f51880d8e2fdfa5a$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $3aC2T.useReducer)(function(state, event) {
        var nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
var $f51880d8e2fdfa5a$export$99c2b779aa4e8b8b = function(props) {
    var present = props.present, children = props.children;
    var presence = $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$usePresence(present);
    var child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $3aC2T.Children).only(children);
    var ref = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    var forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $3aC2T.cloneElement)(child, {
        ref: ref
    }) : null;
};
$f51880d8e2fdfa5a$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$usePresence(present) {
    var _$iqq3r$useState = (0, $aSMts._)((0, $3aC2T.useState)(), 2), node1 = _$iqq3r$useState[0], setNode = _$iqq3r$useState[1];
    var stylesRef = (0, $3aC2T.useRef)({});
    var prevPresentRef = (0, $3aC2T.useRef)(present);
    var prevAnimationNameRef = (0, $3aC2T.useRef)("none");
    var initialState = present ? "mounted" : "unmounted";
    var _$fe963b355347cc68$export$3e6543de14f8614f = (0, $aSMts._)($f51880d8e2fdfa5a$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    }), 2), state = _$fe963b355347cc68$export$3e6543de14f8614f[0], send = _$fe963b355347cc68$export$3e6543de14f8614f[1];
    (0, $3aC2T.useEffect)(function() {
        var currentAnimationName = $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $87c460e54a6a0a0a$export$e5c5a5f917a5871c)(function() {
        var styles = stylesRef.current;
        var wasPresent = prevPresentRef.current;
        var hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            var prevAnimationName = prevAnimationNameRef.current;
            var currentAnimationName = $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ var isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $87c460e54a6a0a0a$export$e5c5a5f917a5871c)(function() {
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ var handleAnimationEnd = function(event) {
                var currentAnimationName = $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                var isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $cd654765cc6da6c6$exports.flushSync)(function() {
                    return send("ANIMATION_END");
                });
            };
            var handleAnimationStart = function(event) {
                if (event.target === node1) prevAnimationNameRef.current = $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return function() {
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $3aC2T.useCallback)(function(node) {
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $f51880d8e2fdfa5a$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $aSMts = parcelRequire("aSMts");

var $3aC2T = parcelRequire("3aC2T");

function $0313c4d98332b104$export$6f32135080cb4c3(param) {
    var prop = param.prop, defaultProp = param.defaultProp, tmp = param.onChange, onChange = tmp === void 0 ? function() {} : tmp;
    var _$71cd76cc60e0454e$var$useUncontrolledState = (0, $aSMts._)($0313c4d98332b104$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    }), 2), uncontrolledProp = _$71cd76cc60e0454e$var$useUncontrolledState[0], setUncontrolledProp = _$71cd76cc60e0454e$var$useUncontrolledState[1];
    var isControlled = prop !== undefined;
    var value1 = isControlled ? prop : uncontrolledProp;
    var handleChange = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(onChange);
    var setValue = (0, $3aC2T.useCallback)(function(nextValue) {
        if (isControlled) {
            var setter = nextValue;
            var value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $0313c4d98332b104$var$$71cd76cc60e0454e$var$useUncontrolledState(param) {
    var defaultProp = param.defaultProp, onChange = param.onChange;
    var uncontrolledState = (0, $3aC2T.useState)(defaultProp);
    var _uncontrolledState = (0, $aSMts._)(uncontrolledState, 1), value = _uncontrolledState[0];
    var prevValueRef = (0, $3aC2T.useRef)(value);
    var handleChange = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(onChange);
    (0, $3aC2T.useEffect)(function() {
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}






var $3aC2T = parcelRequire("3aC2T");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ var $2fb6311364b90287$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
var $2fb6311364b90287$export$439d29a4e110a164 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).span, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal"
        }, props.style)
    }));
});
/*#__PURE__*/ Object.assign($2fb6311364b90287$export$439d29a4e110a164, {
    displayName: $2fb6311364b90287$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $2fb6311364b90287$export$be92b6f5f03c0fe9 = $2fb6311364b90287$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
var $1054c53496897b1c$var$_$eyrYI$createCollection = (0, $aSMts._)((0, $7429be92871737da$export$c74125a8e3af6bb2)("Toast"), 3), $1054c53496897b1c$var$$054eb8030ebde76e$var$Collection = $1054c53496897b1c$var$_$eyrYI$createCollection[0], $1054c53496897b1c$var$$054eb8030ebde76e$var$useCollection = $1054c53496897b1c$var$_$eyrYI$createCollection[1], $1054c53496897b1c$var$$054eb8030ebde76e$var$createCollectionScope = $1054c53496897b1c$var$_$eyrYI$createCollection[2];
var $1054c53496897b1c$var$_$eyrYI$createContextScope = (0, $aSMts._)((0, $9632a9140807dc32$export$50c7b4e9d9f19c1)("Toast", [
    $1054c53496897b1c$var$$054eb8030ebde76e$var$createCollectionScope
]), 2), $1054c53496897b1c$var$$054eb8030ebde76e$var$createToastContext = $1054c53496897b1c$var$_$eyrYI$createContextScope[0], $1054c53496897b1c$export$8a359da18fbc9073 = $1054c53496897b1c$var$_$eyrYI$createContextScope[1];
var $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext = (0, $aSMts._)($1054c53496897b1c$var$$054eb8030ebde76e$var$createToastContext($1054c53496897b1c$var$$054eb8030ebde76e$var$PROVIDER_NAME), 2), $1054c53496897b1c$var$$054eb8030ebde76e$var$ToastProviderProvider = $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext[0], $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastProviderContext = $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext[1];
var $1054c53496897b1c$export$f5d03d415824e0e = function(props) {
    var __scopeToast = props.__scopeToast, tmp = props.label, label = tmp === void 0 ? "Notification" : tmp, tmp1 = props.duration, duration = tmp1 === void 0 ? 5000 : tmp1, tmp2 = props.swipeDirection, swipeDirection = tmp2 === void 0 ? "right" : tmp2, tmp3 = props.swipeThreshold, swipeThreshold = tmp3 === void 0 ? 50 : tmp3, children = props.children;
    var _$eyrYI$useState = (0, $aSMts._)((0, $3aC2T.useState)(null), 2), viewport = _$eyrYI$useState[0], setViewport = _$eyrYI$useState[1];
    var _$eyrYI$useState1 = (0, $aSMts._)((0, $3aC2T.useState)(0), 2), toastCount = _$eyrYI$useState1[0], setToastCount = _$eyrYI$useState1[1];
    var isFocusedToastEscapeKeyDownRef = (0, $3aC2T.useRef)(false);
    var isClosePausedRef = (0, $3aC2T.useRef)(false);
    return /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $3aC2T.useCallback)(function() {
            return setToastCount(function(prevCount) {
                return prevCount + 1;
            });
        }, []),
        onToastRemove: (0, $3aC2T.useCallback)(function() {
            return setToastCount(function(prevCount) {
                return prevCount - 1;
            });
        }, []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$1054c53496897b1c$export$f5d03d415824e0e.propTypes = {
    label: function(props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            var error = "Invalid prop `label` supplied to `".concat($1054c53496897b1c$var$$054eb8030ebde76e$var$PROVIDER_NAME, "`. Expected non-empty `string`.");
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$f5d03d415824e0e, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
var $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
var $1054c53496897b1c$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, tmp = props.hotkey, hotkey = tmp === void 0 ? $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY : tmp, tmp1 = props.label, label = tmp1 === void 0 ? "Notifications ({hotkey})" : tmp1, viewportProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "hotkey",
        "label"
    ]);
    var context = $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastProviderContext($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    var getItems = $1054c53496897b1c$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    var wrapperRef = (0, $3aC2T.useRef)(null);
    var headFocusProxyRef = (0, $3aC2T.useRef)(null);
    var tailFocusProxyRef = (0, $3aC2T.useRef)(null);
    var ref = (0, $3aC2T.useRef)(null);
    var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    var hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    var hasToasts = context.toastCount > 0;
    (0, $3aC2T.useEffect)(function() {
        var handleKeyDown = function(event) {
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            var isHotkeyPressed = hotkey.every(function(key) {
                return event[key] || event.code === key;
            });
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        hotkey
    ]);
    (0, $3aC2T.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            var handlePause = function() {
                if (!context.isClosePausedRef.current) {
                    var pauseEvent = new CustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            var handleResume = function() {
                if (context.isClosePausedRef.current) {
                    var resumeEvent = new CustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            var handleFocusOutResume = function(event) {
                var isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            var handlePointerLeaveResume = function() {
                var isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return function() {
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    var getSortedTabbableCandidates = (0, $3aC2T.useCallback)(function(param) {
        var tabbingDirection = param.tabbingDirection;
        var toastItems = getItems();
        var tabbableCandidates = toastItems.map(function(toastItem) {
            var toastNode = toastItem.ref.current;
            var toastTabbableCandidates = [
                toastNode
            ].concat((0, $dHvbf._)($1054c53496897b1c$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)));
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $3aC2T.useEffect)(function() {
        var viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            var handleKeyDown = function(event) {
                var isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                var isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    var focusedElement = document.activeElement;
                    var isTabbingBackwards = event.shiftKey;
                    var targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    var tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    var sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    var index = sortedCandidates.findIndex(function(candidate) {
                        return candidate === focusedElement;
                    });
                    if ($1054c53496897b1c$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return function() {
                return viewport.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $37c1eb94e3048b3d$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: function() {
            var tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $1054c53496897b1c$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).ol, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: function() {
            var tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $1054c53496897b1c$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$6192c2425ecfd989, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, onFocusFromOutsideViewport = props.onFocusFromOutsideViewport, proxyProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "onFocusFromOutsideViewport"
    ]);
    var context = $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastProviderContext($1054c53496897b1c$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $2fb6311364b90287$export$439d29a4e110a164), (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: function(event) {
            var _context$viewport;
            var prevFocusedElement = event.relatedTarget;
            var isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
var $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
var $1054c53496897b1c$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var forceMount = props.forceMount, openProp = props.open, defaultOpen = props.defaultOpen, onOpenChange = props.onOpenChange, toastProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "forceMount",
        "open",
        "defaultOpen",
        "onOpenChange"
    ]);
    var _$eyrYI$useControllableState = (0, $aSMts._)((0, $0313c4d98332b104$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    }), 2), tmp = _$eyrYI$useControllableState[0], open = tmp === void 0 ? true : tmp, setOpen = _$eyrYI$useControllableState[1];
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $f51880d8e2fdfa5a$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastImpl, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: function() {
            return setOpen(false);
        },
        onPause: (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onSwipeStart, function(event) {
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onSwipeMove, function(event) {
            var _event_detail_delta = event.detail.delta, x = _event_detail_delta.x, y = _event_detail_delta.y;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", "".concat(x, "px"));
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", "".concat(y, "px"));
        }),
        onSwipeCancel: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onSwipeCancel, function(event) {
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onSwipeEnd, function(event) {
            var _event_detail_delta = event.detail.delta, x = _event_detail_delta.x, y = _event_detail_delta.y;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", "".concat(x, "px"));
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", "".concat(y, "px"));
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$8d8dc7d5f743331b, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext1 = (0, $aSMts._)($1054c53496897b1c$var$$054eb8030ebde76e$var$createToastContext($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose: function() {}
}), 2), $1054c53496897b1c$var$$054eb8030ebde76e$var$ToastInteractiveProvider = $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext1[0], $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastInteractiveContext = $1054c53496897b1c$var$_$054eb8030ebde76e$var$createToastContext1[1];
var $1054c53496897b1c$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, tmp = props.type, type = tmp === void 0 ? "foreground" : tmp, durationProp = props.duration, open = props.open, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onPause = props.onPause, onResume = props.onResume, onSwipeStart = props.onSwipeStart, onSwipeMove = props.onSwipeMove, onSwipeCancel = props.onSwipeCancel, onSwipeEnd = props.onSwipeEnd, toastProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "type",
        "duration",
        "open",
        "onClose",
        "onEscapeKeyDown",
        "onPause",
        "onResume",
        "onSwipeStart",
        "onSwipeMove",
        "onSwipeCancel",
        "onSwipeEnd"
    ]);
    var context = $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastProviderContext($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    var _$eyrYI$useState = (0, $aSMts._)((0, $3aC2T.useState)(null), 2), node1 = _$eyrYI$useState[0], setNode = _$eyrYI$useState[1];
    var composedRefs = (0, $412308b0c5df3cb9$export$c7b2cbe3552a0d05)(forwardedRef, function(node) {
        return setNode(node);
    });
    var pointerStartRef = (0, $3aC2T.useRef)(null);
    var swipeDeltaRef = (0, $3aC2T.useRef)(null);
    var duration1 = durationProp || context.duration;
    var closeTimerStartTimeRef = (0, $3aC2T.useRef)(0);
    var closeTimerRemainingTimeRef = (0, $3aC2T.useRef)(duration1);
    var closeTimerRef = (0, $3aC2T.useRef)(0);
    var onToastAdd = context.onToastAdd, onToastRemove = context.onToastRemove;
    var handleClose = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(function() {
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        var isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    var startTimer = (0, $3aC2T.useCallback)(function(duration) {
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $3aC2T.useEffect)(function() {
        var viewport = context.viewport;
        if (viewport) {
            var handleResume = function() {
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            var handlePause = function() {
                var elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return function() {
                viewport.removeEventListener($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($1054c53496897b1c$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $3aC2T.useEffect)(function() {
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $3aC2T.useEffect)(function() {
        onToastAdd();
        return function() {
            return onToastRemove();
        };
    }, [
        onToastAdd,
        onToastRemove
    ]);
    var announceTextContent = (0, $3aC2T.useMemo)(function() {
        return node1 ? $1054c53496897b1c$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $3aC2T.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $cd654765cc6da6c6$exports.createPortal)(/*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $3aC2T.createElement)((0, $37c1eb94e3048b3d$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(onEscapeKeyDown, function() {
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).li, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: (0, $50aa2eeb65885e7e$export$581ff339ea0ba762)({
            userSelect: "none",
            touchAction: "none"
        }, props.style),
        onKeyDown: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onKeyDown, function(event) {
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onPointerDown, function(event) {
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onPointerMove, function(event) {
            if (!pointerStartRef.current) return;
            var x = event.clientX - pointerStartRef.current.x;
            var y = event.clientY - pointerStartRef.current.y;
            var hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            var isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            var clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            var clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            var clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            var moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            var delta = {
                x: clampedX,
                y: clampedY
            };
            var eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $1054c53496897b1c$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($1054c53496897b1c$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $1054c53496897b1c$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onPointerUp, function(event1) {
            var delta = swipeDeltaRef.current;
            var target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                var toast = event1.currentTarget;
                var eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($1054c53496897b1c$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $1054c53496897b1c$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $1054c53496897b1c$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", function(event) {
                    return event.preventDefault();
                }, {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$1054c53496897b1c$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type: function(props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            var error = "Invalid prop `type` supplied to `".concat($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME, "`. Expected `foreground | background`.");
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$ToastAnnounce = function(props) {
    var __scopeToast = props.__scopeToast, children = props.children, announceProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "children"
    ]);
    var context = $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastProviderContext($1054c53496897b1c$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    var _$eyrYI$useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), renderAnnounceText = _$eyrYI$useState[0], setRenderAnnounceText = _$eyrYI$useState[1];
    var _$eyrYI$useState1 = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), isAnnounced = _$eyrYI$useState1[0], setIsAnnounced = _$eyrYI$useState1[1]; // render text content in the next frame to ensure toast is announced in NVDA
    $1054c53496897b1c$var$$054eb8030ebde76e$var$useNextFrame(function() {
        return setRenderAnnounceText(true);
    }); // cleanup after announcing
    (0, $3aC2T.useEffect)(function() {
        var timer = window.setTimeout(function() {
            return setIsAnnounced(true);
        }, 1000);
        return function() {
            return window.clearTimeout(timer);
        };
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $3aC2T.createElement)((0, $fd81f363624b1018$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $3aC2T.createElement)((0, $2fb6311364b90287$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $3aC2T.createElement)((0, $3aC2T.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
var $1054c53496897b1c$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, titleProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$16d42d7c29b95a4, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
var $1054c53496897b1c$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, descriptionProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$ecddd96c53621d9a, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
var $1054c53496897b1c$export$3019feecfda683d2 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var altText = props.altText, actionProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "altText"
    ]);
    if (!altText) return null;
    return /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$export$811e70f61c205839, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$1054c53496897b1c$export$3019feecfda683d2.propTypes = {
    altText: function(props) {
        if (!props.altText) return new Error("Missing prop `altText` expected on `".concat($1054c53496897b1c$var$$054eb8030ebde76e$var$ACTION_NAME, "`"));
        return null;
    }
};
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$3019feecfda683d2, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ var $1054c53496897b1c$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
var $1054c53496897b1c$export$811e70f61c205839 = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, closeProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast"
    ]);
    var interactiveContext = $1054c53496897b1c$var$$054eb8030ebde76e$var$useToastInteractiveContext($1054c53496897b1c$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $3aC2T.createElement)($1054c53496897b1c$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).button, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $0bcc6b3945dce3a7$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($1054c53496897b1c$export$811e70f61c205839, {
    displayName: $1054c53496897b1c$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ var $1054c53496897b1c$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $3aC2T.forwardRef)(function(props, forwardedRef) {
    var __scopeToast = props.__scopeToast, altText = props.altText, announceExcludeProps = (0, $08757aa37edf87c6$export$69fdd232f62cde60)(props, [
        "__scopeToast",
        "altText"
    ]);
    return /*#__PURE__*/ (0, $3aC2T.createElement)((0, $9ce0b5db9b85dbae$export$250ffa63cdc0d034).div, (0, $2641cb1ee5dd360d$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $1054c53496897b1c$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    var textContent = [];
    var childNodes = Array.from(container.childNodes);
    childNodes.forEach(function(node) {
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($1054c53496897b1c$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            var isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            var isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                var _textContent;
                if (isExcluded) {
                    var altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else (_textContent = textContent).push.apply(_textContent, (0, $dHvbf._)($1054c53496897b1c$var$$054eb8030ebde76e$var$getAnnounceTextContent(node)));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $1054c53496897b1c$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, param) {
    var discrete = param.discrete;
    var currentTarget = detail.originalEvent.currentTarget;
    var event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $9ce0b5db9b85dbae$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
var $1054c53496897b1c$var$$054eb8030ebde76e$var$isDeltaInDirection = function(delta, direction) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var deltaX = Math.abs(delta.x);
    var deltaY = Math.abs(delta.y);
    var isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $1054c53496897b1c$var$$054eb8030ebde76e$var$useNextFrame() {
    var callback = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {};
    var fn = (0, $99a6ed5a8631b664$export$25bec8c6f54ee79a)(callback);
    (0, $87c460e54a6a0a0a$export$e5c5a5f917a5871c)(function() {
        var raf1 = 0;
        var raf2 = 0;
        raf1 = window.requestAnimationFrame(function() {
            return raf2 = window.requestAnimationFrame(fn);
        });
        return function() {
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $1054c53496897b1c$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $1054c53496897b1c$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    var nodes = [];
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $1054c53496897b1c$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    var previouslyFocusedElement = document.activeElement;
    return candidates.some(function(candidate) {
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
var $1054c53496897b1c$export$2881499e37b75b9a = $1054c53496897b1c$export$f5d03d415824e0e;
var $1054c53496897b1c$export$d5c6c08dc2d3ca7 = $1054c53496897b1c$export$6192c2425ecfd989;
var $1054c53496897b1c$export$be92b6f5f03c0fe9 = $1054c53496897b1c$export$8d8dc7d5f743331b;
var $1054c53496897b1c$export$f99233281efd08a0 = $1054c53496897b1c$export$16d42d7c29b95a4;
var $1054c53496897b1c$export$393edc798c47379d = $1054c53496897b1c$export$ecddd96c53621d9a;
var $1054c53496897b1c$export$e19cd5f9376f8cee = $1054c53496897b1c$export$3019feecfda683d2;
var $1054c53496897b1c$export$f39c2d165cd861fe = $1054c53496897b1c$export$811e70f61c205839;


var $e1c951943d92a51d$var$ItemList = function(param) {
    var items = param.items;
    // console.log(items);
    var styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-white shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var timerRef = (0, $3aC2T.useRef)(0);
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)("Default Title"), 2), toastTitle = _useState1[0], setToastTitle = _useState1[1];
    (0, $3aC2T.useEffect)(function() {
        return function() {
            return clearTimeout(timerRef.current);
        };
    }, []);
    //dispatch is an action
    var dispatch = (0, $c9b06aa5b40d17ee$export$8ad76b76a4c905f8)();
    // onClick of Add Button
    var handleAddItem = function(item) {
        // Dispatch an action
        dispatch((0, $a0cc13637f716510$export$fb9705de59d96855)(item));
        setOpen(false);
        setToastTitle("Added " + item.card.info.name);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(function() {
            setOpen(true);
        }, 100);
    };
    return /*#__PURE__*/ (0, $esXub.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$2881499e37b75b9a, {
                swipeDirection: "right",
                duration: 1000,
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "border-b-2 border-gray-200 my-4 pb-5 flex",
                        "data-testid": "foodItem",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                className: "w-1/4 pl-6",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                        className: "absolute",
                                        children: /*#__PURE__*/ (0, $esXub.jsx)("button", {
                                            className: " bg-white text-green-600 px-5 py-1 border-gray-300 border-2 rounded-md ml-6 mt-20 hover:bg-green-200 hover:text-black",
                                            onClick: function() {
                                                return handleAddItem(item);
                                            },
                                            children: "Add +"
                                        })
                                    }),
                                    item.card.info.imageId ? /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        className: "w-36 h-28 rounded-lg",
                                        src: (0, $8b2e38a7724326b9$export$31adfacaf07ffe63) + item.card.info.imageId,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                        className: "text-center w-36 h-28",
                                        children: "No Image"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                className: "w-3/4",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("span", {
                                        className: "font-medium",
                                        children: item.card.info.name
                                    }),
                                    item.card.info.itemAttribute.vegClassifier === "VEG" ? /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($012467c92d666826$exports))),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d009e9898e6b53f$exports))),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("p", {
                                        children: [
                                            "\u20B9",
                                            (item.card.info.price ? item.card.info.price : item.card.info.defaultPrice) / 100
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                        className: "text-xs text-gray-500",
                                        children: item.card.info.description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$be92b6f5f03c0fe9, {
                        className: styles.rootStyle,
                        open: open,
                        onOpenChange: setOpen,
                        type: "background",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f99233281efd08a0, {
                                className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px] truncate w-52",
                                children: toastTitle
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f39c2d165cd861fe, {
                                className: styles.closeButtonStyle,
                                children: "OK"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$d5c6c08dc2d3ca7, {
                        className: styles.viewPortStyle
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $e1c951943d92a51d$export$2e2bcd8739ae039 = $e1c951943d92a51d$var$ItemList;


var $841fe97f9b1714fe$var$ResCategory = function(param) {
    var data = param.data, showItems = param.showItems, indexCbFun = param.indexCbFun, index = param.index;
    var _data_card;
    var _ref = data === null || data === void 0 ? void 0 : (_data_card = data.card) === null || _data_card === void 0 ? void 0 : _data_card.card, title = _ref.title, itemCards = _ref.itemCards;
    console.log(data);
    //This state var is tracking click of category
    // false- by default all are collapsed
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), click = _useState[0], setClick = _useState[1];
    var handleClick = function() {
        // toggling clicks
        //1st click set to true shows items, second click set to false hides items
        setClick(!click);
        indexCbFun();
    };
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "w-8/12 my-6 py-1 shadow-xl mx-auto px-2 rounded-lg bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "flex justify-between items-center cursor-pointer ",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("span", {
                        className: "font-bold text-2xl p-2",
                        children: [
                            title,
                            " (",
                            itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)("span", {
                        className: "mr-6",
                        children: /*#__PURE__*/ (0, $esXub.jsx)("img", {
                            // src={ARROW_DOWN}
                            //During Testing
                            src: "https://img.icons8.com/ios/30/expand-arrow--v1.png",
                            alt: "arrow-down"
                        })
                    })
                ]
            }),
            click && showItems && /*#__PURE__*/ (0, $esXub.jsx)((0, $e1c951943d92a51d$export$2e2bcd8739ae039), {
                items: itemCards
            })
        ]
    });
};
var $841fe97f9b1714fe$export$2e2bcd8739ae039 = $841fe97f9b1714fe$var$ResCategory;


parcelRequire("7bnAA");
var $cd4a6c0894e3aed0$var$ResMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_1;
    // const [resInfo, setResInfo] = useState(null);
    var resId = (0, $7aa78ce6d363d479$export$99eaa27ddbbb95ef)().resId;
    // const params = useParams();
    //using custom Hook which gives data using resId
    var resInfo = (0, $f7b586262587f0c1$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(0), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    // const {loggedInUser} = useContext(UserContext)
    if (resInfo === null) return /*#__PURE__*/ (0, $esXub.jsx)((0, $31614b666dbabba2$export$2e2bcd8739ae039), {});
    console.log(resInfo);
    //As per the API 0th element of array contains the restaurant name
    var _ref = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info, name = _ref.name, avgRating = _ref.avgRating, cuisines = _ref.cuisines, areaName = _ref.areaName, costForTwoMessage = _ref.costForTwoMessage;
    console.log(name, avgRating, cuisines, areaName, costForTwoMessage);
    //As per the API 2nd element of array contains the category and dishes
    // Getting Categories like Recommended from the array. This string signifes category "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[4]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_1.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return (c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    console.log(categories[0]);
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        className: "mx-24",
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "resDetails flex gap-24 mt-10 mx-auto justify-center ",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("h1", {
                                className: "font-bold text-3xl",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                children: areaName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                children: cuisines.join(", ")
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)("p", {
                                children: [
                                    avgRating,
                                    "  \u2B50"
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                children: costForTwoMessage
                            })
                        ]
                    })
                ]
            }),
            categories.map(function(c, index) {
                return /*#__PURE__*/ (0, $esXub.jsx)((0, $841fe97f9b1714fe$export$2e2bcd8739ae039), {
                    data: c,
                    showItems: index === showIndex ? true : false,
                    indexCbFun: function() {
                        return setShowIndex(index);
                    },
                    index: index
                }, c.card.card.title);
            })
        ]
    });
};
var $cd4a6c0894e3aed0$export$2e2bcd8739ae039 = $cd4a6c0894e3aed0$var$ResMenu;




var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");




var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");






var $3aC2T = parcelRequire("3aC2T");

var $41beb6c7a2286b4b$var$CartItemList = function(param) {
    var items = param.items;
    var styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-slate-50 shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    //RadixUI
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var timerRef = (0, $3aC2T.useRef)(0);
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)("Default Title"), 2), toastTitle = _useState1[0], setToastTitle = _useState1[1];
    (0, $3aC2T.useEffect)(function() {
        return function() {
            return clearTimeout(timerRef.current);
        };
    }, []);
    var dispatch = (0, $c9b06aa5b40d17ee$export$8ad76b76a4c905f8)();
    var handleRemoveItem = function(item) {
        dispatch((0, $a0cc13637f716510$export$fe2d9b4e03920b4c)(item));
        //RadixUI
        setOpen(false);
        setToastTitle("Removed " + item.card.info.name);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(function() {
            setOpen(true);
        }, 100);
    };
    return /*#__PURE__*/ (0, $esXub.jsx)("div", {
        children: items.map(function(item) {
            return /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$2881499e37b75b9a, {
                swipeDirection: "right",
                duration: 1000,
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "border-b-2 border-gray-200 my-4 pb-5 flex",
                        "data-testid": "cartItem",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                className: " px-6",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                        className: "absolute",
                                        children: /*#__PURE__*/ (0, $esXub.jsx)("button", {
                                            className: " bg-white text-red-500 px-3 py-1 border-gray-300 border-2 rounded-md mx-3 mt-20 hover:bg-green-200",
                                            onClick: function() {
                                                return handleRemoveItem(item);
                                            },
                                            "data-testid": "removeButton",
                                            children: "Remove"
                                        })
                                    }),
                                    item.card.info.imageId ? /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        className: "w-36 h-28 rounded-lg",
                                        src: (0, $8b2e38a7724326b9$export$31adfacaf07ffe63) + item.card.info.imageId,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                        className: "text-center w-36 h-28",
                                        children: "No Image"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("span", {
                                        className: "font-medium",
                                        children: item.card.info.name
                                    }),
                                    item.card.info.itemAttribute.vegClassifier === "VEG" ? /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($012467c92d666826$exports))),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $esXub.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3d009e9898e6b53f$exports))),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("p", {
                                        children: [
                                            "\u20B9",
                                            (item.card.info.price ? item.card.info.price : item.card.info.defaultPrice) / 100
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, item.card.info.id),
                    /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$be92b6f5f03c0fe9, {
                        className: styles.rootStyle,
                        open: open,
                        onOpenChange: setOpen,
                        type: "background",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f99233281efd08a0, {
                                className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px] truncate w-52",
                                children: toastTitle
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f39c2d165cd861fe, {
                                className: styles.closeButtonStyle,
                                children: "OK"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$d5c6c08dc2d3ca7, {
                        className: styles.viewPortStyle
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $41beb6c7a2286b4b$export$2e2bcd8739ae039 = $41beb6c7a2286b4b$var$CartItemList;



var $3aC2T = parcelRequire("3aC2T");

var $bb72352e30aecb41$var$Cart = function() {
    var cartItems = (0, $c9b06aa5b40d17ee$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    var styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-slate-50 shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    //RadixUI
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var timerRef = (0, $3aC2T.useRef)(0);
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)("Default Title"), 2), toastTitle = _useState1[0], setToastTitle = _useState1[1];
    (0, $3aC2T.useEffect)(function() {
        return function() {
            return clearTimeout(timerRef.current);
        };
    }, []);
    var dispatch = (0, $c9b06aa5b40d17ee$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $a0cc13637f716510$export$810121176e3e3671)());
        //RadixUI
        setOpen(false);
        cartItems.length !== 0 ? setToastTitle("Cart Cleared") : setToastTitle("Nothing to clear");
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(function() {
            setOpen(true);
        }, 100);
    };
    var itemTotal = cartItems.reduce(function(acc, curr) {
        return acc + (curr.card.info.price ? curr.card.info.price : curr.card.info.defaultPrice);
    }, 0);
    var gst = parseFloat((itemTotal / 100 * 0.12).toFixed(2));
    var totalPrice = itemTotal / 100 + gst + 40 + 3;
    return /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$2881499e37b75b9a, {
        swipeDirection: "right",
        duration: 1000,
        children: [
            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "my-4 mx-24 px-48",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "my-8 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsxs)("h2", {
                                className: "text-3xl font-semibold ",
                                children: [
                                    "Your Cart (",
                                    cartItems.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("button", {
                                className: "w-32 py-2 border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-red-100",
                                onClick: handleClearCart,
                                children: "Clear Cart"
                            })
                        ]
                    }),
                    cartItems.length === 0 ? /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "p-2 flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("h2", {
                                className: "text-2xl",
                                children: "Oops! Your Cart is as Empty as a Cookie Jar at Midnight \uD83C\uDF6A"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                className: "text-xl",
                                children: "Looks like you haven't sprinkled any goodies into your cart yet! How about picking some delicious treats from our menu?"
                            }),
                            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $esXub.jsx)("button", {
                                        className: "w-36 m-4 p-2 text-xl border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-green-100",
                                        children: "Let's Fill It Up! \uD83D\uDE0B"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                        className: "gap-4 flex",
                        children: [
                            /*#__PURE__*/ (0, $esXub.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $esXub.jsx)((0, $41beb6c7a2286b4b$export$2e2bcd8739ae039), {
                                    items: cartItems
                                })
                            }),
                            /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                className: " border-l-2 p-4 w-1/3 ",
                                children: [
                                    /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                        className: "font-semibold  text-2xl",
                                        children: "Bill Details"
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "Item Total"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: itemTotal / 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "Delivery Fee"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "40"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "Platform fee"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                        className: "flex justify-between border-b-2 p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "GST(12%)"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: gst
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                                        className: "flex justify-between border-b-2 p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $esXub.jsx)("p", {
                                                children: "To Pay"
                                            }),
                                            /*#__PURE__*/ (0, $esXub.jsxs)("p", {
                                                children: [
                                                    "\u20B9 ",
                                                    totalPrice
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$be92b6f5f03c0fe9, {
                className: styles.rootStyle,
                open: open,
                onOpenChange: setOpen,
                type: "background",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f99233281efd08a0, {
                        className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px]",
                        children: toastTitle
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$f39c2d165cd861fe, {
                        className: styles.closeButtonStyle,
                        children: "OK"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$d5c6c08dc2d3ca7, {
                className: styles.viewPortStyle
            })
        ]
    });
};
var $bb72352e30aecb41$export$2e2bcd8739ae039 = $bb72352e30aecb41$var$Cart;



var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");
function $204cd0e1d45ed33b$var$Panel(param) {
    var title = param.title, children = param.children, isActive = param.isActive, onShow = param.onShow;
    return /*#__PURE__*/ (0, $esXub.jsxs)("section", {
        className: "panel border-2 border-black",
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("h3", {
                children: title
            }),
            isActive ? /*#__PURE__*/ (0, $esXub.jsx)("p", {
                children: children
            }) : /*#__PURE__*/ (0, $esXub.jsx)("button", {
                className: "p-2 border-2 border-black rounded-lg",
                onClick: onShow,
                children: "Show"
            })
        ]
    });
}
function $204cd0e1d45ed33b$export$2e2bcd8739ae039() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(0), 2), activeIndex = _useState[0], setActiveIndex = _useState[1];
    return /*#__PURE__*/ (0, $esXub.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("h2", {
                children: "Almaty, Kazakhstan"
            }),
            /*#__PURE__*/ (0, $esXub.jsx)($204cd0e1d45ed33b$var$Panel, {
                title: "About",
                isActive: activeIndex === 0,
                onShow: function() {
                    return setActiveIndex(0);
                },
                children: "With a population of about 2 million, Almaty is Kazakhstan's largest city. From 1929 to 1997, it was its capital city."
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)($204cd0e1d45ed33b$var$Panel, {
                title: "Etymology",
                isActive: activeIndex === 1,
                onShow: function() {
                    return setActiveIndex(1);
                },
                children: [
                    "The name comes from ",
                    /*#__PURE__*/ (0, $esXub.jsx)("span", {
                        lang: "kk-KZ",
                        children: "\u0430\u043B\u043C\u0430"
                    }),
                    ', the Kazakh word for "apple" and is often translated as "full of apples". In fact, the region surrounding Almaty is thought to be the ancestral home of the apple, and the wild ',
                    /*#__PURE__*/ (0, $esXub.jsx)("i", {
                        lang: "la",
                        children: "Malus sieversii"
                    }),
                    " is considered a likely candidate for the ancestor of the modern domestic apple."
                ]
            })
        ]
    });
}



var $7bnAA = parcelRequire("7bnAA");

var $aSMts = parcelRequire("aSMts");

var $esXub = parcelRequire("esXub");

var $3aC2T = parcelRequire("3aC2T");

var $e2549e3e0a3259d4$var$Testing = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(false), 2), open = _useState[0], setOpen = _useState[1];
    var timerRef = (0, $3aC2T.useRef)(0);
    var _useState1 = (0, $aSMts._)((0, $3aC2T.useState)("Default Title"), 2), toastTitle = _useState1[0], setToastTitle = _useState1[1];
    (0, $3aC2T.useEffect)(function() {
        return function() {
            return clearTimeout(timerRef.current);
        };
    }, []);
    var myBtn = "w-36 m-4 p-2 text-xl border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-green-100";
    return /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$2881499e37b75b9a, {
        swipeDirection: "right",
        duration: 2000,
        children: [
            /*#__PURE__*/ (0, $esXub.jsx)("button", {
                className: myBtn,
                onClick: function() {
                    setOpen(false);
                    setToastTitle("hiiiii");
                    window.clearTimeout(timerRef.current);
                    timerRef.current = window.setTimeout(function() {
                        setOpen(true);
                    }, 100);
                },
                children: "Add +"
            }),
            /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$be92b6f5f03c0fe9, {
                className: "bg-white rounded-md shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut",
                open: open,
                v: true,
                onOpenChange: setOpen,
                children: [
                    /*#__PURE__*/ (0, $esXub.jsxs)($1054c53496897b1c$export$f99233281efd08a0, {
                        className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px]",
                        children: [
                            toastTitle,
                            "        "
                        ]
                    }),
                    /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$e19cd5f9376f8cee, {
                        className: "[grid-area:_action]",
                        asChild: true,
                        altText: "Goto schedule to undo",
                        children: /*#__PURE__*/ (0, $esXub.jsx)("button", {
                            className: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
                            children: "OK"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $esXub.jsx)($1054c53496897b1c$export$d5c6c08dc2d3ca7, {
                className: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
            })
        ]
    });
};
var $e2549e3e0a3259d4$export$2e2bcd8739ae039 = $e2549e3e0a3259d4$var$Testing;





var $92902c36f5fb8f2e$var$appStore = (0, $dd193db6d1f94c14$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $a0cc13637f716510$export$2e2bcd8739ae039)
    }
});
var $92902c36f5fb8f2e$export$2e2bcd8739ae039 = $92902c36f5fb8f2e$var$appStore;



var $6c74cc72a0a2f69a$var$Grocery = /*#__PURE__*/ (0, $3aC2T.lazy)(function() {
    return (parcelRequire("aVp1z"));
});

var $6c74cc72a0a2f69a$var$About = /*#__PURE__*/ (0, $3aC2T.lazy)(function() {
    return (parcelRequire("lLa62"));
});
var $6c74cc72a0a2f69a$var$AppLayout = function() {
    var _useState = (0, $aSMts._)((0, $3aC2T.useState)(), 2), userName = _useState[0], setUserName = _useState[1];
    //auhthentication
    (0, $3aC2T.useEffect)(function() {
        //API call and send Username and Password get result data
        var data = {
            name: "Default User"
        };
        setUserName(data.name);
    }, []);
    // console.log(userName);
    return /*#__PURE__*/ (0, $esXub.jsx)((0, $c9b06aa5b40d17ee$export$2881499e37b75b9a), {
        store: (0, $92902c36f5fb8f2e$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $7bnAA.default).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $esXub.jsxs)("div", {
                className: "font-poppins ",
                children: [
                    /*#__PURE__*/ (0, $esXub.jsx)((0, $b7407642b5bd3f78$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $esXub.jsx)("div", {
                        children: /*#__PURE__*/ (0, $esXub.jsx)((0, $7aa78ce6d363d479$export$910ae8079b2c2852), {})
                    })
                ]
            })
        })
    });
};
var $6c74cc72a0a2f69a$var$appRouter = (0, $453a12ddee1c3125$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $a2937e22c1ddf1d8$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $3aC2T.Suspense), {
                    fallback: /*#__PURE__*/ (0, $esXub.jsx)((0, $4fcb5d63c47ef7d3$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$About, {})
                })
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $1e75e520e4c41f31$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $3aC2T.Suspense), {
                    fallback: /*#__PURE__*/ (0, $esXub.jsx)((0, $4fcb5d63c47ef7d3$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $esXub.jsx)($6c74cc72a0a2f69a$var$Grocery, {})
                })
            },
            {
                //colon represents resId is Dynamic
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $cd4a6c0894e3aed0$export$2e2bcd8739ae039), {})
            },
            {
                path: "/accordion",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $204cd0e1d45ed33b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $bb72352e30aecb41$export$2e2bcd8739ae039), {})
            },
            {
                path: "/test",
                element: /*#__PURE__*/ (0, $esXub.jsx)((0, $e2549e3e0a3259d4$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $esXub.jsx)((0, $94229c684d67f149$export$2e2bcd8739ae039), {})
    }
]);
var $6c74cc72a0a2f69a$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($931d92b7390d92a2$exports))).createRoot(document.getElementById("root"));
// root.render(<AppLayout />);
$6c74cc72a0a2f69a$var$root.render(/*#__PURE__*/ (0, $esXub.jsx)((0, $453a12ddee1c3125$export$323e4fc2fa4753fb), {
    router: $6c74cc72a0a2f69a$var$appRouter
}));

})();
//# sourceMappingURL=index.a25f9351.js.map
